export const defaultResources = {
  en: {
    common: {
      // Header & Quick Settings
      'header.quickSettings': 'Quick Settings',
      'header.theme': 'Theme',
      'header.translationMode': 'Translation Mode',
      'header.exitTranslationMode': 'Exit Translation Mode',
      'header.notifications': 'Notifications',
      'header.erpNotifications': 'ERP Notifications',
      'header.testNotifications': 'Test Notifications',
      'header.adminPanel': 'Admin Panel',
      'header.testerArea': 'Tester Area',
      'header.userMenu': 'User Menu',
      'theme.light': 'Light',
      'theme.dark': 'Dark',
      'theme.system': 'Auto',
      'onboarding.gettingStarted': 'Getting Started',
      'onboarding.tooltip': 'Take a guided tour of the app',
      'user.inviteUser': 'Invite User',

      // Changelog
      'changelog.title': 'Changelog',
      'changelog.subtitle': 'See what\'s new and improved',
      'changelog.loading': 'Loading changelog...',
      'changelog.empty': 'No changelogs available yet.',
      'changelog.newRelease': '{{count}} changes in this release',
      'changelog.viewAll': 'View all changelogs',

      // Notifications
      'notifications.markAllRead': 'Mark all as read',
      'notifications.clearRead': 'Clear read',
      'notifications.loading': 'Loading notifications...',
      'notifications.empty': 'No notifications',
      
      // Workspace
      'workspace.switchWorkspace': 'Switch Workspace',
      'workspace.switching': 'Switching workspace...',
      'workspace.switchingTo': 'Loading data for {{name}}',
      'workspace.workspaces': 'Workspaces',
      'workspace.role.owner': 'Owner',
      'workspace.role.admin': 'Admin',
      'workspace.role.editor': 'Editor',
      'workspace.role.viewer': 'Viewer',
      'workspace.noPermission': 'You do not have permission to perform this action',
      'workspace.members': 'Members',
      'workspace.members.active': 'Active Members',
      'workspace.members.count': 'member(s)',
      'workspace.members.description': 'Manage who has access to this workspace.',
      'workspace.members.empty': 'No members found.',
      'workspace.members.roleUpdated': 'Member role updated',
      'workspace.members.removed': 'Member removed',
      'workspace.members.remove': 'Remove',
      'workspace.inviteMembers': 'Invite Members',
      'workspace.manageMembers': 'Manage Members',
      'workspace.invite.title': 'Invite to Workspace',
      'workspace.invite.description': 'Invite someone to join your workspace.',
      'workspace.invite.role': 'Workspace Role',
      'workspace.invite.roleDescription': 'This determines what the user can do in this workspace.',
      'workspace.invite.message': 'Personal Message',
      'workspace.invite.messagePlaceholder': 'Add a personal message...',
      'workspace.invite.sending': 'Sending...',
      'workspace.invite.send': 'Send Invitation',
      'workspace.invite.sent': 'Invitation sent',
      'workspace.invite.alreadyInvited': 'This email has already been invited to this workspace',
      'workspace.invite.pending': 'Pending Invitations',
      'workspace.invite.expires': 'Expires',
      'workspace.invite.resend': 'Resend',
      'workspace.invite.resent': 'Invitation resent',
      'workspace.invite.revoke': 'Revoke',
      'workspace.invite.revoked': 'Invitation revoked',
      
      // Navigation - Custom Plan
      'nav.yourFeatures': 'Your Features',
      'nav.account': 'Account',
      'nav.dashboard': 'Dashboard',
      'nav.contracts': 'Contracts',
      'nav.allContracts': 'All Contracts',
      'nav.allContractsDesc': 'Browse and manage contracts',
      'nav.newContract': 'New Contract',
      'nav.newContractDesc': 'Create a new contract',
      'nav.categories': 'Categories',
      'nav.categoriesDesc': 'Organize contracts',
      'nav.services': 'Services',
      'nav.servicesDesc': 'Manage contract services',
      'nav.salesAnalytics': 'Sales Analytics',
      'nav.costOptimization': 'Cost Optimization',
      'nav.erpIntegration': 'ERP Integration',
      'nav.documentExtraction': 'Document Extraction',
      'nav.customFields': 'Custom Fields',
      'nav.tags': 'Tags',
      'tags.pageTitle': 'Contract Tags',
      'tags.pageDescription': 'Reusable labels you can attach to contracts to organise and filter them.',
      'tags.newTag': 'New tag',
      'tags.editTag': 'Edit tag',
      'tags.allTags': 'All tags',
      'tags.empty': 'No tags yet. Create your first tag to start organising contracts.',
      'contract.owner': 'Owner',
      'contract.ownerPlaceholder': 'Select owner',
      'contract.ownerDescription': 'Assign a responsible colleague from this workspace.',
      'contract.department': 'Department',
      'contract.departmentPlaceholder': 'Select department',
      'contract.departmentDescription': 'Organise the contract under a department.',
      'contract.noDepartments': 'No departments yet — create them under Departments',
      'contract.noMembers': 'No workspace members available',
      'contract.unassigned': 'Unassigned',
      'owner': 'Owner',
      'tags.name': 'Name',
      'tags.color': 'Color',
      'tags.deleteTitle': 'Delete this tag?',
      'tags.deleteDescription': 'It will be removed from all contracts it is attached to.',
      'contracts.fields.name': 'Contract Name',
      'contracts.fields.description': 'Description',
      'contracts.fields.tags': 'Tags',
      'duplicateContract': 'Duplicate contract',
      'duplicatingFromNotice': 'Duplicating from "{{name}}". Pick a new vendor below — all other details have been pre-filled and can be adjusted.',
      'nav.calendarView': 'Calendar',
      'nav.apiPortal': 'API Portal',
      'nav.settings': 'Settings',
      'nav.help': 'Help',
      'nav.subscriptionRequired': 'Subscription Required',
      'nav.choosePlan': 'Choose a Plan',
      'nav.getStarted': 'Get Started',
      'nav.documentation': 'Documentation',
      'nav.suppliers': 'Vendors',
      'nav.suppliersDesc': 'Manage your vendors and their contacts',

      // Suppliers
      'suppliers.title': 'Vendors',
      'suppliers.description': 'Manage your vendors and their contact persons.',
      'suppliers.addSupplier': 'Add Vendor',
      'suppliers.searchPlaceholder': 'Search vendors...',
      'suppliers.showInactive': 'Show inactive',
      'suppliers.noSuppliers': 'No vendors yet',
      'suppliers.noSuppliersDescription': 'Add your first vendor to get started.',
      'suppliers.name': 'Name',
      'suppliers.orgNumber': 'Org. Number',
      'suppliers.email': 'Email',
      'suppliers.phone': 'Phone',
      'suppliers.status': 'Status',
      'suppliers.active': 'Active',
      'suppliers.inactive': 'Inactive',
      'suppliers.activate': 'Activate',
      'suppliers.deactivate': 'Deactivate',
      'suppliers.activated': 'Vendor activated',
      'suppliers.deactivated': 'Vendor deactivated',
      'suppliers.deleted': 'Vendor deleted',
      'suppliers.deleteTitle': 'Delete Vendor',
      'suppliers.deleteDescription': 'Are you sure you want to delete this vendor? This action cannot be undone.',
      'suppliers.createTitle': 'Add New Vendor',
      'suppliers.createDescription': 'Fill in the details to create a new vendor.',
      'suppliers.created': 'Vendor created',
      'suppliers.updated': 'Vendor updated',
      'suppliers.save': 'Save Changes',
      'suppliers.create': 'Create Vendor',
      'suppliers.details': 'Details',
      'suppliers.contactPersons': 'Contact Persons',
      'suppliers.linkedContracts': 'Linked Contracts',
      'suppliers.notFound': 'Vendor not found',
      'suppliers.backToList': 'Back to Vendors',
      'suppliers.addContact': 'Add Contact',
      'suppliers.noContacts': 'No contact persons for this vendor.',
      'suppliers.contactCreated': 'Contact person created',
      'suppliers.contactUpdated': 'Contact person updated',
      'suppliers.contactDeleted': 'Contact person deleted',
      'suppliers.editContact': 'Edit Contact',
      'suppliers.deleteContact': 'Delete Contact',
      'suppliers.deleteContactConfirm': 'Are you sure you want to delete this contact person?',
      'suppliers.noContracts': 'No contracts linked to this vendor.',
      'suppliers.contractName': 'Contract',
      'suppliers.cost': 'Cost',
      'suppliers.signedDate': 'Signed Date',
      'suppliers.expiryDate': 'Expiry Date',
      'suppliers.namePlaceholder': 'Enter vendor name',
      'suppliers.orgNumberPlaceholder': 'Enter organisation number',
      'suppliers.emailPlaceholder': 'Enter email address',
      'suppliers.phonePlaceholder': 'Enter phone number',
      'suppliers.addressPlaceholder': 'Enter address',
      'suppliers.cityPlaceholder': 'Enter city',
      'suppliers.postalCodePlaceholder': 'Enter postal code',
      'suppliers.countryPlaceholder': 'Enter country',
      'suppliers.notesPlaceholder': 'Add notes about this vendor...',
      'suppliers.address': 'Address',
      'suppliers.city': 'City',
      'suppliers.postalCode': 'Postal Code',
      'suppliers.country': 'Country',
      'suppliers.role': 'Role',
      'suppliers.website': 'Website',
      'suppliers.notes': 'Notes',
      'suppliers.importFromUrl': 'Import from URL',
      'suppliers.importFromUrlDesc': 'Enter a company website URL and we\'ll automatically extract their details using AI.',
      'suppliers.websiteUrl': 'Website URL',
      'suppliers.extract': 'Extract',
      'suppliers.detailsExtracted': 'Company details extracted! Review and edit before saving.',
      'suppliers.contactPersonFound': 'Contact person found (can be added later):',
      'suppliers.createSupplier': 'Create Vendor',
      'suppliers.urlRequired': 'Please enter a website URL',
      'suppliers.nameRequired': 'Vendor name is required',
      'supplierSearch.placeholder': 'Search vendors or enter name...',
      'supplierSearch.searching': 'Searching vendors...',
      'supplierSearch.existingSuppliers': 'Your vendors',
      'supplierSearch.orgNr': 'Org.nr',
      'supplierSearch.registered': 'Registered',
      'supplierSearch.createNew': 'Create new vendor',
      'supplierSearch.addToRegister': 'add to your vendor register',
      'supplierSearch.noResults': 'No vendors found',
      'supplierSearch.supplierCreated': 'Vendor created successfully',
      'supplierSearch.createNewSupplier': 'Create New Vendor',
      'supplierSearch.createNewSupplierDesc': 'Add a new vendor to your register. You can add more details later.',
      'supplierSearch.createAndSelect': 'Create & Select',
      'nav.documentationDesc': 'Learn how to use the platform',
      
      // Subscription access messages
      'subscription.accessRestricted': 'Please complete your subscription to access all features.',
      'subscription.paymentRequired': 'Payment required to access this feature.',
      'subscription.upgradeRequired': 'Upgrade your plan to access this feature.',
      
      // Legacy Navigation keys
      contracts: 'Contracts',
      categories: 'Categories',
      contacts: 'Contacts',
      contractTypes: 'Contract Types',
      currencies: 'Currencies',
      
      // Actions
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create',
      update: 'Update',
      continue: 'Continue',

      // Admin impersonation
      'admin.impersonate.title': 'Impersonate User',
      'admin.impersonate.confirmation': 'You are about to log in as {{name}} in a new tab. This action will be logged for audit purposes.',
      'admin.impersonate.warning1': 'A new browser tab will open with a support session',
      'admin.impersonate.warning2': 'All actions during impersonation are logged',
      'admin.impersonate.warning3': 'Your admin session in this tab will remain active',
      'admin.impersonate.confirm': 'Open Support Session',
      'admin.impersonate.error': 'Impersonation Error',
      'admin.impersonate.noSession': 'No active admin session found.',
      'admin.impersonate.failed': 'Failed to start impersonation session.',
      'admin.impersonate.success': 'Support Session Started',
      'admin.impersonate.openedTab': 'A new tab has been opened as {{name}}.',
      'admin.impersonate.bannerText': 'Support session — viewing as {{name}} ({{email}})',
      'admin.impersonate.endSession': 'End Session',
      'admin.impersonate.resetDefaults': 'Reset to Defaults',
      'admin.impersonate.resetSuccess': 'User Reset Complete',
      'admin.impersonate.resetSuccessDesc': 'All data has been cleared and demo data has been re-populated.',
      'admin.impersonate.resetError': 'Failed to reset user data',
      assign: 'Assign',
      updating: 'Updating...',
      createAndAssign: 'Create & Assign',
      skip: 'Skip',
      nextStep: 'Next Step',
      
      // States
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      saving: 'Saving...',
      saveSettings: 'Save Settings',
      more: 'more',
      month: 'month',
      expires: 'Expires',
      
      // 404 Page
      pageNotFound: 'Page Not Found',
      pageNotFoundDesc: 'Sorry, the page you are looking for does not exist or has been moved.',
      backToHome: 'Back to Home',
      
      // Contract related
      supplier: 'Vendor',
      expiryDate: 'Expiry Date',
      signedDate: 'Signed Date',
      'contractDates.startDate': 'Start Date',
      'contractDates.signedDateDesc': 'The date the contract was signed',
      'contractDates.startDateDesc': 'When the contract term begins (defaults to signed date if not set)',
      'contractDates.sameAsSigned': 'Same as signed date',
      category: 'Category',
      type: 'Type',
      importance: 'Importance',
      expectedCost: 'Expected Cost',
      expectedIncome: 'Expected Income',
      value: 'Value',
      currency: 'Currency',
      actions: 'Actions',
      
      // Currency modal
      editCurrency: 'Edit Currency',
      addNewCurrency: 'Add New Currency',
      updateCurrencyDetails: 'Update currency details',
      addNewCurrencyDescription: 'Add a new currency for your contracts',
      selectFromList: 'Select from List',
      createManually: 'Create Manually',
      selectCurrencyFromList: 'Click on a currency to add it to your list of available currencies.',
      currencyRateDisclaimer: 'Currency exchange rates are approximate and updated periodically. Contract values shown in different currencies are estimates and may not reflect exact rates at the time of payment.',
      added: 'Added',
      searchCurrencies: 'Search currencies...',
      noCurrenciesMatchSearch: 'No currencies match your search',
      defaultCurrencyUpdated: 'Default currency updated successfully',
      failedToUpdateDefaultCurrency: 'Failed to update default currency',
      
      // Category pages
      createNewCategory: 'Create New Category',
      editCategory: 'Edit Category',
      addNewCategory: 'Add a new category for organizing contracts',
      updateCategoryDetails: 'Update category details',
      categoryName: 'Category Name',
      enterCategoryName: 'Enter category name',
      enterDescription: 'Enter a description (optional)',
      createCategory: 'Create Category',
      updateCategory: 'Update Category',
      categoryCreated: 'Category created successfully',
      categoryUpdated: 'Category updated successfully',
      categoryDeleted: 'Category deleted successfully',
      
      status: 'Status',
      select: 'Select',
      selectCategory: 'Select Category',
      selectContractType: 'Select Contract Type',
      errorLoadingContract: 'Error Loading Contract',
      contractNotFound: 'The contract you are looking for could not be found.',
      backToContracts: 'Back to Contracts',
      contractType: 'Contract Type',
      paymentFrequency: 'Payment Frequency',
      oneTime: 'One time',
      erpSource: 'ERP',
      erpClient: 'ERP Client',
      importedFrom: 'Imported from',
      addAnother: 'Add Another',
      
      // Contract table UI elements
      searchContracts: 'Search contracts...',
      resetFilters: 'Reset Filters',
      settings: 'Settings',
      updateAllRates: 'Update All Rates',
      newContract: 'New Contract',
      createNewContract: 'Create New Contract',
      editContract: 'Edit Contract',
      addNewContract: 'Add a new contract to your portfolio',
      updateContractDetails: 'Update contract details',
      allContracts: 'All Contracts',
      showingXtoYofZ: 'Showing {{start}} to {{end}} of {{total}}',
      totalCost: 'Total cost: ',
      totalCostInCurrency: 'Total cost in {{currency}}: ',
      totalIncome: 'Total income: ',
      totalIncomeInCurrency: 'Total income in {{currency}}: ',
      result: 'Result: ',
      resultInCurrency: 'Result in {{currency}}: ',
      reviewExpired: 'Review Expired',
      showDisabled: 'Show Disabled',
      hideDisabled: 'Hide Disabled',
      reviewExpiredContracts: 'Review Expired Contracts',
      reviewExpiredContractsDescription: 'Review and decide what to do with expired or soon-to-expire contracts',
      selectNewExpiryDate: 'Select New Expiry Date',
      renew: 'Renew',
      renewFor: 'Renew for',
      disableContract: 'Disable Contract',
      expired: 'Expired',
      expiringSoon: 'Expiring Soon',
      daysAgo: 'days ago',
      daysLeft: 'days left',
      expiresIn: 'Expires in {{days}} days',
      contractRenewed: 'Contract renewed successfully',
      contractDisabled: 'Contract Disabled',
      noExpiredContractsToReview: 'No expired or expiring contracts to review',
      pleaseSelectNewExpiryDate: 'Please select a new expiry date',
      failedToRenewContract: 'Failed to renew contract',
      failedToDisableContract: 'Failed to disable contract',
      autoRenewing: 'Auto-renewing',
      enableContract: 'Enable Contract',
      contractEnabled: 'Contract enabled successfully',
      failedToEnableContract: 'Failed to enable contract',
      contractDisabledDescription: 'This contract is currently disabled and hidden from the main contract list.',
      disabled: 'Disabled',
      renewContractConfirm: 'Create a new version of this contract for the next period? The current contract will be disabled.',
      previousVersion: 'Previous version',
      nextVersion: 'Next version',
      
      // Integration selection
      selectIntegration: 'Select Integration',
      selectIntegrationDescription: 'You have multiple {{erp}} integrations. Please select which one to use for expense detection.',
      unknownCompany: 'Unknown Company',
      unknownOrganization: 'Unknown Organization',

      // Admin section
      adminDashboard: 'Admin Dashboard',
      translations: 'Translations',
      manageTranslations: 'Manage Translations',
      
      // User Management
      users: 'Users',
      manageUsers: 'Manage Users',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userCreated: 'User Created',
      userUpdated: 'User Updated',
      userDeleted: 'User Deleted',
      roles: 'Roles',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      name: 'Name',
      
      // Profile page
      profile: 'Profile',
      yourInformation: 'Your Information',
      editPersonalInfo: 'Edit your personal information',
      profileUpdated: 'Profile updated successfully',
      saveChanges: 'Save Changes',
      goToSettings: 'Go to Settings',
      
      // Bug Reports
      bugReports: 'Bug Reports',
      manageBugReports: 'Manage Bug Reports',
      newBugReport: 'New Bug Report',
      bugReportDetails: 'Bug Report Details',
      statusChangeSuccess: 'Status Change Success',
      
      // Email Settings
      emailSettings: 'Email Settings',
      configureEmailSettings: 'Configure Email Settings',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUser: 'SMTP User',
      smtpPassword: 'SMTP Password',
      senderEmail: 'Sender Email',
      testEmail: 'Test Email',
      sendTestEmail: 'Send Test Email',
      testEmailSent: 'Test Email Sent',
      
      // System Settings
      systemSettings: 'System Settings',
      generalSettings: 'General Settings',
      defaultLanguage: 'Default Language',
      
      // User Settings Page
      settingsPage: {
        general: 'General',
        subscription: 'Subscription',
        appearance: 'Appearance',
        appearanceDescription: 'Customize how contracts are displayed throughout the application.',
        integrations: 'Integrations',
        advisors: 'Advisor Access',
        integrationsDescription: 'Configure external services and data providers for your account.',
        managePreferences: 'Manage your account settings and preferences.',
        importanceColors: {
          title: 'Contract Importance Colors',
          description: 'Customize the colors used to display contract importance levels (Very Low to Critical) throughout the application.'
        },
        statusColors: {
          title: 'Contract Status Colors',
          description: 'Customize the colors used to display contract status badges (Active, Expiring Soon, Expired, etc.) in contracts lists and tables.'
        },
        exchangeRate: {
          title: 'Currency Conversion',
          description: 'Configure which service to use for currency conversion rates between different currencies.'
        },
        companyRegister: {
          title: 'Company Register',
          description: 'Configure company lookup services for quick access to company information when adding contracts.',
          intro: 'Company registers help you quickly look up company information when adding contracts. Select which official company register you\'d like to use.',
          provider: 'Provider',
          selectProvider: 'Select a provider',
          none: 'None - No company lookups',
          requiresApiKey: 'This provider requires an API key',
          noApiKey: 'No API key required for this provider',
          apiKey: 'API Key',
          enterApiKey: 'Enter your API key',
          apiKeyHelp: 'You\'ll need to register for an API key from the provider\'s website.',
          savedSuccess: 'Company register settings saved successfully',
          savedError: 'Failed to save company register settings'
        }
      },
      
      // Status colors labels
      statusColors: {
        active: 'Active',
        expiringSoon: 'Expiring Soon',
        expired: 'Expired',
        autoRenewing: 'Auto-Renewing',
        renewed: 'Renewed'
      },
      
      // Features Settings
      featuresSettings: 'Features Settings',
      enableFeature: 'Enable Feature',
      disableFeature: 'Disable Feature',
      
      // Company Register Settings
      companyRegisterSettings: 'Company Register Settings',
      companyName: 'Company Name',
      companyAddress: 'Company Address',
      companyLogo: 'Company Logo',
      
      // Widget Designer
      widgetDesigner: 'Widget Designer',
      designYourWidgets: 'Design Your Widgets',
      addWidget: 'Add Widget',
      editWidget: 'Edit Widget',
      deleteWidget: 'Delete Widget',
      widgetName: 'Widget Name',
      widgetType: 'Widget Type',
      widgetData: 'Widget Data',
      
      // Seed Translations
      seedTranslations: 'Seed Translations',
      seedTranslationsFromDefaults: 'Seed Translations From Defaults',
      seedingTranslations: 'Seeding Translations',
      translationsSeeded: 'Translations Seeded',
      
      // Translations Manager
      manageApplicationTranslations: 'Manage Application Translations',
      addNewLanguage: 'Add New Language',
      languageCode: 'Language Code',
      addLanguage: 'Add Language',
      languageCodeHelp: 'Enter a 2-letter language code (e.g., en, es, fr)',
      localeExists: 'Locale {{locale}} already exists',
      localeAdded: 'Locale {{locale}} added',
      addNewTranslationKey: 'Add New Translation Key',
      translationKeyPlaceholder: 'Enter translation key',
      valueForLocale: 'Value for {{locale}}',
      addTranslationKey: 'Add Translation Key',
      translationKeyHelp: 'Enter a unique key for the translation',
      translationUpdated: 'Translation for "{{key}}" in "{{locale}}" updated successfully',
      invalidKey: 'Invalid key',
      invalidLocaleCode: 'Invalid locale code',
      selectLanguage: 'Select Language',
      searchTranslationKeys: 'Search Translation Keys',
      translationKey: 'Translation Key',
      translationValue: 'Value',
      noResults: 'No Results',
      syncingTranslations: 'Syncing Translations',
      translationsSynced: 'Translations Synced',
      errorSyncingTranslations: 'Error Syncing Translations',
      
      // Financial Forecast Widget
      forecast: {
        title: 'Financial Forecast',
        expenses: 'Expenses',
        income: 'Income',
        totalExpenses: 'Total Expenses',
        totalIncome: 'Total Income',
        noData: 'No forecast data available for the selected period',
        currencyNote: 'Values in your default currency',
        currencyTooltip: 'Contract amounts are converted to your default currency for display',
        periods: {
          quarter: 'Next Quarter',
          sixMonths: 'Next 6 Months',
          year: 'Next Year',
          twoYears: 'Next 2 Years'
        }
      },
      
      // Budget vs Actual Widget
      budget: {
        title: 'Budget vs Actual',
        totalBudget: 'Total Budget',
        actualSpend: 'Actual Spend',
        variance: 'Variance',
        status: 'Status',
        underBudget: 'Under Budget',
        overBudget: 'Over Budget',
        onTrack: 'On Track',
        noTripletexData: 'Connect contracts to Tripletex to see budget comparison',
        viewDetails: 'View All'
      },

      // Renewal Cost Prediction Widget
      renewal: {
        title: 'Renewal Cost Prediction',
        currentCost: 'Current Cost',
        predictedCost: 'Predicted Cost',
        difference: 'Difference',
        contractsWithPredictions: 'Contracts',
        noContracts: 'No contracts connected to Tripletex',
        stable: 'Stable',
        increasing: 'Increasing',
        decreasing: 'Decreasing',
        nextYear: 'next year'
      },
      
      // Contracts table UI elements
      manageYourContracts: 'Manage all your contracts in one place',
      areYouSure: 'Are you absolutely sure?',
      deleteContractsWarning: 'This action cannot be undone. This will permanently delete the selected contracts from our servers.',
      assignToGroup: 'Assign to Group',
      removeFromGroup: 'Remove from Group',
      tableSettings: 'Table Settings',
      configureContractsDisplay: 'Configure how the contracts are displayed',
      showGroupedContracts: 'Show Grouped Contracts',
      displayContractsInGroups: 'Display contracts in their assigned groups',
      groupContractsBy: 'Group contracts by',
      groupContractsByDescription: 'Choose how contracts are grouped in the overview',
      groupByNone: 'No grouping',
      groupByCustom: 'Custom groups',
      groupByVendor: 'Vendor',
      groupByType: 'Type',
      groupByCategory: 'Category',
      groupingPreferenceSaved: 'Grouping preference saved',
      columns: 'Columns',
      customizeColumns: 'Customize columns',
      selectOrCreateGroup: 'Select an existing group or create a new one to assign the selected contracts.',
      existingGroup: 'Existing Group',
      createNewGroup: 'Create New Group',
      selectAGroup: 'Select a group',
      noExistingGroups: 'No existing groups found. Create a new group instead.',
      groupName: 'Group Name',
      description: 'Description',
      optional: 'optional',
      enterGroupName: 'Enter group name',
      enterGroupDescription: 'Enter group description',
      
      // Exchange rates
      noCurrenciesAvailable: 'No currencies available',
      exchangeRatesUpdated: 'All exchange rates updated successfully',
      failedToUpdateRates: 'Failed to update exchange rates',
      currencyDisclaimer: 'Currency conversions are estimates and may not reflect exact rates at the time of contract payment.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Dashboard',
        loading: 'Loading dashboard...',
        notAvailable: 'Dashboard Not Available',
        upgradeMessage: 'The advanced dashboard visualization is not included in your current subscription plan.',
        viewPlans: 'View Available Plans',
        upgradeDetails: 'Upgrade your plan to get access to all dashboard features including financial insights, contract timelines, distribution analytics, and more.',
        
        controls: {
          editLayout: 'Edit Layout',
          editing: 'Editing',
          addWidget: 'Add Widget',
          resetLayout: 'Reset Layout',
          saveLayout: 'Save Layout',
          saving: 'Saving...',
          saved: 'Saved!',
          freePositioning: 'Free Positioning',
          gridLayout: 'Grid Layout'
        },

        filters: {
          title: 'Filters',
          refineData: 'Refine dashboard data',
          clearAll: 'Clear all',
          vendors: 'Vendors',
          contractTypes: 'Contract types',
          currencies: 'Currencies',
          importance: 'Importance',
        },
        
        widgets: {
          noData: 'No contract data yet',
          populate: 'Your dashboard will populate with insights once you add contracts to the system.',
          addFirst: 'Add your first contract',
          
          totalContracts: 'Total Contracts',
          acrossCategories: 'Across all categories',
          activeContracts: 'Active Contracts',
          currentlyActive: 'Currently active',
          expiringSoon: 'Expiring Soon',
          nextDays: 'In the next 30 days',
          totalValue: 'Total Value',
          inUserCurrency: 'In user\'s currency',
          calculating: 'Calculating...',
          
          contractsByType: 'Contracts by Type',
          contractsTimeline: 'Contracts Timeline',
          hoverInfo: 'Hover over data points to see detailed information',
          contractCount: '{{value}} contracts',
          
          recentContracts: 'Recent Contracts',
          supplier: 'Vendor',
          status: 'Status',
          created: 'Created',
          actions: 'Actions',
          noRecentContracts: 'No recent contracts found',
          
          upcomingExpirations: 'Upcoming Expirations',
          expires: 'Expires',
          daysLeft: 'Days Left',
          noDaysLeft: '{{count}} days',
          noUpcomingExpirations: 'No upcoming expirations',
          
          contractCostsByType: 'Contract Costs by Type',
          financialResult: 'Financial Result',
          multiCurrency: 'Multi-currency conversion',
          convertedFrom: 'Converted from multiple currencies'
        },
        
        supplierHealth: {
          title: 'Vendor Health',
          noIntegration: 'Connect Tripletex to view vendor analytics',
          noData: 'No vendor data available yet',
          highConsistency: 'High',
          mediumConsistency: 'Medium',
          lowConsistency: 'Low',
          transactions: 'transactions',
          contracts: 'contracts',
          lastPayment: 'Last payment'
        }
      },

      // API Portal translations
      apiPortal: {
        title: 'API Portal',
        description: 'Build integrations with our API',
        subtitle: 'Manage your API clients and access documentation',
        requestAccess: 'Request API Access',
        requestAccessDescription: 'To access the Subtrackr API, you need to request access from our team. Once approved, you can create API clients and start integrating.',
        requestPending: 'Your request is pending review',
        requestPendingDescription: 'We will notify you once your request has been reviewed.',
        requestRejected: 'Your request was rejected',
        approved: 'API Access Approved',
        activeClients: 'Active Clients',
        totalCalls: 'Total API Calls',
        rateLimit: 'Rate Limit',
        manageClients: 'Manage Clients',
        manageClientsDesc: 'Create and manage API credentials',
        documentation: 'Documentation',
        documentationDesc: 'View API reference and examples',
        sandboxTitle: 'Sandbox',
        sandboxDesc: 'Test API endpoints interactively',
        usageTitle: 'Usage Analytics',
        usageDesc: 'Monitor your API usage',
        recentActivity: 'Recent Activity',
        recentActivityDesc: 'Your latest API calls',
        noActivity: 'No API activity yet. Create a client and start making requests!',
        navigation: {
          overview: 'Overview',
          clients: 'My Clients',
          documentation: 'Documentation',
          sandbox: 'Sandbox',
          usage: 'Usage'
        },
        overview: {
          welcome: 'Welcome to the API Portal',
          description: 'Build powerful integrations with our comprehensive API',
          requestAccess: 'Request API Access',
          accessPending: 'Access Request Pending',
          accessApproved: 'API Access Approved',
          accessRejected: 'Access Request Rejected',
          getStarted: 'Get Started',
          viewDocs: 'View Documentation'
        },
        request: {
          title: 'Request API Access',
          description: 'Tell us about your integration plans',
          companyName: 'Company Name',
          companyNamePlaceholder: 'Your company name',
          useCase: 'Use Case',
          useCasePlaceholder: 'Describe how you plan to use the API...',
          submit: 'Submit Request',
          submitting: 'Submitting...',
          success: 'Your API access request has been submitted',
          error: 'Failed to submit request'
        },
        clients: {
          title: 'API Clients',
          description: 'Manage your OAuth2 clients',
          noClients: 'No API clients yet',
          createFirst: 'Create your first API client to start building integrations',
          create: 'Create Client',
          name: 'Client Name',
          namePlaceholder: 'My Integration',
          clientId: 'Client ID',
          clientSecret: 'Client Secret',
          secretWarning: 'Store this secret securely. It will not be shown again.',
          scopes: 'Scopes',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive',
          created: 'Created',
          rateLimit: 'Rate Limit',
          requestsPerHour: '{{count}} requests/hour',
          delete: 'Delete Client',
          deleteConfirm: 'Are you sure you want to delete this client?',
          deleteWarning: 'This action cannot be undone. All tokens will be revoked.',
          createSuccess: 'API client created successfully',
          createError: 'Failed to create API client',
          deleteSuccess: 'API client deleted',
          deleteError: 'Failed to delete client'
        },
        docs: {
          title: 'API Documentation',
          description: 'Learn how to integrate with our API',
          authentication: 'Authentication',
          authDescription: 'Our API uses OAuth2 client credentials flow',
          endpoints: 'Endpoints',
          baseUrl: 'Base URL',
          tryIt: 'Try it in Sandbox'
        },
        sandbox: {
          title: 'API Sandbox',
          description: 'Test API calls in a safe environment',
          selectEndpoint: 'Select Endpoint',
          selectClient: 'Select Client',
          noClients: 'Create an API client first',
          send: 'Send Request',
          sending: 'Sending...',
          response: 'Response',
          noResponse: 'Send a request to see the response'
        },
        usage: {
          title: 'API Usage',
          description: 'Monitor your API usage and analytics',
          totalRequests: 'Total Requests',
          successRate: 'Success Rate',
          avgResponseTime: 'Avg Response Time',
          recentRequests: 'Recent Requests',
          noUsage: 'No API usage data yet',
          endpoint: 'Endpoint',
          method: 'Method',
          statusCode: 'Status',
          responseTime: 'Response Time',
          timestamp: 'Timestamp'
        },
        admin: {
          title: 'API Access Requests',
          description: 'Review and manage API access requests',
          noRequests: 'No access requests',
          company: 'Company',
          noCompany: 'No company specified',
          useCase: 'Use Case',
          status: 'Status',
          submittedAt: 'Submitted',
          reviewedAt: 'Reviewed',
          pending: 'Pending',
          approved: 'Approved',
          rejected: 'Rejected',
          approve: 'Approve',
          reject: 'Reject',
          viewDetails: 'View Details',
          requestDetails: 'Request Details',
          rejectRequest: 'Reject Request',
          rejectDescription: 'Please provide a reason for rejecting this request',
          rejectionReasonPlaceholder: 'Enter rejection reason...',
          confirmReject: 'Confirm Reject',
          rejectionReason: 'Rejection Reason',
          requestApproved: 'Request approved successfully',
          requestRejected: 'Request rejected',
          approvalFailed: 'Failed to approve request',
          rejectionFailed: 'Failed to reject request'
        }
      },
      
      // Contract view page translations
      back: 'Back',
      contractDetails: 'Contract Details',
      basicInformation: 'Basic Information',
      supplierDetails: 'Vendor Details',
      organizationNumber: 'Organization Number',
      renewalDate: 'Renewal Date',
      renewalTerms: 'Renewal Terms',
      autoRenews: 'Auto Renews',
      everyInterval: 'Every {{interval}} {{unit}}',
      viewTimeline: 'View Timeline',
      'timeline.autoRenewed': 'Auto-Renewed',
      'timeline.previousExpiry': 'Previous expiry',
      'timeline.newExpiry': 'New expiry',
      'timeline.renewedFor': 'Renewed for',
      viewCostTimeline: 'View Cost Timeline',
      viewIncomeTimeline: 'View Income Timeline',
      manageContacts: 'Manage Contacts',
      noContacts: 'No contacts associated with this contract',
      peopleAssociated: 'People associated with this contract',
      contactPersons: 'Contact Persons',

      // Email related translations
      sendContract: 'Send Contract',
      recipient: 'Recipient',
      subject: 'Subject',
      message: 'Message',
      emailAddress: 'Email address',
      includeAdditionalAttachments: 'Include additional attachments',
      send: 'Send',
      sending: 'Sending...',
      generatingPdf: 'Generating PDF...',
      emailSent: 'Email sent successfully',
      errorSendingEmail: 'Error sending email',
      fillAllFields: 'Please fill all required fields',

      // Service Types
      serviceTypes: {
        product: 'Product',
        service: 'Service',
        subscription: 'Subscription',
        license: 'License',
        other: 'Other'
      },

      // Contract Services translations
      contractServices: 'Contract Services',
      servicesAssociated: 'Services associated with this contract',
      noServices: 'No services associated with this contract',
      serviceName: 'Service Name',
      serviceType: 'Service Type',
      quantity: 'Quantity',
      unitCost: 'Unit Cost',
      originalCost: 'Original Cost',
      contractCost: 'Contract Cost',
      totalInContractCurrency: 'Total (in contract currency)',
      exchangeRateApplied: 'Exchange rate applied',
      
      // Empty contracts state translations
      "contracts.emptyState.title": "Get Started with Contract Management",
      "contracts.emptyState.description": "Create your first contract to start organizing and managing your business agreements effectively.",
      "contracts.emptyState.addFirstContract": "Add Your First Contract",
      "contracts.emptyState.extractContract": "Extract from Document",
      "contracts.emptyState.setupGuide": "Setup Guide",
      "contracts.emptyState.step1.title": "Enter Basic Details",
      "contracts.emptyState.step1.description": "Start by entering the vendor name and basic contract information.",
      "contracts.emptyState.step2.title": "Set Terms",
      "contracts.emptyState.step2.description": "Define contract terms including expiry date and expected costs.",
      "contracts.emptyState.step3.title": "Add Documents",
      "contracts.emptyState.step3.description": "Upload any relevant contract documents and files.",

      // Contract import from Excel
      "contracts.import.title": "Import Contracts from Excel",
      "contracts.import.pageTitle": "Import Contracts",
      "contracts.import.pageDescription": "Import contracts, vendors, and contacts from an Excel file.",
      "contracts.import.description": "Upload an Excel file to bulk-create contracts with vendors and contact persons. Download the template, fill in your data (one row per contract), and upload.",
      "contracts.import.shortDescription": "Bulk-create contracts, vendors, and contacts by uploading an Excel file. Download the template, fill in your data, and upload.",
      "contracts.import.requiredColumns": "Required columns:",
      "contracts.import.optionalColumns": "Optional columns:",
      "contracts.import.downloadTemplate": "Download Template",
      "contracts.import.dropHere": "Drop your file here...",
      "contracts.import.dragOrClick": "Drag & drop an Excel file here, or click to browse",
      "contracts.import.acceptedFormats": ".xlsx or .csv",
      "contracts.import.validRows": "{{count}} valid row(s) ready to import",
      "contracts.import.errorRows": "{{count}} row(s) with errors (will be skipped)",
      "contracts.import.rowError": "Row {{row}}",
      "contracts.import.importButton": "Import {{count}} contract(s)",
      "contracts.import.cancel": "Cancel",
      "contracts.import.importing": "Importing... {{count}} of {{total}}",
      "contracts.import.done": "Successfully imported {{count}} contract(s)!",
      "contracts.import.success": "Successfully imported {{count}} contract(s)!",
      "contracts.import.error.missingSupplier": "Missing supplier_name",
      "contracts.import.error.invalidCost": "Invalid expected_cost",
      "contracts.import.error.invalidSignedDate": "Invalid signed_date",
      "contracts.import.error.invalidExpiryDate": "Invalid expiry_date",
      "contracts.import.error.invalidImportance": "Importance must be 1-5",
      "contracts.import.error.invalidFreqUnit": "Invalid payment_frequency_unit",
      "contracts.import.error.invalidReminder": "Invalid reminder_period",
      "contracts.import.error.parseFailed": "Failed to parse the file",
      "contracts.import.error.notLoggedIn": "You must be logged in to import contracts",
      "contracts.import.limitWarning": "Your plan allows {{remaining}} more contract(s). Only {{importable}} of {{total}} contracts will be imported.",
      "contracts.import.limitUpgradeHint": "Upgrade your subscription to import all contracts.",
      "contracts.import.upgradeLink": "Upgrade now",
      "contracts.import.limitReached": "You have reached the maximum number of contracts ({{used}}/{{limit}}) for your plan.",
      "contracts.import.upgradeToImport": "to import contracts.",
      
      // Contract extraction
      toggleJson: "Toggle JSON",
      extractedDataJson: "Extracted Data (JSON)",
      rawExtractionResults: "Raw extraction results from OpenAI",
      
      // Detect Expenses & Sales
      detect: "Detect",
      detectExpenses: "Detect Expenses",
      detectExpensesTooltip: "Analyze recurring expenses from your active Tripletex integration to automatically create contracts",
      detectRecurringSales: "Detect Sales",
      detectRecurringSalesTooltip: "Analyze recurring sales patterns to detect potential incoming contracts",
      detectBoth: "Run both",
      recurringCustomer: "Recurring Customer",
      expectedRevenue: "Expected Revenue",
      salesPattern: "Sales pattern",
      salesDetection: "Sales Detection",
      expenseDetection: "Expense Detection",
      willCreateIncomingContract: "This will create an incoming contract",
      salesDetectionComplete: "Sales detection complete. {{count}} recurring patterns found.",
      salesDetectionFailed: "Sales detection failed: {{message}}",
      notARecurringSale: "Not a recurring sale",
      showAll: "Show all",
      "revenue.revenueTrend": "Revenue Trend",
      "revenue.totalRevenue": "Total Revenue",
      "revenue.collected": "Collected",
      "revenue.outstanding": "Outstanding",
      "revenue.pipeline": "Pipeline",
      "revenue.actualRevenue": "Actual Revenue",
      "revenue.expectedIncome": "Expected Income",
      "revenue.invoiceCount": "{{count}} invoices",
      "revenue.salesOrderCount": "{{count}} orders",
      "revenue.paid": "Paid",
      "revenue.confirmed": "Confirmed",
      "revenue.cancelled": "Cancelled",
      "revenue.draft": "Draft",
      "revenue.overdue": "Overdue",
      "revenue.partial": "Partial",
      "revenue.pending": "Pending",
      "revenue.invoice": "Invoice",
      "revenue.order": "Order",
      "revenue.due": "Due",
      "revenue.showInvoices": "Show All Invoices",
      "revenue.hideInvoices": "Hide Invoices",
      "revenue.showOrders": "Show All Orders",
      "revenue.hideOrders": "Hide Orders",
      "revenue.amount": "Revenue",
      
      // Setup guide - Welcome
      "setupGuide.welcome.title": "Welcome to Subtrackr",
      "setupGuide.welcome.readyToGo": "Your account is ready to go! We've set up default categories, contract types, and currencies for you.",
      "setupGuide.welcome.customizeTitle": "Want to customize? Here's where to find everything:",
      "setupGuide.welcome.settingsCategories": "Categories & Contract Types",
      "setupGuide.welcome.settingsCategoriesDesc": "Customize in Settings → Categories / Contract Types",
      "setupGuide.welcome.settingsExchangeRates": "Exchange Rates",
      "setupGuide.welcome.settingsExchangeRatesDesc": "Manage in Settings → Exchange Rates",
      "setupGuide.welcome.settingsCompanyRegister": "Company Register",
      "setupGuide.welcome.settingsCompanyRegisterDesc": "Configure in Settings → Company Register",
      "setupGuide.welcome.settingsColors": "Importance & Status Colors",
      "setupGuide.welcome.settingsColorsDesc": "Personalize in Settings → Colors",
      "setupGuide.welcome.nextStepHint": "Next, let's set your preferred default currency.",
      "setupGuide.welcome.subtitle": "This setup guide will help you configure your account with all the essential settings.",
      "setupGuide.welcome.description": "You can complete this setup now, or you can access it later from the Settings page.",
      
      // Setup guide - Steps
      "setupGuide.steps.welcome": "Welcome",
      "setupGuide.steps.defaultCurrency": "Default Currency",
      "setupGuide.steps.completed": "Completed",
      
      // Setup guide - Default Currency
      "setupGuide.defaultCurrency.title": "Choose Your Default Currency",
      "setupGuide.defaultCurrency.description": "This will be used as the default when creating new contracts. You can change it anytime in Settings.",
      "setupGuide.defaultCurrency.error": "Failed to set default currency",
      "setupGuide.defaultCurrency.saved": "Default currency updated!",
      
      // Setup guide - Completion
      "setupGuide.completion.title": "Setup Complete!",
      "setupGuide.completion.description": "You're all set! Your account is configured and ready to use.",
      "setupGuide.completion.whatsNext": "What's Next?",
      "setupGuide.completion.nextStep1": "Add your first contract",
      "setupGuide.completion.nextStep2": "Invite team members to collaborate",
      "setupGuide.completion.nextStep3": "Set up notifications for contract renewals",
      "setupGuide.completion.nextStep4": "Explore the reporting and analytics features",
      "setupGuide.completion.accessLater": "You can access this setup guide again anytime from the Settings page.",
      
      // Setup guide - Actions
      "setupGuide.completedSuccess": "Setup completed successfully!",
      "setupGuide.completedError": "Error marking setup as complete",
      "setupGuide.error": "An error occurred while completing setup",
      "setupGuide.skippedSuccess": "Setup skipped. You can access it anytime from Settings.",
      "setupGuide.completing": "Completing...",
      "setupGuide.processing": "Processing...",
      "setupGuide.complete": "Complete Setup",
      
      // Setup guide - Categories
      "categories.resetExisting": "Remove existing categories before adding defaults",
      "categories.resetting": "Resetting...",
      "categories.adding": "Adding...",
      
      // Setup guide - Contract Types
      "contractTypes.resetExisting": "Remove existing contract types before adding defaults",
      "contractTypes.resetting": "Resetting...",
      
      // Common
      comingSoon: "Coming soon",
      close: "Close",
      
      reset: "Reset",
      resetAll: "Reset All",
      saveColors: "Save Colors",
      backgroundColor: "Background Color",
      textColor: "Text Color",
      colorSettingsSaved: "Color settings saved successfully",
      failedToSaveSettings: "Failed to save settings",
      
      // Importance levels
      importanceLevels: {
        veryLow: "Very Low",
        low: "Low",
        medium: "Medium",
        high: "High",
        critical: "Critical"
      },
      
      // Contract creation from ERP
      creatingContracts: "Creating Contracts",
      creatingContractsDescription: "Creating {{count}} contract(s) from detected expenses...",
      contractsCreatedSuccessfully: "Contracts Created Successfully",
      contractsCreatedWithErrors: "Contracts Created with Errors",
      contractCreationFailed: "Contract Creation Failed",
      createdContractsCount: "Created {{count}} contract(s)",
      failedContractsCount: "{{count}} failed",
      createdContracts: "Created Contracts",
      failedContracts: "Failed",
      viewAllContracts: "View All Contracts",
      createContract: "Create Contract",
      
      // Cost/Income Trend Graph
      expenses: {
        costTrend: "Cost Trend",
        amount: "Amount",
        actualCost: "Actual Cost",
        expectedCostHistory: "Expected Cost History",
        currentExpected: "Current Expected",
        stable: "Stable",
        graphDescriptionTripletex: "Expense history from {{start}} to {{end}}",
        graphDescriptionCostChanges: "Cost history from {{start}} to {{end}}",
        fetchInvoice: "Fetch Invoice",
        invoiceSynced: "Invoice synced successfully",
        noInvoiceFound: "No invoice document found for this voucher",
        invoiceSyncError: "Failed to sync invoice"
      },
      income: {
        incomeTrend: "Income Trend",
        amount: "Amount",
        actualIncome: "Actual Income",
        expectedIncomeHistory: "Expected Income History",
        currentExpected: "Current Expected",
        graphDescriptionTripletex: "Income history from {{start}} to {{end}}",
        graphDescriptionChanges: "Income history from {{start}} to {{end}}"
      },
      
      // Risk Analysis
      riskAnalysis: {
        title: "Risk Analysis",
        noAnalysis: "No risk analysis has been performed for this contract yet.",
        analyzeNow: "Analyze Contract",
        analyzing: "Analyzing...",
        analysisComplete: "Contract analysis complete",
        analysisError: "Failed to analyze contract",
        rateLimitError: "Too many requests. Please try again later.",
        lastAnalyzed: "Last analyzed",
        findings: "Risk Findings",
        recommendations: "Recommendations",
        noIssues: "No significant risks detected in this contract.",
        highRiskContracts: "High Risk Contracts",
        highRiskDescription: "Contracts requiring immediate attention",
        noHighRisk: "No high-risk contracts detected",
        analyzeMore: "Analyze your contracts to identify potential risks",
        expires: "Expires",
        findingsCount: "findings",
        viewAll: "View all {{count}} high-risk contracts",
        scoreLabel: "Score",
        riskLevels: {
          low: "Low Risk",
          medium: "Medium Risk",
          high: "High Risk",
          critical: "Critical Risk"
        }
      },

      // Approval Workflows
      approvalWorkflows: {
        title: "Approval Workflows",
        description: "Configure multi-stakeholder approval chains for contracts",
        createWorkflow: "Create Workflow",
        editWorkflow: "Edit Workflow",
        deleteWorkflow: "Delete Workflow",
        workflowName: "Workflow Name",
        workflowDescription: "Description",
        contractType: "Contract Type (Optional)",
        selectContractType: "Apply to specific contract type...",
        steps: "Approval Steps",
        approvalSteps: "Approval Steps",
        addStep: "Add Step",
        removeStep: "Remove Step",
        approverEmail: "Approver Email",
        approverName: "Approver Name",
        stepOrder: "Step Order",
        isMandatory: "Mandatory",
        mandatory: "Mandatory",
        timeoutDays: "Timeout (days)",
        isDefault: "Default Workflow",
        isActive: "Active",
        default: "Default",
        inactive: "Inactive",
        noWorkflows: "No workflows yet",
        noWorkflowsDesc: "Create approval workflows to manage contract approvals with multiple stakeholders.",
        createFirst: "Create Your First Workflow",
        workflowCreated: "Workflow created successfully",
        workflowUpdated: "Workflow updated successfully",
        workflowDeleted: "Workflow deleted successfully",
        confirmDelete: "Are you sure you want to delete this workflow?",
        deleteConfirmTitle: "Delete Workflow?",
        deleteConfirmDesc: "This will permanently delete this workflow and all its steps. This action cannot be undone.",
        stepsCount: "{{count}} steps",
        pendingApproval: "Pending Approval",
        approved: "Approved",
        rejected: "Rejected",
        approve: "Approve",
        reject: "Reject",
        addComment: "Add Comment",
        commentsPlaceholder: "Add comments (optional)...",
        approvalHistory: "Approval History",
        currentStep: "Current Step",
        step: "Step",
        initiatedBy: "Initiated By",
        initiatedAt: "Started",
        completedAt: "Completed At",
        noActiveRequest: "No active approval request. Start one to get stakeholder sign-off.",
        selectWorkflow: "Select a workflow...",
        startApproval: "Start",
        cancelApproval: "Cancel Approval",
        noWorkflowsAvailable: "No workflows available. Create one in Settings.",
        contractApprovals: "Contract Approvals",
        pastRequests: "Past Requests",
        autoInitiated: "Approval workflow \"{{name}}\" has been started",
        pendingApprovalBlocking: "Editing Blocked - Pending Approval",
        pendingApprovalBlockingDesc: "This contract is awaiting approval and cannot be edited until the approval process is complete. Please complete or cancel the approval workflow first.",
        namePlaceholder: "e.g., Standard Contract Approval",
        descriptionPlaceholder: "Describe when this workflow should be used...",
        status: {
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
          expired: "Expired",
          cancelled: "Cancelled"
        }
      },

      // Cost Optimization
      costOptimization: {
        title: "Cost Optimization",
        description: "AI-powered insights to reduce contract costs",
        runAnalysis: "Run Analysis",
        analyzing: "Analyzing...",
        lastAnalysis: "Last analysis",
        potentialSavings: "Potential Savings",
        suggestions: "Suggestions",
        noSuggestions: "No optimization suggestions yet",
        runFirst: "Run an analysis to discover cost-saving opportunities",
        suggestionTypes: {
          consolidation: "Consolidation",
          renegotiation: "Renegotiation",
          elimination: "Elimination",
          timing: "Timing Optimization",
          alternative: "Alternative Vendor"
        },
        status: {
          pending: "Pending Review",
          reviewed: "Reviewed",
          implemented: "Implemented",
          dismissed: "Dismissed"
        },
        markReviewed: "Mark as Reviewed",
        markImplemented: "Mark as Implemented",
        dismiss: "Dismiss",
        viewDetails: "View Details",
        affectedContracts: "Affected Contracts",
        confidence: "Confidence",
        recommendations: "Recommendations",
        analysisComplete: "Analysis complete: {{count}} suggestions found",
        freshAnalysisComplete: "Fresh analysis complete: {{count}} suggestions found. Previous history cleared.",
        analysisError: "Failed to analyze costs",
        statusUpdated: "Suggestion status updated",
        totalPotentialSavings: "Total Potential Savings",
        pendingReview: "Pending Review",
        implemented: "Implemented",
        dismissed: "Dismissed",
        freshAnalysis: "Fresh Re-analysis",
        freshAnalysisTooltip: "Clears all previous suggestions and analyzes all contracts from scratch"
      },

      // Sales Analytics
      salesAnalytics: {
        title: "Sales Analytics",
        description: "Analyze sales by product, customer and period",
        byProduct: "By product",
        byCustomer: "By customer",
        orders: "Orders",
        ordersShort: "Orders",
        product: "Product",
        customer: "Customer",
        totalRevenue: "Total revenue",
        orderCount: "Number of orders",
        confirmedValue: "Confirmed orders",
        awaitingDelivery: "Awaiting delivery",
        paidValue: "Paid",
        customers: "Customers",
        avgOrderValue: "Avg per order",
        sources: "sources",
        noData: "No data",
        importOrSync: "Import data or sync from ERP",
        dataSources: "Data sources",
        manualImport: "Manual import",
        selectPeriod: "Select period",
        thisMonth: "This month",
        lastMonth: "Last month",
        thisQuarter: "This quarter",
        thisYear: "This year",
        last12Months: "Last 12 months",
        pickDate: "Pick date",
        topProducts: "Top 10 products",
        revenueByProduct: "Revenue by product in selected period",
        allProducts: "All products",
        productCount: "{{count}} products",
        productName: "Product",
        quantity: "Quantity",
        revenue: "Revenue",
        share: "Share",
        noProductData: "No product data",
        noProductDataDescription: "No sales data for selected period. Sync from ERP or import data manually.",
        topCustomers: "Top 10 customers",
        revenueByCustomer: "Revenue by customer in selected period",
        allCustomers: "All customers",
        customerCount: "{{count}} customers",
        customerName: "Customer",
        email: "Email",
        lastOrder: "Last order",
        noCustomerData: "No customer data",
        noCustomerDataDescription: "No sales data for selected period. Sync from ERP or import data manually.",
        orderList: "Order list",
        refresh: "Refresh",
        orderNumber: "Order no.",
        orderDate: "Date",
        status: "Status",
        amount: "Amount",
        orderLines: "Order lines",
        unitPrice: "Unit price",
        lineTotal: "Total",
        noOrders: "No orders",
        noOrdersDescription: "No orders for selected period. Sync from ERP or import data manually.",
        statusDraft: "Draft",
        statusConfirmed: "Confirmed",
        statusInvoiced: "Invoiced",
        statusPaid: "Paid",
        statusCancelled: "Cancelled",
        // Sync button
        collectSalesAnalytics: "Collect sales analytics",
        sync: "Sync",
        syncing: "Syncing...",
        synced: "Synced",
        syncFailed: "Failed",
        syncComplete: "Sync complete",
        syncCompleteDesc: "{{products}} products, {{customers}} customers, {{orders}} orders synced.",
        syncError: "Sync error",
        syncErrorDesc: "Could not sync sales data. Try again later.",
        noIntegration: "No ERP integration",
        noIntegrationDesc: "You need to connect Tripletex or Finago to sync sales data.",
        syncNewData: "Sync new data",
        resetAndReimport: "Reset & re-import all",
        resetConfirmTitle: "Reset sales data?",
        resetConfirmDescription: "This will delete all existing sales data (orders, products, customers) and re-import everything from the ERP system. This may take some time.",
        resetAndReimportConfirm: "Yes, reset and re-import",
        resetComplete: "Reset complete",
        noIntegrationTooltip: "Connect Tripletex or Finago to sync",
        resetAndSyncComplete: "Data cleared and re-imported successfully.",
        // Import
        import: "Import",
        importSalesData: "Import sales data",
        importDescription: "Upload a CSV file with sales data. The file should contain columns for customer, product, date, quantity and price.",
        needTemplate: "Need a template?",
        downloadTemplate: "Download template",
        dropHere: "Drop the file here...",
        dragDrop: "Drag and drop CSV file here",
        orClickToSelect: "or click to select file",
        rowsDetected: "rows detected",
        importing: "Importing...",
        startImport: "Start import",
        importSuccess: "Import completed successfully",
        importPartial: "Import completed with some errors",
        importCompleted: "Import completed",
        importWithErrors: "Import completed with errors",
        ordersCreated: "orders",
        linesCreated: "lines",
        customersCreated: "customers",
        productsCreated: "products",
        moreErrors: "more errors",
        // Export
        export: "Export",
        exportOrders: "Export orders",
        exportProducts: "Export product sales",
        exportCustomers: "Export customer sales",
        exportSuccess: "Export completed",
        exportError: "Export failed",
        currency: "Currency",
        totalQuantity: "Total quantity",
        // Filters
        filters: "Filters",
        advancedFilters: "Advanced filters",
        clearAll: "Clear all",
        allStatuses: "All statuses",
        allSources: "All sources",
        amountRange: "Amount range",
        min: "Min",
        max: "Max",
        dataSource: "Data source",
        csvImport: "CSV Import",
        manual: "Manual",
        searchPlaceholder: "Search orders...",
        // Saved Reports
        savedReports: "Saved reports",
        saveCurrentAsNew: "Save current as new report",
        yourReports: "Your reports",
        noSavedReports: "No saved reports yet",
        saveReport: "Save report",
        saveReportDesc: "Save your current filter and date settings as a report you can quickly load later.",
        reportName: "Report name",
        reportNamePlaceholder: "e.g., Monthly product sales",
        reportDescription: "Description (optional)",
        reportDescPlaceholder: "What does this report show?",
        editReport: "Edit report",
        deleteReport: "Delete report?",
        deleteReportDesc: "This action cannot be undone. The saved report will be permanently deleted.",
        reportSaved: "Report saved",
        reportSaveError: "Failed to save report",
        reportUpdated: "Report updated",
        reportUpdateError: "Failed to update report",
        reportDeleted: "Report deleted",
        reportDeleteError: "Failed to delete report",
        reportLoaded: "Report loaded",
        updateWithCurrent: "Update with current settings",
        customPeriod: "Custom period",
        // PDF Export
        downloadPdf: "Download PDF",
        pdfPreview: "PDF Preview",
        pdfPreviewDesc: "Preview your report before downloading",
        pdfSelectSections: "Select which sections to include in your report",
        noSectionsSelected: "Select at least one section to include in the report",
        loadingReportData: "Loading report data...",
        totalItems: "Total: {{count}} items",
        generatedOn: "Generated on",
        period: "Period",
        summary: "Summary",
        pdfDownloaded: "PDF downloaded",
        pdfError: "Failed to generate PDF",
        generating: "Generating...",
        showingTop: "Showing top {{count}} of {{total}}",
        // Contract linking
        contract: "Contract",
        hasContract: "Has contract",
        contractsLinked: "{{count}} contracts linked",
        viewContract: "View contract",
        linkedContracts: "Linked contracts",
        expectedRevenue: "Expected revenue",
        expiringContract: "Expires {{date}}"
      },

      // Expense Sync
      expenseSync: {
        syncExpenses: "Sync expenses",
        syncing: "Syncing...",
        synced: "Synced",
        syncFailed: "Failed",
        syncComplete: "Expense sync complete",
        syncCompleteDesc: "{{synced}} expenses synced, {{matched}} contracts matched, {{unlinked}} unlinked expenses saved.",
        syncError: "Sync error",
        syncErrorDesc: "Could not sync expense data. Try again later.",
      },

      salesContractSuggestions: {
        title: "Contract Matches",
        description: "Auto-detect matches between sales customers and incoming contracts",
        detect: "Detect Matches",
        rescan: "Re-scan",
        pending: "pending",
        noSuggestions: "No contract matches found yet. Click 'Detect Matches' to scan for matches between sales customers and your incoming contracts.",
        detected: "{{count}} contract matches detected",
        noNewMatches: "No new contract matches found",
        detectionError: "Failed to detect contract matches",
        accepted: "Suggestion accepted",
        dismissed: "Suggestion dismissed",
        dismissTitle: "Dismiss this match?",
        dismissDescription: "This match won't be shown again. You can re-scan to find new matches.",
        confirmDismiss: "Dismiss",
        orgMatch: "Org# match",
        nameMatch: "Name match",
        manualMatch: "Manual",
        linked: "Linked",
        avgSales: "Avg sales",
        contractValue: "Contract",
        confidence: "confidence",
        viewContract: "View contract",
        pendingImports: "Products to import as services",
        dismissSelected: "Dismiss selected",
        importSelected: "Import selected",
        productName: "Product",
        qty: "Qty",
        unitPrice: "Unit price",
        total: "Total",
        importedServices: "Already imported as services",
        importedLabel: "Imported",
        status: "Status",
        noLines: "No order lines available for import",
        imported: "{{count}} services imported",
        importError: "Failed to import services",
        manualLinkCreated: "Customer linked to contract",
        salesServiceSuggestions: "Sales Service Suggestions",
        contractSuggestionDesc: "Products from sales orders that can be imported as services for this contract",
        dismiss: "Dismiss",
        importAsServices: "Import as services",
        allImported: "All suggested products have been imported as services",
      },

      // Contract Document Builder
      contractDocuments: {
        // Templates
        templatesTitle: "Document Templates",
        templatesDescription: "Create reusable templates for your contract documents",
        newTemplate: "New Template",
        editTemplate: "Edit Template",
        newTemplateDesc: "Create a reusable document template with dynamic variables",
        editTemplateDesc: "Modify your document template",
        noTemplates: "No templates yet",
        noTemplatesDesc: "Create your first document template to start generating professional contract documents.",
        createFirst: "Create your first template",
        templateName: "Template Name",
        templateNamePlaceholder: "e.g., Standard Service Agreement",
        templateDescription: "Description",
        descriptionPlaceholder: "Describe what this template is used for...",
        templateContent: "Template Content",
        templateContentHint: "Use the \"Insert Variable\" button to add dynamic placeholders that will be filled with contract data.",
        contractType: "Contract Type",
        selectContractType: "Select contract type",
        anyType: "Any type",
        direction: "Direction",
        selectDirection: "Select direction",
        anyDirection: "Any direction",
        setAsDefault: "Set as default for this type",
        templateCreated: "Template created",
        templateCreatedDesc: "Your template is ready to use.",
        templateUpdated: "Template updated",
        templateUpdatedDesc: "Your template has been saved.",
        templateDeleted: "Template deleted",
        templateDeletedDesc: "The template has been removed.",
        deleteTemplateTitle: "Delete template?",
        deleteTemplateDesc: "This action cannot be undone. Documents created from this template will not be affected.",
        deleteError: "Failed to delete template.",
        saveError: "Failed to save template.",
        nameRequired: "Template name is required.",
        editorPlaceholder: "Start writing your contract document...",
        insertVariable: "Insert Variable",
        // Direction labels
        "direction.incoming": "Incoming",
        "direction.outgoing": "Outgoing",
        "direction.employment": "Employment",
        "direction.other": "Other",
        // Variables
        variables: {
          supplierName: "Vendor Name",
          orgNumber: "Organization Number",
          contractType: "Contract Type",
          category: "Category",
          expectedCost: "Expected Cost",
          paymentFrequency: "Payment Frequency",
          paymentType: "Payment Type",
          signedDate: "Signed Date",
          expiryDate: "Expiry Date",
          todayDate: "Today's Date",
          contactPersons: "Contact Persons",
          companyName: "Company Name",
          servicesTable: "Services Table",
          categoryContract: "Contract Info",
          categoryFinancial: "Financial",
          categoryDates: "Dates",
          categoryPeople: "People",
          categoryDynamic: "Dynamic Content",
        },
        // Phase 2: Document editor
        documentsTitle: "Documents",
        documentsDescription: "Contract documents and drafts",
        createDocument: "Create Document",
        noDocuments: "No documents yet",
        noDocumentsDesc: "Create a document from a template or start from scratch.",
        document: "Document",
        documentCreateError: "Failed to create document.",
        documentDeleteError: "Failed to delete document.",
        pdfError: "Failed to generate PDF.",
        documentDeleted: "Document deleted",
        documentDeletedDesc: "The document has been removed.",
        deleteDocumentTitle: "Delete document?",
        deleteDocumentDesc: "This action cannot be undone. The document will be permanently deleted.",
        selectTemplate: "Select Template",
        selectTemplateDesc: "Choose a template to create a pre-filled document, or start with a blank document.",
        choosePlaceholder: "Choose a template...",
        default: "default",
        blankDocument: "Blank Document",
        useTemplate: "Use Template",
        downloadPdf: "Download PDF",
        finalize: "Finalize",
        saved: "Document saved",
        savedDesc: "Your changes have been saved.",
        finalized: "Document finalized",
        finalizedDesc: "The document has been marked as finalized.",
        unsaved: "Unsaved changes",
        untitledDocument: "Untitled Document",
        documentNotFound: "Document not found",
        goBack: "Go back",
        lastUpdated: "Updated",
        // Status labels
        status: {
          draft: "Draft",
          finalized: "Finalized",
          sent_for_signing: "Sent for Signing",
          signed: "Signed",
        },
        // Phase 3: Clause Library
        clauseLibrary: "Clause Library",
        clauseLibraryDesc: "Browse and insert reusable clause snippets into your document.",
        clauseLibraryPageDesc: "Manage reusable clause snippets for your contract documents.",
        insertClause: "Insert",
        newClause: "New Clause",
        editClause: "Edit Clause",
        clauseFormDesc: "Create a reusable clause snippet for your contract documents.",
        clauseName: "Clause Name",
        clauseNamePlaceholder: "e.g., Confidentiality Clause",
        clauseCategoryLabel: "Category",
        clauseContent: "Clause Content",
        clauseContentPlaceholder: "Write your clause content here...",
        clauseNameRequired: "Clause name is required.",
        clauseCreated: "Clause created",
        clauseCreatedDesc: "The clause has been added to your library.",
        clauseUpdated: "Clause updated",
        clauseUpdatedDesc: "The clause has been saved.",
        clauseDeleted: "Clause deleted",
        clauseDeletedDesc: "The clause has been removed.",
        clauseSaveError: "Failed to save clause.",
        clauseDeleteError: "Failed to delete clause.",
        deleteClauseTitle: "Delete clause?",
        deleteClauseDesc: "This action cannot be undone. The clause will be permanently removed from your library.",
        noClausesYet: "No clauses in your library yet.",
        noClausesDesc: "Manage clauses from the Clause Library page in settings.",
        noClausesPageDesc: "Create reusable clause snippets that you can insert into any contract document.",
        createFirstClause: "Create your first clause",
        clauseCategory: {
          general: "General",
          legal: "Legal",
          financial: "Financial",
          termination: "Termination",
          confidentiality: "Confidentiality",
          liability: "Liability",
          other: "Other",
        },
        // Phase 3: Signing integration
        signingPrepError: "Failed to prepare document for signing.",
        preparingSigning: "Preparing...",
        sendForSigningBankID: "Send for Signing (BankID)",
        sendForSigningDocuSign: "Send for Signing (DocuSign)",
        sentForSigning: "Sent for signing",
        sentForSigningDesc: "The document has been sent for e-signature.",
        // Document Import
        importDocument: {
          title: "Import Document",
          buttonLabel: "Import",
          description: "Upload a PDF, DOC, DOCX, or image file to convert it into editable content.",
          dropzone: "Click to select a file",
          converting: "Converting...",
          convert: "Import to Editor",
          success: "Document imported",
          successDesc: "The document content has been added to the editor.",
          conversionError: "Failed to convert document. Please try again.",
          fileTooLarge: "File is too large. Maximum size is 10MB.",
          unsupportedFormat: "Unsupported file format. Please use PDF, DOC, DOCX, or image files.",
          hint: "DOCX files are converted locally for best quality. PDF and image files use AI to extract and structure the content.",
          rateLimited: "Too many requests. Please wait a moment and try again.",
          creditsExhausted: "AI credits exhausted. Please add credits to continue.",
        },
        // Version history
        versionHistory: "Version History",
        createNewVersion: "New Version",
        newVersionCreated: "New version created",
        newVersionCreatedDesc: "A new draft version has been created.",
        newVersionError: "Failed to create new version.",
        editedBy: "Edited by",
        downloadSignedDoc: "Download signed document",
        lockedMessage: "This version is locked because it has been sent for signing or signed. Create a new version to make changes.",
        // Insert Image
        insertImage: {
          title: "Insert Image",
          description: "Upload an image and choose where to place it in the document.",
          selectFile: "Select image file",
          dropzone: "Click to select an image",
          placement: "Placement",
          atCursor: "At cursor position",
          headerSection: "Header",
          footerSection: "Footer",
          left: "Left",
          center: "Center",
          right: "Right",
          insert: "Insert",
        },
      },

      // IDURA Digital Signature
      idura: {
        title: "Send for Digital Signature",
        description: "Send contract for signing via Norwegian BankID",
        selectDocument: "Select Document",
        selectDocumentPlaceholder: "Choose a PDF document...",
        signerName: "Signer Name",
        signerNamePlaceholder: "Enter the signer's full name",
        signerEmail: "Signer Email",
        signerEmailPlaceholder: "Enter the signer's email address",
        sendForSignature: "Send for Signing (BankID)",
        sending: "Creating signature request...",
        sentSuccess: "Signing request sent to {{email}}",
        sentSuccessMessage: "The signing request has been created. Share the link below with the signer.",
        copyLink: "Copy Signing Link",
        copyLinkTooltip: "Copy the signing link to share with the signer",
        openLink: "Open signing link",
        linkCopied: "Signing link copied to clipboard",
        linkInstructions: "Send this link to the signer. They will authenticate with BankID to sign the document.",
        signedWith: "Signed with BankID",
        provider: "Provider",
        signingLink: "Signing Link",
        bankIdInfo: "The signer will authenticate using Norwegian BankID to sign the document digitally.",
        noPdfAttachments: "No PDF documents attached to this contract. Please add a PDF document first.",
        validation: {
          missingFields: "Please fill in all required fields",
          invalidEmail: "Please enter a valid email address"
        },
        error: {
          sendFailed: "Failed to send document for signature"
        },
        status: {
          pending: "Awaiting Signature",
          signed: "Signed",
          rejected: "Rejected",
          expired: "Expired"
        },
        downloadSigned: "Download Signed",
        downloadSignedTooltip: "Download the signed PDF with BankID signature",
        downloadSuccess: "Signed document downloaded",
        downloadFailed: "Failed to download signed document",
        noSignedDocument: "No signed document available"
      },

      // Multi-signer shared translations
      signing: {
        signers: "Signers",
        suggestedContacts: "Suggested from contract contacts",
        addSigner: "Add a signer",
        addSignerButton: "Add Signer",
        namePlaceholder: "Full name",
        emailPlaceholder: "Email address",
        fromContacts: "Contact",
        noSignersYet: "Add at least one signer to continue",
      },

      // E-Signature (shared translations for both providers)
      esignature: {
        title: "Send for E-Signature",
        description: "Send a contract document to be signed electronically via DocuSign.",
        requests: "Signature Requests",
        sentTo: "Sent to",
        signedOn: "Signed",
        selectDocument: "Select Document",
        selectDocumentPlaceholder: "Choose a document to sign",
        noDocuments: "No signable documents available",
        uploadHint: "Upload a PDF or Word document to this contract first.",
        signerName: "Signer Name",
        signerNamePlaceholder: "John Doe",
        signerEmail: "Signer Email",
        signerEmailPlaceholder: "john@example.com",
        emailSubject: "Email Subject",
        emailMessage: "Email Message",
        sendForSignature: "Send for Signature",
        sendForSignatureBankID: "Send for Signing (BankID)",
        sendForSignatureDocuSign: "Send for Signing (DocuSign)",
        sending: "Sending...",
        validationError: "Please fill in all required fields",
        invalidEmail: "Please enter a valid email address",
        sentSuccess: "Document sent for signature to {{email}}",
        sendError: "Failed to send document for signature: {{message}}",
        status: {
          completed: "Signed",
          pending: "Pending",
          declined: "Declined",
          voided: "Voided"
        },
        downloadSigned: "Download Signed",
        downloadSignedTooltipBankId: "Download the signed PDF with BankID signature",
        downloadSignedTooltipDocuSign: "Download the signed PDF from DocuSign",
        downloadSuccess: "Signed document downloaded",
        downloadFailed: "Failed to download signed document",
        noSignedDocument: "No signed document available",
        declineReason: "Reason",
        noDeclineReason: "No reason provided"
      },

      // Signing Integrations Admin
      signingIntegrations: {
        title: "Signing Integrations",
        description: "Manage signing providers and their environment modes",
        criiptoName: "Criipto (BankID)",
        criiptoDescription: "Norwegian BankID digital signatures for Nordic contracts",
        docusignName: "DocuSign",
        docusignDescription: "International electronic signature service for global contracts",
        enabled: "Enabled",
        disabled: "Disabled",
        production: "Production",
        development: "Development",
        environment: "Environment",
        productionDesc: "Using real API endpoints and charging real costs",
        developDesc: "Using sandbox/demo endpoints and simulated charges",
        productionWarning: "Production mode is active. All signing requests will use real API endpoints and incur real costs.",
        providerEnabled: "Provider Enabled",
        providerDisabled: "Provider Disabled",
        providerEnabledDesc: "Users can now use this signing provider",
        providerDisabledDesc: "This signing provider is now hidden from users",
        modeUpdated: "Mode Updated",
        productionModeActive: "Production mode is now active. Real API endpoints and charges will be used.",
        developModeActive: "Development mode is now active. Sandbox endpoints and simulated charges will be used.",
        updateFailed: "Failed to update setting",
        confirmProductionTitle: "Switch to Production Mode?",
        confirmProductionDesc: "Switching to production mode means:",
        confirmPoint1: "Real API endpoints will be used for signing requests",
        confirmPoint2: "Signing credit purchases will incur real Stripe charges",
        confirmPoint3: "All signatures will be legally binding",
        confirmSwitch: "Switch to Production",
        note: "When a provider is disabled, users will not see the signing button for that provider. Development mode uses sandbox endpoints and simulates credit purchases.",
        accessSettings: "Access Settings",
        accessDescription: "Configure who can access this signing provider",
        accessMode: "Access Mode",
        allUsers: "All Users",
        restrictedAccess: "Restricted Access",
        allUsersDesc: "All users with signing access in their subscription can use this provider",
        restrictedDesc: "Only selected roles and users can access this signing provider",
        allowedRoles: "Allowed Roles",
        allowedUsers: "Allowed Users",
        searchUsers: "Search users by name or email...",
        noUsersFound: "No users found",
        saveAccess: "Save Changes",
        access: "Access",
        restricted: "Restricted",
        accessUpdated: "Access Settings Updated",
        accessUpdatedDesc: "The signing provider access settings have been saved",
      },

      // Currencies page
      yourCurrencies: "Your Currencies",
      currenciesForContracts: "Currencies available for your contracts",
      loadingCurrencies: "Loading currencies...",
      errorLoadingCurrencies: "Error loading currencies",
      noCurrenciesFound: "No currencies found",
      addFirstCurrency: "Add your first currency",
      addCurrency: "Add Currency",
      manageCurrenciesDescription: "Manage the currencies available for your contracts",
      deleteCurrencyWarning: "This will permanently delete this currency. Contracts using this currency may be affected.",
      code: "Code",
      symbol: "Symbol",
      
      // Documentation page
      documentation: {
        title: "Documentation",
        subtitle: "Learn how to use all features in Subtrackr",
        searchPlaceholder: "Search documentation...",
        viewSubscription: "View Subscription"
      },
      
      // Documentation navigation
      docs: {
        contents: "Contents",
        categories: {
          gettingStarted: "Getting Started",
          coreFeatures: "Core Features",
          organization: "Organization & Setup",
          advancedFeatures: "Advanced Features",
          aiTools: "AI & Analytics",
          integrations: "Integrations",
          settings: "Settings"
        },
        nav: {
          gettingStarted: "Introduction",
          subscriptionPlans: "Subscription Plans",
          dashboard: "Dashboard",
          dashboardWidgets: "Dashboard Widgets",
          contracts: "Contracts",
          calendarView: "Calendar View",
          notifications: "Notifications & Reminders",
          categories: "Categories",
          contractTypes: "Contract Types",
          currencies: "Currencies",
          contacts: "Contacts",
          groups: "Departments",
          customFields: "Custom Fields",
          duplicateDetection: "Duplicate Detection",
          notesActivity: "Notes & Activity Log",
          approvalWorkflows: "Approval Workflows",
          contractDocumentBuilder: "Document Builder",
          clauseLibrary: "Clause Library",
          documentVariables: "Document Variables",
          governingDocuments: "Governing Documents",
          esignature: "E-Signature (DocuSign)",
          riskAnalysis: "AI Risk Analysis",
          costOptimization: "AI Cost Optimization",
          salesAnalytics: "Sales Analytics",
          dataHealth: "Data Health",
          erpIntegrations: "ERP Integrations",
          apiPortal: "API Portal",
          documentExtraction: "Document Extraction",
          settingsProfile: "Settings & Profile"
        },
        // Section content translations
        sections: {
          gettingStarted: {
            title: "Getting Started",
            description: "Welcome to Subtrackr! This guide will help you get started with managing your contracts efficiently.",
            whatIs: "What is Subtrackr?",
            whatIsDesc: "Subtrackr is a comprehensive contract management system that helps you track, manage, and analyze your business contracts. It provides tools for contract lifecycle management, expense tracking, reminders, and integrations with ERP systems like Tripletex.",
            firstSteps: "First Steps",
            firstStepsDesc: "After logging in, you'll see the Dashboard which provides an overview of your contracts and important metrics.",
            navigation: "Navigation",
            navigationDesc: "The main navigation is located at the top of the page. You can access all features from here."
          },
          subscriptionPlans: {
            title: "Subscription Plans",
            description: "Subtrackr offers different subscription plans to fit your business needs. Learn about features, pricing, and how to upgrade your plan.",
            overview: "Overview",
            overviewDesc: "Subtrackr has four subscription tiers: Gratis (Free), Plus, Pro, and Business. Each tier offers progressively more features and higher usage limits.",
            freePlan: "Gratis (Free) Plan",
            freePlanDesc: "The free plan is perfect for individuals or small businesses just getting started with contract management.",
            plusPlan: "Plus Plan",
            plusPlanDesc: "The Plus plan is designed for growing businesses that need more contracts and access to advanced features.",
            proPlan: "Pro Plan",
            proPlanDesc: "The Pro plan is ideal for established businesses that need comprehensive contract management.",
            businessPlan: "Business Plan",
            businessPlanDesc: "The Business plan is our most comprehensive offering for larger organizations."
          },
          salesAnalytics: {
            title: "Sales Analytics",
            description: "Analyze your sales performance by product, customer, and time period using data from your ERP integrations or CSV imports.",
            whatIs: "What is Sales Analytics?",
            whatIsDesc: "Sales Analytics provides comprehensive insights into your revenue streams. It aggregates order and invoice data from connected ERP systems or manual CSV imports.",
            accessing: "Accessing Sales Analytics",
            accessingDesc: "Navigate to Sales Analytics from the Tools menu in the main navigation.",
            dataSources: "Data Sources",
            dataSourcesDesc: "Sales Analytics can pull data from multiple sources including Tripletex, Finago, and CSV imports.",
            overview: "Overview Dashboard",
            overviewDesc: "The Overview tab provides key performance indicators and trends.",
            products: "Product Analysis",
            productsDesc: "The Products tab shows revenue broken down by product or service.",
            customers: "Customer Analysis",
            customersDesc: "The Customers tab helps you understand your customer base.",
            orders: "Order Details",
            ordersDesc: "The Orders tab provides a detailed list of all transactions.",
            csvImport: "CSV Import",
            csvImportDesc: "Import sales data manually if you don't have ERP integration.",
            syncing: "Syncing ERP Data",
            syncingDesc: "Keep your sales data up to date with ERP synchronization."
          },
          dataHealth: {
            title: "Data Health",
            description: "Monitor and improve the quality of your contract data to ensure accurate reporting and reliable automated features.",
            whatIs: "What is Data Health?",
            whatIsDesc: "Data Health analyzes your contract database to identify missing information, data quality issues, and opportunities for improvement.",
            accessing: "Accessing Data Health",
            accessingDesc: "Navigate to Data Health from the Tools menu in the main navigation.",
            healthScore: "Understanding the Health Score",
            healthScoreDesc: "The Data Health Score provides a quick assessment of your overall data quality.",
            categories: "Issue Categories",
            categoriesDesc: "Data Health organizes issues into logical categories for easier management.",
            fixing: "Fixing Issues",
            fixingDesc: "Each issue includes guidance on how to resolve it.",
            recommendations: "Recommendations",
            recommendationsDesc: "Data Health provides proactive recommendations to improve your contract management.",
            widget: "Dashboard Widget",
            widgetDesc: "Add the Data Health widget to your dashboard for at-a-glance monitoring.",
            bestPractices: "Best Practices",
            bestPracticesDesc: "Tips for maintaining high data quality."
          },
          approvalWorkflows: {
            title: "Approval Workflows",
            description: "Configure multi-stakeholder approval chains for contracts requiring sign-off from multiple people.",
            whatIs: "What are Approval Workflows?",
            whatIsDesc: "Approval Workflows allow you to define formal approval chains for contracts.",
            creating: "Creating a Workflow",
            creatingDesc: "Access approval workflows from Tools → Approval Workflows.",
            steps: "Adding Approval Steps",
            stepsDesc: "Each workflow consists of one or more sequential approval steps.",
            initiating: "Initiating an Approval",
            initiatingDesc: "Start the approval process from a contract's detail page.",
            approving: "Approving or Rejecting",
            approvingDesc: "Approvers can take action on pending requests via email link or in the system.",
            tracking: "Tracking Approval Status",
            trackingDesc: "Monitor the progress of approval requests in real-time.",
            managing: "Managing Workflows",
            managingDesc: "Edit or delete workflows from the Approval Workflows page."
          },
          costOptimization: {
            title: "AI Cost Optimization",
            description: "Analyze spending patterns across your contracts to identify savings opportunities using AI.",
            whatIs: "What is Cost Optimization?",
            whatIsDesc: "The AI Cost Optimization Engine analyzes your contract portfolio to identify opportunities for savings.",
            running: "Running Analysis",
            runningDesc: "Access cost optimization from Tools → Cost Optimization.",
            suggestions: "Understanding Suggestions",
            suggestionsDesc: "The AI generates different types of optimization suggestions.",
            details: "Suggestion Details",
            detailsDesc: "Each suggestion includes detailed information to help you take action.",
            managing: "Managing Suggestions",
            managingDesc: "Take action on suggestions to track your optimization efforts.",
            stats: "Dashboard Statistics",
            statsDesc: "The Cost Optimization dashboard shows key metrics.",
            bestPractices: "Best Practices",
            bestPracticesDesc: "Tips for getting the most from cost optimization."
          },
          riskAnalysis: {
            title: "AI Risk Analysis",
            description: "Analyze contract documents using AI to identify potential legal and financial risks.",
            whatIs: "What is Risk Analysis?",
            whatIsDesc: "AI Contract Risk Analysis uses advanced AI to evaluate your contract documents and identify potential risks.",
            running: "Running Risk Analysis",
            runningDesc: "Analyze a contract document from the contract detail page.",
            scores: "Understanding Risk Scores",
            scoresDesc: "The AI assigns a risk score from 0-100 and categorizes the overall risk level.",
            findings: "Risk Findings",
            findingsDesc: "The analysis identifies specific risk areas in your contract.",
            recommendations: "Recommendations",
            recommendationsDesc: "For each risk finding, the AI provides specific recommendations."
          }
        },
        // Common documentation UI elements
        stepsLabel: "Steps",
        tipsLabel: "Tips & Notes",
        requiresErp: "Requires ERP Integration"
      },
      
      // Integrations page
      Tripletex: "Tripletex",
      "Finago Office": "Finago Office",
      Connect: "Connect",
      Active: "Active",
      Inactive: "Inactive",
      Connected: "Connected",
      Remove: "Remove",
      Cancel: "Cancel",
      Search: "Search",
      "Connect your Tripletex ERP system to sync data": "Connect your Tripletex ERP system to sync data",
      "Connect your Finago Office ERP system to sync data": "Connect your Finago Office ERP system to sync data",
      "No Tripletex integration connected": "No Tripletex integration connected",
      "No Finago Office integration connected": "No Finago Office integration connected",
      "Click the Connect button above to get started": "Click the Connect button above to get started",
      "Org. number": "Org. number",
      "Detect Expenses": "Detect Expenses",
      "Remove Integration": "Remove Integration",
      "Are you sure you want to remove this Tripletex integration? This action cannot be undone.": "Are you sure you want to remove this Tripletex integration? This action cannot be undone.",
      "Are you sure you want to remove this integration? This action cannot be undone.": "Are you sure you want to remove this integration? This action cannot be undone.",
      "Connecting...": "Connecting...",
      
      // Finago Office specific
      "Connect to Finago Office": "Connect to Finago Office",
      "Authorize access to your Finago Office account to sync your accounting data": "Authorize access to your Finago Office account to sync your accounting data",
      "What you'll get:": "What you'll get:",
      "Automatic expense synchronization": "Automatic expense synchronization",
      "Recurring expense detection": "Recurring expense detection",
      "Customer invoice tracking": "Customer invoice tracking",
      "Budget vs actual comparison": "Budget vs actual comparison",
      "You will be redirected to Finago Office to authorize access. After authorization, you'll be returned to this application.": "You will be redirected to Finago Office to authorize access. After authorization, you'll be returned to this application.",
      "Connect with Finago": "Connect with Finago",
      "Processing authorization...": "Processing authorization...",
      "Please wait while we connect your Finago account": "Please wait while we connect your Finago account",
      "Authorization Failed": "Authorization Failed",
      "An error occurred during authorization": "An error occurred during authorization",
      "Try Again": "Try Again",
      "Go Back": "Go Back",
      "Select Organization": "Select Organization",
      "Choose which organization to integrate with": "Choose which organization to integrate with",
      "Search by organization name or number": "Search by organization name or number",
      "No organizations found matching your search": "No organizations found matching your search",
      "Integration Successful!": "Integration Successful!",
      "Your Finago Office account has been connected successfully": "Your Finago Office account has been connected successfully",
      "Connected Organization": "Connected Organization",
      "No authorization code received": "No authorization code received",
      "Failed to exchange authorization code": "Failed to exchange authorization code",
      "Failed to fetch organizations": "Failed to fetch organizations",
      "No organizations found in your Finago account": "No organizations found in your Finago account",
      "Failed to initialize OAuth": "Failed to initialize OAuth",
      "Admin Preview": "Admin Preview",
      
      // Expense Detection Page
      analysisSettings: "Analysis Settings",
      selectDateRange: "Select date range for expense analysis",
      from: "From",
      to: "To",
      analyzeExpenses: "Analyze Expenses",
      analyzing: "Analyzing",
      detectedPatterns: "Detected Patterns",
      potentialContracts: "potential contracts",
      selectHighConfidence: "Select High Confidence",
      createContracts: "Create Contracts",
      high: "High",
      medium: "Medium",
      low: "Low",
      weekly: "Weekly",
      fortnightly: "Fortnightly",
      monthly: "Monthly",
      biMonthly: "Bi-monthly",
      quarterly: "Quarterly",
      semiAnnually: "Semi-annually",
      annually: "Annually",
      transactions: "transactions",
      analyzed: "Analyzed",
      transactionsFound: "transactions, found",
      recurringPatterns: "recurring patterns",
      analysisComplete: "Analysis Complete",
      analysisFailed: "Analysis Failed",
      failedToCreateContracts: "Failed to Create Contracts",
      noExpensesSelected: "No Expenses Selected",
      pleaseSelectAtLeastOne: "Please select at least one expense pattern to create contracts",
      cannotReject: "Cannot Reject Pattern",
      noSupplierInfo: "Missing vendor information for this pattern",
      patternRejected: "Pattern Rejected",
      patternWontBeSuggested: "This pattern won't be suggested again",
      rejectionFailed: "Rejection Failed",
      noActiveIntegration: "No Active Integration",
      setupFinagoFirst: "Please set up your Finago Office integration first",
      goToIntegrations: "Go to Integrations",
      organization: "Organization",
      detectRecurringExpenses: "Detect Recurring Expenses",
      analyzeFinagoPostings: "Analyze Finago ledger postings to find recurring expenses",
      connectedTo: "Connected to",
      dateRange: "Date Range",
      startAnalysis: "Start Analysis",
      detectedRecurringExpenses: "Detected Recurring Expenses",
      reviewAndSelectExpenses: "Review and select expenses to create as contracts",
      selectAllHighConfidence: "Select All High Confidence",
      account: "Account",
      averageAmount: "Average Amount",
      frequency: "Frequency",
      occurrences: "Occurrences",
      times: "times",
      variance: "Variance",
      varianceTooltip: "Variance shows how much the payment amounts differ between occurrences. Low variance indicates consistent payments.",
      paymentType: "Payment Type",
      contractDetailsOptional: "Contract Details (Optional)",
      leaveEmptyToUseSuggested: "Leave empty to use suggested",
      selectCategoryOptional: "Select category (optional)",
      selectContractTypeOptional: "Select contract type (optional)",
      signingDate: "Signing Date",
      default: "Default",
      period: "Period",
      sampleDescriptions: "Sample Descriptions",
      detectedBy: "Detected by",
      noPatterns: "No Patterns Detected",
      clickAnalyze: "Click 'Start Analysis' to detect recurring expense patterns from your transactions.",
      rejectSuggestion: "Reject this suggestion",
      accountFilteringRules: "Account Filtering Rules",
      accountFilteringDescription: "Control which account numbers should be excluded or prioritized in expense detection",
      accountNumber: "Account Number",
      ruleType: "Rule Type",
      exclude: "Exclude",
      prioritize: "Prioritize",
      descriptionOptional: "Description (optional)",
      descriptionPlaceholder: "e.g., Insurance expenses",
      prioritizedAccounts: "Prioritized Accounts",
      excludedAccounts: "Excluded Accounts",
      loadingAccountRules: "Loading account rules...",
      accountRuleAdded: "Account rule added",
      accountRuleRemoved: "Account rule removed",
      failedToAddRule: "Failed to add rule",
      failedToRemoveRule: "Failed to remove rule",
      pleaseEnterAccountNumber: "Please enter an account number",
      
      // Payment related
      Day: "Day",
      Month: "Month",
      Year: "Year",
      Unit: "Unit",
      "Payment Frequency": "Payment Frequency",
      "Frequency (e.g. 1, 3, 6)": "Frequency (e.g. 1, 3, 6)",
      "Select unit": "Select unit",
      "Payment Type": "Payment Type",
      "Select payment type": "Select payment type",
      
      // Contract dates
      "1 month": "1 month",
      "3 months": "3 months",
      "6 months": "6 months",
      "1 year": "1 year",
      "2 years": "2 years",
      "3 years": "3 years",
      "5 years": "5 years",
      "Custom date": "Custom date",
      "Signed Date": "Signed Date",
      "Pick a date": "Pick a date",
      "Select duration": "Select duration",
      "This date is locked because it's determined by the auto-renewal settings of the contract type": "This date is locked because it's determined by the auto-renewal settings of the contract type",
      "This date is set automatically based on contract type renewal settings": "This date is set automatically based on contract type renewal settings",
      
      // Financial Details
      "Financial Details": "Financial Details",
      "Cost and payment information": "Cost and payment information",
      "Use services total": "Use services total",
      "useServicesTotalTooltip": "When enabled, the contract cost will be automatically calculated from the total of all added services instead of manually entering a cost.",
      "Enter expected cost": "Enter expected cost",
      "Enter expected income": "Enter expected income",
      "Using total from services": "Using total from services",
      "Converted at rate": "Converted at rate",
      "Currency conversions are estimates and may not reflect exact rates at the time of contract payment.": "Currency conversions are estimates and may not reflect exact rates at the time of contract payment.",
      
      // Calendar View
      calendarView: "Calendar View",
      tableView: "Table View", 
      cardView: "Card View",
      listView: "List View",
      timelineView: "Timeline View",
      clearFilters: "Clear filters",
      convertedAtRate: "Converted at rate",
      currencyConversionDisclaimer: "Currency conversions are estimates and may not reflect exact rates at the time of contract payment.",
      converting: "converting...",
      calendarLegend: "Legend",
      signedDates: "Signed Dates",
      expiryDates: "Expiry Dates",
      signedOn: "Signed On",
      expiresOn: "Expires On",
      contractsOnDate: "Contracts on {{date}}",
      noContractsOnDate: "No contracts on this date",
      selectADate: "Select a Date",
      clickDateToViewContracts: "Click on a date to view contracts",
      
      // Interactive Timeline
      timeline: {
        title: "Contract Timeline",
        today: "Today",
        noContracts: "No contracts to display",
        addContracts: "Add contracts to see them on the timeline",
        totalContracts: "Total Contracts",
        active: "Active",
        expiringSoon: "Expiring Soon",
        expired: "Expired",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        reset: "Reset view",
        expense: "Expense",
        revenue: "Revenue",
        employment: "Employment",
        expiringSoonLabel: "Expiring ≤30d",
        expiredLabel: "Expired",
        contractValue: "Contract Value",
        startDate: "Start Date",
        endDate: "End Date",
        duration: "Duration",
        days: "days",
        daysRemaining: "Days Remaining",
        expiredDays: "{{days}} days ago",
        viewDetails: "View Full Details",
        instructions: "Click and drag to pan. Use mouse wheel or buttons to zoom. Click on a contract for details."
      },
      
      // Duplicate Detection
      duplicateDetection: "Duplicate Detection",
      findDuplicates: "Find Duplicates",
      potentialDuplicate: "Potential Duplicate",
      noDuplicatesFound: "No duplicate contracts found",
      allContractsUnique: "All your contracts appear to be unique",
      duplicatesFound: "{{count}} potential duplicate(s) found",
      confidenceScore: "Confidence: {{score}}%",
      organizationNumberMatch: "Same organization number",
      similarSupplierName: "Similar vendor name",
      sameCost: "Same expected cost",
      sameCategory: "Same category",
      sameContractType: "Same contract type",
      sameExpiryDate: "Same expiry date",
      sameSignedDate: "Same signed date",
      mergeContracts: "Merge Contracts",
      dismissDuplicate: "Dismiss",
      selectContractToKeep: "Select which contract to keep",
      keepingContract: "Keeping",
      removingContract: "Removing",
      mergePreview: "Merge Preview",
      mergeWarning: "This action cannot be undone",
      attachmentsWillTransfer: "Attachments will be transferred",
      contactsWillTransfer: "Contacts will be transferred",
      expensesWillTransfer: "Expense history will be transferred",
      actionCannotBeUndone: "This action cannot be undone",
      confirmMerge: "Confirm Merge",
      contractsMerged: "Contracts merged successfully",
      mergeFailed: "Failed to merge contracts",
      merging: "Merging...",
      keep: "Keep",
      
      // Custom Fields
      customFields: "Custom Fields",
      customFieldsDescription: "Define custom fields for contracts",
      createCustomField: "Create Custom Field",
      createCustomFieldDescription: "Add a new custom field for your contracts",
      editCustomField: "Edit Custom Field",
      editCustomFieldDescription: "Update custom field settings",
      noCustomFields: "No custom fields defined",
      noCustomFieldsDescription: "Create custom fields to track additional information",
      createFirstCustomField: "Create Your First Custom Field",
      fieldName: "Field Name",
      fieldType: "Field Type",
      usage: "Usage",
      fieldOptions: "Options",
      textField: "Text",
      numberField: "Number",
      dateField: "Date",
      dropdownField: "Dropdown",
      checkboxField: "Checkbox",
      isRequired: "Required Field",
      enterFieldName: "Enter field name",
      enterOption: "Enter option",
      fieldNameRequired: "Field name is required",
      customFieldCreated: "Custom field created",
      customFieldUpdated: "Custom field updated",
      customFieldDeleted: "Custom field deleted",
      fieldInUse: "This field is in use by {{count}} contract(s)",
      deleteCustomFieldWarning: "Are you sure you want to delete the custom field \"{{name}}\"? This action cannot be undone.",
      failedToCreateCustomField: "Failed to create custom field",
      failedToUpdateCustomField: "Failed to update custom field",
      failedToDeleteCustomField: "Failed to delete custom field",
      
      // Notes & Activity Log
      notesAndActivity: "Notes & Activity",
      addNote: "Add Note",
      editNote: "Edit Note",
      deleteNote: "Delete Note",
      noteTitle: "Title",
      noteContent: "Content",
      noteTitlePlaceholder: "Enter a title for this note",
      noteContentPlaceholder: "Add details about this activity...",
      activityType: "Activity Type",
      activityTypeNote: "Note",
      activityTypeCall: "Call",
      activityTypeMeeting: "Meeting",
      activityTypeEmail: "Email",
      activityTypeNegotiation: "Negotiation",
      activityTypeIssue: "Issue",
      reviewDate: "Review Date",
      reviewDateHint: "Set a date to be reminded to review this note",
      reviewOn: "Review on",
      markAsReviewed: "Mark as Reviewed",
      noNotesYet: "No notes yet",
      addNoteToTrack: "Add notes to track activities and important events",
      allActivities: "All Activities",
      filterByType: "Filter by type",
      noteCreated: "Note added successfully",
      noteUpdated: "Note updated successfully",
      noteDeleted: "Note deleted successfully",
      noteMarkedReviewed: "Note marked as reviewed",
      errorCreatingNote: "Error creating note",
      errorUpdatingNote: "Error updating note",
      errorDeletingNote: "Error deleting note",
      errorMarkingReviewed: "Error marking note as reviewed",
      deleteNoteConfirmation: "Are you sure you want to delete this note? This action cannot be undone.",
      notesForReview: "Notes for Review",
      dueForReview: "Due for Review",
      upcomingReviews: "Upcoming Reviews",
      noUpcomingReviews: "No upcoming reviews scheduled",
      updateNote: "Update Note",
      titleRequired: "Title is required",
      enter: "Enter",
      pickADate: "Pick a date",
      yes: "Yes",
      no: "No",
      
      // Pending Contracts Page
      pendingContracts: "Pending Contracts",
      pendingContractsDescription: "Review and import detected contracts from all your ERP integrations",
      noPendingContracts: "No Pending Contracts",
      noPendingContractsDescription: "No potential contracts have been detected from your ERP integrations. Run a sync to detect new patterns.",
      confidence: "confidence",
      hideDetails: "Hide Details",
      showContractDetails: "Contract Details",
      notAContract: "Not a Contract",
      creating: "Creating",
      
      // Subscription & Usage
      subscription: {
        usage: {
          title: "Usage & Limits",
          description: "Track your current usage against your plan limits",
          contracts: "Contracts",
          documentExtractions: "Document Extractions",
          erpIntegrations: "ERP Integrations",
          storage: "Storage",
          includesAddOn: "(includes {{count}} add-on credits)",
          includesAddons: "Includes {{count}} add-on credits",
          monthlyReset: "Resets monthly",
          unlimited: "Unlimited",
          limitReached: "Limit reached"
        },
        upgrade: {
          title: "Upgrade Required",
          defaultMessage: "This feature is not available on your current plan. Upgrade to access {{feature}}.",
          viewPlans: "View Plans"
        },
        limits: {
          approachingTitle: "Approaching {{limitName}} Limit",
          approachingMessage: "You have used {{used}} of {{limit}} {{limitName}} ({{percent}}%).",
          reachedTitle: "{{limitName}} Limit Reached",
          reachedMessage: "You have used {{used}} of {{limit}} {{limitName}}. Upgrade to continue.",
          erpReached: "You have reached the maximum number of ERP integrations for your plan. Upgrade to add more integrations.",
          contractsReached: "You have reached the maximum number of contracts ({{used}}/{{limit}}) for your plan. Upgrade to add more contracts.",
          extractionsReached: "You have used all your document extractions ({{used}}/{{limit}}) for this month. Purchase add-on credits or upgrade your plan.",
          extractionsWarning: "You have {{remaining}} document extractions remaining this month.",
          contractLockedRow: "Locked — over plan limit",
          contractLockedTooltip: "This contract exceeds your plan limit ({{used}}/{{limit}}). Upgrade your plan or delete other contracts to unlock it.",
          contractLockedTitle: "Contract Locked",
          contractLockedMessage: "You currently have {{used}} contracts but your plan only allows {{limit}}. The newest contracts are locked until you upgrade your plan or delete other contracts. You can still delete this contract."
        },
        widgets: {
          premiumRequired: "This widget is available on Pro and Business plans.",
          budgetVsActual: "Budget vs Actual",
          supplierHealth: "Vendor Health",
          renewalPrediction: "Renewal Cost Prediction",
          revenueOverview: "Revenue Overview",
          notesForReview: "Notes for Review"
        },
        api: {
          description: "Access to the API Portal requires a Pro or Business subscription.",
          upgradeMessage: "Upgrade your plan to access the API Portal and integrate Subtrackr with your external applications."
        },
        customFields: {
          upgradeMessage: "Upgrade your plan to create custom fields for your contracts."
        },
        contractNotes: {
          description: "Track meetings, negotiations, and important events on your contracts.",
          upgradeMessage: "Upgrade your plan to add notes and activity logs to your contracts."
        },
        duplicateDetection: {
          description: "Find and manage potential duplicate contracts in your database.",
          upgradeMessage: "Upgrade your plan to access duplicate detection and keep your contract database clean."
        },
        plans: {
          free: "Free",
          plus: "Plus", 
          pro: "Pro",
          business: "Business",
          perMonth: "/month",
          perYear: "/year",
          annualBilling: "Annual billing",
          monthlyBilling: "Monthly billing",
          savePercent: "Save {{percent}}%",
          currentPlan: "Current Plan",
          upgrade: "Upgrade",
          downgrade: "Downgrade",
          mostPopular: "Most Popular"
        },
        features: {
          contracts: "{{count}} contracts",
          contractsLimit: "Up to {{count}} contracts",
          unlimitedContracts: "Unlimited contracts",
          users: "{{count}} users",
          usersLimit: "{{count}} user(s)",
          unlimitedUsers: "Unlimited users",
          documentExtractions: "{{count}} document extractions/month",
          docExtractions: "{{count}} document extractions/month",
          noDocExtraction: "Document extraction",
          erpIntegrations: "{{count}} ERP integration",
          erpLimit: "{{count}} ERP integration(s)",
          noErp: "ERP integrations",
          unlimitedErp: "Unlimited ERP integrations",
          storage: "{{count}} GB storage",
          dashboard: "Dashboard analytics",
          basicDashboard: "Basic dashboard",
          advancedDashboard: "Advanced dashboard widgets",
          customFields: "Custom contract fields",
          contractNotes: "Contract notes & activity log",
          calendarView: "Calendar view",
          duplicateDetection: "Duplicate detection",
          apiRead: "API read access",
          apiWrite: "API write access",
          apiAccess: "API access",
          apiReadAccess: "API read access",
          apiWriteAccess: "API write access",
          prioritySupport: "Priority support",
          reminders: "Email reminders",
          calendarViewRequired: "Calendar view requires a Pro or Business plan"
        }
      },
      subscriptions: {
        mostPopular: "Most Popular",
        currentPlan: "Current Plan",
        selectPlan: "Select Plan",
        perMonth: "month",
        perYear: "year",
        savePercent: "Save {{percent}}%",
        choosePlan: "Choose Your Plan",
        selectBestPlan: "Select a plan that best fits your contract management needs",
        alreadySubscribed: "You are already subscribed to this plan",
        contactToDowngrade: "Please contact support to downgrade to the free plan",
        alreadyOnFree: "You are already on the free plan. Select a paid plan to unlock more features.",
        checkoutOpened: "Checkout opened in a new tab. Complete payment to activate your plan.",
        checkoutFailed: "Failed to start checkout. Please try again.",
        checkoutError: "Failed to start checkout. Please try again.",
        portalError: "Failed to open subscription management. Please try again.",
        confirmChange: "Confirm Plan Change",
        confirmStripeCheckout: "You will be redirected to a secure checkout page to complete your subscription to the {{plan}} plan ({{billing}} billing).",
        currentlyOn: "You are currently on the {{plan}} plan.",
        proceedToCheckout: "Proceed to Checkout",
        updated: "Subscription updated successfully!",
        noPermission: "You don't have permission to update your subscription.",
        unavailable: "The subscription system is currently unavailable.",
        updateFailed: "Failed to update subscription. Please try again.",
        manageSubscription: "Manage Subscription",
        yourSubscription: "Your Subscription",
        onFreePlan: "You are currently on the Free plan",
        noActiveSubscription: "You don't have an active subscription",
        upgradePrompt: "Upgrade to access premium features and get more out of your contract management.",
        viewPlans: "View Plans",
        upgrade: "Upgrade Now",
        activate: "Activate Subscription",
        activeSubscription: "Active subscription",
        subscriptionInfo: "Subscription information",
        price: "Price",
        expired: {
          title: "Subscription Expired",
          message: "Your complimentary subscription has expired. You have been moved to the free plan. Some of your data may be restricted."
        },
        expiring: {
          critical: {
            title: "Subscription Expiring Very Soon!",
            message: "Your complimentary {{planName}} subscription expires in {{days}} days. Activate a paid subscription now to avoid losing access to premium features."
          },
          warning: {
            title: "Subscription Expiring Soon",
            message: "Your complimentary {{planName}} subscription expires in {{days}} days. Consider activating a paid subscription to continue using premium features."
          },
          notice: {
            title: "Subscription Notice",
            message: "Your complimentary {{planName}} subscription expires in {{days}} days."
          }
        },
        billingInfo: "Billing Info",
        billingPeriod: "Billing Period",
        active: "Active",
        expiringSoon: "Your subscription will expire soon on {{date}}.",
        activatedFeatures: "Activated Features",
        viewAvailablePlans: "View Available Plans",
        paymentSuccess: "Payment successful! Your subscription is now active.",
        paymentCanceled: "Payment was canceled. Your subscription remains unchanged.",
        addonPurchaseSuccess: "Purchase successful! {{count}} extraction credits have been added to your account.",
        addonPaymentCanceled: "Add-on purchase was canceled.",
        features: {
          unlimitedContracts: "Unlimited contracts",
          contractsLimit: "Up to {{count}} contracts",
          unlimitedUsers: "Unlimited users",
          usersLimit: "{{count}} user(s)",
          unlimitedErp: "Unlimited ERP integrations",
          erpLimit: "{{count}} ERP integration(s)",
          noErp: "ERP integrations",
          docExtractions: "{{count}} document extractions/month",
          noDocExtraction: "Document extraction",
          dashboard: "Dashboard analytics",
          advancedDashboard: "Advanced dashboard widgets",
          customFields: "Custom contract fields",
          contractNotes: "Contract notes & activity log",
          duplicateDetection: "Duplicate detection",
          calendarView: "Calendar view",
          apiRead: "API read access",
          apiWrite: "API write access",
          apiAccess: "API access",
          reminders: "Email reminders",
          dataHealth: "Data health monitoring"
        }
      },
      dataHealth: {
        title: "Data Health",
        pageTitle: "Data Health",
        pageDescription: "Monitor and improve the quality of your contract data",
        refresh: "Refresh",
        issues: "Issues",
        recommendations: "Recommendations",
        categories: "Categories",
        lastUpdated: "Last updated",
        tabOverview: "Overview",
        tabIssues: "Issues",
        tabRecommendations: "Recommendations",
        issuesTitle: "Data Quality Issues",
        issuesDescription: "Review and fix these issues to improve your data quality score",
        noIssuesTitle: "No issues found!",
        noIssuesDescription: "Your data quality is excellent",
        noRecommendationsTitle: "Great job!",
        noRecommendationsDescription: "No additional recommendations at this time",
        issuesFound: "issues found",
        noIssues: "No issues found",
        viewDetails: "View Details",
        scoreExcellent: "Excellent",
        scoreGood: "Good",
        scoreNeedsWork: "Needs Work",
        scorePoor: "Poor",
        errorLoading: "Error loading data health",
        errorDescription: "Unable to calculate your data health score",
        issue: "issue",
        issuesPlural: "issues",
        // Category names
        categorySupplierData: "Vendor Data",
        categorySupplierDataDesc: "Organization number and vendor information",
        categoryDocumentArchive: "Document Archive",
        categoryDocumentArchiveDesc: "Contract documents and attachments",
        categoryCategorization: "Categorization",
        categoryCategorizationDesc: "Categories and contract types",
        categoryErpConnection: "ERP Connection",
        categoryErpConnectionDesc: "Connection to ERP system for automatic tracking",
        categoryContacts: "Contact Persons",
        categoryContactsDesc: "Contact persons linked to contracts",
        // Issue descriptions
        issueMissingOrgNumber: "{contractName} is missing organization number",
        actionMissingOrgNumber: "Add organization number for better traceability and matching",
        issueMissingCategory: "{contractName} is missing category",
        actionMissingCategory: "Categorize the contract for better reporting",
        issueMissingAttachment: "{contractName} has no attachments",
        actionMissingAttachment: "Upload the contract document for documentation",
        issueMissingErpConnection: "{contractName} is not connected to ERP",
        actionMissingErpConnection: "Connect the contract to ERP for automatic cost tracking",
        issueMissingContractType: "{contractName} is missing contract type",
        actionMissingContractType: "Select contract type for better categorization",
        // Issue type labels
        issueType: {
          missing_org_number: "Missing org number",
          missing_category: "Missing category",
          missing_attachment: "Missing attachment",
          missing_erp_connection: "Missing ERP",
          missing_contract_type: "Missing type"
        },
        // Recommendations
        recOrgNumbersTitle: "Add organization numbers",
        recOrgNumbersDesc: "More than half of the contracts are missing organization numbers. This is important for vendor matching and reporting.",
        recAttachmentsTitle: "Upload contract documents",
        recAttachmentsDesc: "Most contracts are missing attached documents. Upload PDFs for better documentation and AI extraction.",
        recErpTitle: "Connect contracts to ERP",
        recErpDesc: "Connect more contracts to ERP for automatic cost tracking and budget alerts.",
        recViewContracts: "View contracts",
        recGoToIntegrations: "Go to integrations",
        // Impact labels
        impact: {
          high: "High impact",
          medium: "Medium impact",
          low: "Low impact"
        },
        // Contract-level data health
        contractScore: "Data Health",
        contractScoreTooltip: "Data completeness score for this contract",
        allChecksPassed: "All data health checks passed",
        checkOrgNumber: "Missing organization number",
        checkCategory: "Missing category",
        checkAttachment: "Missing attachment",
        checkContractType: "Missing contract type",
        checkErpConnection: "Missing ERP connection"
      },
      // Portfolio Assessment
      portfolioAssessment: {
        title: "Portfolio Assessment",
        description: "Comprehensive overview of your contract portfolio health",
        maturityScore: "Contract Maturity Score",
        outOf: "out of 100",
        scoreExcellent: "Excellent",
        scoreGood: "Good",
        scoreFair: "Fair",
        scorePoor: "Needs Improvement",
        dataQuality: "Data Quality",
        riskCoverage: "Risk Coverage",
        riskScore: "Risk Score",
        costAdoption: "Cost Optimization",
        erpIntegration: "ERP Integration",
        executiveSummary: "Executive Summary",
        activeContracts: "Active Contracts",
        totalContractsSub: "{{count}} total",
        annualSpend: "Annual Spend",
        expenseContracts: "Expense contracts",
        annualRevenue: "Annual Revenue",
        incomeContracts: "Income contracts",
        categoryCoverage: "Category Coverage",
        contractsCategorized: "Contracts categorized",
        riskExposure: "Risk Exposure",
        analyzed: "Analyzed",
        avgRiskScore: "Avg Risk Score",
        highCritical: "High/Critical",
        savingsPotential: "Savings Potential",
        potentialSavings: "Potential Savings",
        realized: "Realized",
        implemented: "implemented",
        pending: "pending",
        keyFindings: "Key Findings",
        expirationTimeline: "Expiration Timeline",
        days: "days",
        noExpirations: "No contracts expiring in this period",
        noData: "No contract data available",
        generateReport: "Generate PDF Report",
        shareReport: "Share Report",
        findingHighRiskTitle: "High/critical risk contracts detected",
        findingHighRiskDesc: "Contracts flagged with high or critical risk levels require attention.",
        findingSavingsTitle: "Potential savings identified",
        findingSavingsDesc: "Cost optimization analysis has identified potential savings across your contracts.",
        findingDataQualityTitle: "Data quality needs improvement",
        findingDataQualityDesc: "Improving data quality will increase portfolio maturity.",
        findingExpiringSoonTitle: "Contracts expiring within 30 days",
        findingExpiringSoonDesc: "These contracts require immediate attention for renewal or renegotiation.",
        findingErpCoverageTitle: "Low ERP integration coverage",
        findingErpCoverageDesc: "Connecting more contracts to ERP data improves cost tracking accuracy.",
        shareTitle: "Share Assessment Report",
        shareDescription: "Create a time-limited link that anyone can use to view this report without logging in.",
        shareLinkExpiry: "Link expires after",
        shareExpiry24h: "24 hours",
        shareExpiry72h: "3 days",
        shareExpiry7d: "7 days",
        shareExpiry30d: "30 days",
        shareGenerate: "Generate Share Link",
        shareLinkLabel: "Share link",
        shareLinkCopied: "Link copied to clipboard",
        shareLinkCreated: "Share link created successfully",
        shareError: "Failed to generate share link",
        shareAuthError: "Authentication required",
        shareExpiresAt: "Expires",
        // Benchmark & Trend
        industryBenchmark: "Industry Benchmark",
        yourScore: "Your score",
        industryAvg: "Industry avg",
        scoreTrend: "Score Trend",
        sinceStart: "since start",
        trendNoData: "Score history will appear here after your next assessment. Scores are recorded daily.",
        // AI Summary
        aiSummary: "AI Executive Summary",
        aiGenerate: "Generate Summary",
        aiRegenerate: "Regenerate",
        aiSummaryHint: "Click \"Generate Summary\" to create an AI-powered executive summary of your portfolio assessment.",
        aiGenerating: "Analyzing portfolio data...",
        aiSummaryError: "Could not generate summary. Please try again.",
        // Scenario Simulator
        scenarioTitle: "Scenario Simulator",
        scenarioDesc: "Adjust revenue and costs to explore what-if scenarios",
        scenarioReset: "Reset",
        scenarioRevenue: "Revenue Adjustment",
        scenarioCost: "Cost Adjustment",
        scenarioCurrent: "Current Profit",
        scenarioSimulated: "Simulated Profit",
        scenarioChange: "Change",
        scenarioGoalTitle: "AI Goal Analysis",
        scenarioGoalDesc: "Set a profit target and let AI analyze your portfolio to suggest how to achieve it.",
        scenarioGoalLabel: "Target Annual Profit (NOK)",
        scenarioYears: "Years",
        scenarioAnalyze: "Analyze",
        scenarioEnterGoal: "Please enter a valid profit goal",
        scenarioError: "Could not generate analysis. Please try again.",
        aiRateLimit: "Rate limit exceeded. Please try again later.",
        aiAnalysisGenerated: "AI analysis generated — {{count}} strategic areas identified",
        aiPaymentRequired: "AI credits depleted. Please add credits.",
        scenarioInclUnlinked: "incl. {{amount}} unlinked",
      },
      sharedReport: {
        sharedAssessment: "Shared Portfolio Assessment",
        generatedOn: "Generated",
        poweredBy: "Powered by Subtrackr — Contract Management Platform",
        expiredTitle: "Report Link Expired",
        expiredDesc: "This report link has expired. Please request a new link from the report owner.",
        revokedTitle: "Report Link Revoked",
        revokedDesc: "This report link has been revoked by the owner.",
        notFoundTitle: "Report Not Found",
        notFoundDesc: "This report could not be found. The link may be invalid.",
        errorTitle: "Something went wrong",
        errorDesc: "An error occurred while loading the report. Please try again later.",
      },
      // Advisor Access
      advisorAccess: {
        title: "Advisor Access",
        description: "Invite external consultants or investors to review your contract portfolio with read-only access.",
        inviteAdvisor: "Invite Advisor",
        email: "Email address",
        accessLevel: "Access level",
        readOnly: "Read-only",
        analyst: "Analyst (read + analyze)",
        accountant: "Accountant",
        auditor: "Auditor",
        duration: "Access duration",
        days30: "30 days",
        days60: "60 days",
        days90: "90 days",
        sendInvite: "Send Invitation",
        inviteSent: "Invitation sent successfully",
        inviteError: "Failed to send invitation",
        currentAdvisors: "Current Advisors",
        noAdvisors: "No advisors have been invited yet.",
        expiresOn: "Expires",
        active: "Active",
        pending: "Pending",
        expired: "Expired",
        revoked: "Revoked",
        revokeTitle: "Revoke Advisor Access",
        revokeDescription: "Are you sure you want to revoke access for {{email}}? They will immediately lose access to your contract portfolio.",
        revokeConfirm: "Revoke Access",
        revokeError: "Failed to revoke access",
        acceptSuccess: "Invitation Accepted!",
        acceptSuccessDesc: "You now have advisor access to review the contract portfolio.",
        acceptError: "Invitation Error",
        goToDashboard: "Go to Advisor Dashboard",
      },
      advisorDashboard: {
        title: "Advisor Dashboard",
        description: "Read-only view of the contract portfolio",
        selectWorkspace: "Select workspace",
        loadingClient: "Loading client…",
        clientNumber: "Client {{number}}",
        memberBadge: "Member ({{role}})",
        noAccess: "No Active Advisor Access",
        noAccessDesc: "You don't have any active advisor engagements. Ask a workspace owner to invite you.",
      },
      bureauCockpit: {
        nav: "Cockpit",
        title: "Bureau Contract Cockpit",
        subtitle: "Cross-client contract and spend overview for your advisory portfolio.",
        loadingClients: "Loading client data…",
        noAccessTitle: "No Active Client Engagements",
        noAccessDesc: "The Bureau Cockpit aggregates contract data across every client workspace you have active advisor access to. Ask a workspace owner to invite you as an advisor to get started.",
        clientFallback: "Client",
        kpi: {
          clients: "Clients",
          contractsAcross: "{{count}} contracts across portfolio",
          totalSpend: "Total annual spend",
          aggregated: "Aggregated across all clients",
          savings: "Potential savings",
          savingsDesc: "AI-identified across all client portfolios",
          maturity: "Avg. maturity score",
          maturityScale: "Out of 100",
        },
        renewals: {
          title: "Upcoming renewals across clients",
          next30: "Next 30 days",
          next60: "Next 60 days",
          next90: "Next 90 days",
        },
        risk: {
          title: "Clients with high-risk contracts",
          ofTotal: "of {{total}} clients",
          desc: "Clients with one or more contracts flagged as high or critical risk.",
        },
        table: {
          title: "Client portfolio",
          search: "Search clients…",
          client: "Client",
          contracts: "Contracts",
          spend: "Annual spend",
          savings: "Savings",
          maturity: "Maturity",
          expiring30: "Exp. 30d",
          empty: "No clients match your filter.",
          open: "Open client dashboard",
        },
        toolsDesc: "Cross-workspace contract & spend overview",
        badge: {
          multiEntity: "Multi-entity",
        },
        source: {
          member: "Member ({{role}})",
        },
      },
      // Tripletex Token Help Dialog
      tripletexHelp: {
        howToCreateToken: "How to create an employee token?",
        title: "How to create an API employee token in Tripletex",
        description: "Follow these steps to create an employee token for connecting Subtrackr to your Tripletex account.",
        intro: "To connect an integration to Tripletex, you use a unique API employee token. The token is created on an employee or contact in the company and given to the integration partner.",
        accessNote: "The token can only have the same or less access to the system as the user you create the token on has. Additionally, you must be a user admin to see the \"API Access\" tab.",
        stepsTitle: "How to create an API employee token:",
        step1: "Go to \"Payroll > Employees\" or \"Customer > Contacts\" in the main menu, and select the user you want to register the token on.",
        step2: "Select the \"API Access\" tab. You can also find this tab on yourself.",
        step3: "Register a token by clicking \"New Token\".",
        setupTitle: "Token setup:",
        setup1: "Select the integration in the \"Application\" field. If you find the integration in the dropdown, you can continue to step 4. If you do NOT find the application, continue to steps 2 and 3.",
        setup2: "Check \"Custom Setup\" and select what type of access you want to give the integration.",
        setup3: "Enter the application name in the \"Application Name\" field. Make sure to type it exactly as shown below, paying attention to uppercase and lowercase letters:",
        setup4: "Enter what you want to call the integration in the \"Give the token a name\" field.",
        setup5: "Click \"Create Token\" to generate the unique employee token.",
        accessOptionsTitle: "Access options:",
        allAccess: "All Access",
        allAccessDesc: "This option gives the token all access, but will be limited to the access the user has. In this case, you must give the user more access, or choose another user with the access the token needs.",
        userAccess: "Give token this user's access",
        userAccessDesc: "This option gives the token all access that the user has at the time the token is created.",
        customAccess: "Decide yourself",
        customAccessDesc: "This option gives no access to the integration. You can add access to the integration afterwards.",
        importantNote: "Important: The employee token is only shown once. You are responsible for keeping it safe.",
        officialDocs: "View official Tripletex documentation",
        copied: "Copied!",
        copiedDescription: "Application name copied to clipboard"
      },
      pricing: {
        title: "Simple, Transparent Pricing",
        subtitle: "Choose the plan that fits your needs",
        monthly: "Monthly",
        annual: "Annual",
        mostPopular: "Most Popular",
        getStarted: "Get Started",
        subscribe: "Subscribe Now",
        question: "Need a custom solution for your business?",
        contactUs: "Contact us",
        year: "year",
        month: "month"
      },
      addOns: {
        buyExtractions: "Buy Document Extractions",
        extractionsDescription: "Purchase additional document extraction credits that never expire.",
        extractionsCount: "{{count}} Extractions",
        perExtraction: "extraction",
        buySignings: "Buy Signing Credits",
        signingsDescription: "Purchase additional e-signature credits that never expire.",
        signingsCount: "{{count}} Signings",
        perSigning: "signing",
        bestValue: "Best Value",
        purchase: "Purchase",
        stripeRequired: "Payment processing requires Stripe integration. Please contact support.",
        purchaseFailed: "Failed to process purchase. Please try again.",
        redirectingToCheckout: "Redirecting to checkout...",
        simulatedPurchaseSuccess: "Development mode: {{credits}} signing credits added (no charge)"
      },
      customPlan: {
        title: "Build Your Custom Plan",
        subtitle: "Select exactly the features you need and pay only for what you use.",
        yourPlan: "Your Custom Plan",
        selectFeatures: "Select features to build your plan",
        includedFree: "Included Free",
        paidFeatures: "Paid Features",
        monthlyTotal: "Monthly Total",
        annualTotal: "Annual Total",
        saving: "Saving {{amount}} compared to monthly",
        perMonth: "{{amount}}/month",
        proceedToCheckout: "Proceed to Checkout",
        processing: "Processing...",
        checkoutError: "Failed to start checkout. Please try again.",
        loadError: "Failed to load features. Please refresh the page.",
        updatePlan: "Update Plan",
        updateSuccess: "Your plan has been updated successfully!",
        updateError: "Failed to update plan. Please try again.",
        currentPlan: "Current Plan",
        modifyPlan: "Modify Plan",
        core: "Core",
        free: "Free",
        requires: "Requires",
        requiredBy: "Required by: {{features}}",
        requiresFirst: "First select: {{features}}",
        save: "Save 17%",
        categories: {
          core: {
            name: "Core Features",
            description: "Essential contract management features"
          },
          analytics: {
            name: "Analytics & Insights",
            description: "Understand your contracts and costs"
          },
          integrations: {
            name: "Integrations",
            description: "Connect with your existing systems"
          },
          advanced: {
            name: "Advanced Features",
            description: "Power features for demanding users"
          },
          api: {
            name: "API Access",
            description: "Programmatic access to your data"
          }
        },
        features: {
          contract_management: {
            name: "Contract Management",
            description: "Basic contract management with all standard features"
          },
          dashboard: {
            name: "Dashboard",
            description: "Visual overview of all contracts and key metrics"
          },
          reminders: {
            name: "Reminders",
            description: "Email notifications before contract renewals"
          },
          advanced_dashboard: {
            name: "Advanced Dashboard",
            description: "Extended analytics and charts for better insights"
          },
          sales_analytics: {
            name: "Sales Analytics",
            description: "Complete sales analysis with orders and customer data"
          },
          cost_optimization: {
            name: "Cost Optimization",
            description: "AI-driven suggestions to reduce costs"
          },
          erp_integration: {
            name: "ERP Integration",
            description: "Connect to Tripletex, Finago and other ERP systems"
          },
          document_extraction: {
            name: "Document Extraction",
            description: "AI-driven extraction of data from PDF contracts"
          },
          custom_fields: {
            name: "Custom Fields",
            description: "Add custom fields to contracts"
          },
          calendar_view: {
            name: "Calendar View",
            description: "View all contract deadlines in calendar format"
          },
          contract_notes: {
            name: "Contract Notes",
            description: "Add notes and activity log to contracts"
          },
          duplicate_detection: {
            name: "Duplicate Detection",
            description: "Automatic alerts about possible duplicates"
          },
          api_read: {
            name: "API Read Access",
            description: "Programmatic access to read data"
          },
          api_write: {
            name: "API Write Access",
            description: "Programmatic access to create and modify data"
          }
        }
      },
      attachments: {
        title: "Attachments",
        description: "Documents related to this contract",
        upload: "Upload",
        uploading: "Uploading...",
        noAttachments: "No attachments uploaded",
        addAttachments: "Add attachments",
        view: "View",
        download: "Download",
        downloading: "Downloading",
        opening: "Opening",
        downloadError: "Failed to download file. Please try again.",
        openError: "Could not open the file. Please try downloading instead.",
        uploadSuccess: "Files uploaded successfully",
        uploadError: "Failed to upload files. Please try again.",
        uploadFileError: "Error uploading file",
        saveError: "Error saving attachment",
        authError: "You must be logged in to upload files.",
        delete: "Delete",
        deleting: "Deleting...",
        deleteTitle: "Delete attachment",
        deleteConfirm: "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
        deleteSuccess: "Attachment deleted successfully",
        deleteError: "Failed to delete attachment"
      },
      // Security & Compliance Page
      security: {
        title: "Security & Compliance",
        subtitle: "How we protect your data and meet enterprise requirements",
        protected: "Protected",
        architecture: {
          title: "Platform Architecture",
          description: "Subtrackr is a modern cloud-native application built on industry-leading infrastructure."
        },
        dataProtection: {
          title: "Data Protection",
          encryption: "Encryption",
          encryptionText: "All data is encrypted in transit (TLS 1.3) and at rest (AES-256). Database connections use SSL enforcement.",
          tenantIsolation: "Tenant Isolation",
          tenantIsolationText: "PostgreSQL Row-Level Security (RLS) policies enforce strict data isolation between customers at the database level. Every table has RLS policies tied to the authenticated user.",
          authentication: "Authentication",
          authenticationText: "JWT-based authentication with automatic token refresh. Sessions expire after 1 hour with seamless renewal. Passwords are hashed using bcrypt.",
          backups: "Backups",
          backupsText: "Automated daily database backups with point-in-time recovery. Infrastructure managed by Supabase with built-in redundancy."
        },
        appSecurity: {
          title: "Application Security",
          xss: "Cross-Site Scripting (XSS)",
          xssText: "React automatically escapes all rendered content via the Virtual DOM. The application has virtually no use of dangerouslySetInnerHTML, and where it exists it processes only internal CSS variables with no user input.",
          sqli: "SQL Injection",
          sqliText: "All database access uses the Supabase SDK with parameterized queries and PostgreSQL RPC functions. No raw SQL is ever constructed from user input.",
          ddos: "DDoS Protection",
          ddosText: "Infrastructure-level DDoS mitigation is provided by our hosting platform (Supabase on AWS), including automatic traffic filtering and rate limiting."
        },
        sso: {
          title: "SSO & Access Control",
          description: "Subtrackr supports enterprise Single Sign-On (SSO) via SAML 2.0, enabling integration with identity providers such as Duo, Okta, Azure AD, and others. SSO is available as an enterprise add-on.",
          supported: "Supported Authentication Methods",
          emailPassword: "Email & password authentication",
          magicLink: "Magic link (passwordless) authentication",
          saml: "SAML 2.0 SSO (Enterprise — Duo, Okta, Azure AD)"
        },
        compliance: {
          title: "Compliance & Certifications",
          soc2: "SOC 2 Type II",
          soc2Text: "Our infrastructure provider (Supabase) maintains SOC 2 Type II compliance, covering security, availability, and confidentiality controls. Subtrackr inherits these infrastructure-level controls.",
          gdpr: "GDPR",
          gdprText: "Subtrackr is designed with GDPR compliance in mind. Users can export and delete their data. We process only the data necessary to provide the service."
        },
        dataResidency: {
          title: "Data Residency",
          description: "Customer data is stored in the Supabase project region. Enterprise customers can request region-specific deployments to meet data residency requirements (e.g., US-only or EU-only).",
          contact: "For specific data residency requirements, please contact us at security@subtrackr.com."
        },
        businessContinuity: {
          title: "Business Continuity & Availability",
          description: "Subtrackr is built on highly available cloud infrastructure with automated failover and redundancy. Our platform leverages Supabase (hosted on AWS) which provides multi-AZ deployments and automatic recovery.",
          uptimeTarget: "Uptime Target",
          rpo: "Recovery Point Objective",
          rto: "Recovery Time Objective"
        },
        contact: {
          title: "Security Questions?",
          description: "For security-related questions, vulnerability reports, or to request our full security documentation package, please contact our security team."
        }
      },
      // SLA Terms
      'terms.sla': '8. Service Level Agreement (SLA)',
      'terms.slaText': 'Subtrackr targets 99.9% platform availability measured on a monthly basis, excluding scheduled maintenance windows. Scheduled maintenance will be communicated at least 48 hours in advance.',
      'terms.slaSupport': 'Support response times: Critical issues — 4 business hours. Standard issues — 1 business day. General inquiries — 2 business days.',
      'terms.slaEnterprise': 'Enterprise customers may negotiate custom SLA terms, including enhanced uptime guarantees and dedicated support, as part of their subscription agreement.',

      // Demo Data
      'demo.bannerMessage': 'You\'re viewing demo data. Ready to start for real?',
      'demo.goLive': 'Go Live',
      'demo.confirmTitle': 'Switch to Live Mode?',
      'demo.confirmDescription': 'All demo data (contracts, vendors, contacts) will be permanently removed. Your account settings, categories, and currencies will be kept. This action cannot be undone.',
      'demo.confirmAction': 'Yes, Go Live',

      // Environment Setup Screen
      'setup.title': 'Setting up your environment',
      'setup.subtitle': 'We\'re preparing demo data so you can explore the platform right away.',
      'setup.stepDefaults': 'Setting up currencies & categories...',
      'setup.stepSuppliers': 'Creating demo vendors & contacts...',
      'setup.stepContracts': 'Generating sample contracts...',
      'setup.stepDone': 'All done!',

      // Governing Documents
      'govDocs.title': 'Governing Documents',
      'govDocs.subtitle': 'Manage procedures, instructions, guidelines and risk assessments',
      'govDocs.newDocument': 'New Document',
      'govDocs.editDocument': 'Edit Document',
      'govDocs.manageTypes': 'Document Types',
      'govDocs.documentTypes': 'Document Types',
      'govDocs.noDocuments': 'No documents yet',
      'govDocs.noDocumentsDesc': 'Create your first governing document to start managing your document lifecycle.',
      'govDocs.createFirst': 'Create your first document',
      'govDocs.searchPlaceholder': 'Search documents...',
      'govDocs.allStatuses': 'All Statuses',
      'govDocs.status.draft': 'Draft',
      'govDocs.status.inReview': 'In Review',
      'govDocs.status.inHearing': 'In Hearing',
      'govDocs.status.approved': 'Approved',
      'govDocs.status.active': 'Active',
      'govDocs.status.revisionNeeded': 'Revision Needed',
      'govDocs.status.archived': 'Archived',
      'govDocs.status.superseded': 'Superseded',
      'govDocs.overdueRevisions': 'Overdue Revisions',
      'govDocs.overdueCount': '{{count}} document(s) need revision',
      'govDocs.upcomingRevisions': 'Upcoming Revisions',
      'govDocs.upcomingCount': '{{count}} document(s) due within 30 days',
      'govDocs.overdue': 'Overdue',
      'govDocs.dueSoon': 'Due Soon',
      'govDocs.nextRevision': 'Next revision',
      'govDocs.deleted': 'Document deleted',
      'govDocs.deleteError': 'Failed to delete document',
      'govDocs.confirmDelete': 'Delete document?',
      'govDocs.confirmDeleteDesc': 'This action cannot be undone.',
      'govDocs.documentDetails': 'Document Details',
      'govDocs.titleLabel': 'Title',
      'govDocs.titlePlaceholder': 'e.g. Safety Procedures Manual',
      'govDocs.documentNumber': 'Document Number',
      'govDocs.documentType': 'Document Type',
      'govDocs.selectType': 'Select type',
      'govDocs.statusLabel': 'Status',
      'govDocs.description': 'Description',
      'govDocs.ownershipRevision': 'Ownership & Revision',
      'govDocs.tabs.details': 'Details',
      'govDocs.tabs.attachments': 'Attachments',
      'govDocs.tabs.workflow': 'Workflow',
      'govDocs.tabs.history': 'History',
      'govDocs.tabs.links': 'Links',
      'govDocs.ownerName': 'Document Owner',
      'govDocs.ownerEmail': 'Owner Email',
      'govDocs.revisionInterval': 'Revision Interval (months)',
      'govDocs.titleRequired': 'Title is required',
      'govDocs.created': 'Document created',
      'govDocs.updated': 'Document updated',
      'govDocs.saveError': 'Failed to save document',
      'govDocs.notFound': 'Document not found',
      'govDocs.newType': 'New Type',
      'govDocs.createType': 'Create Document Type',
      'govDocs.typeName': 'Name',
      'govDocs.typeNamePlaceholder': 'e.g. Procedure, Instruction, Guideline',
      'govDocs.typeDescription': 'Description',
      'govDocs.lifecycleType': 'Lifecycle Type',
      'govDocs.simple': 'Simple',
      'govDocs.advanced': 'Advanced',
      'govDocs.defaultRevisionInterval': 'Default Revision Interval (months)',
      'govDocs.requiresHearing': 'Requires Hearing',
      'govDocs.requiresApproval': 'Requires Approval',
      'govDocs.typeCreated': 'Document type created',
      'govDocs.typeCreateError': 'Failed to create type',
      'govDocs.typeDeleted': 'Document type deleted',
      'govDocs.typeDeleteError': 'Failed to delete type',
      'govDocs.typeNameRequired': 'Type name is required',
      'govDocs.noTypes': 'No document types defined. Create one to categorize your governing documents.',
      'govDocs.revisionEvery': 'Revision every {{months}} months',
      'govDocs.hearing': 'Hearing',
      'govDocs.approval': 'Approval',
      'govDocs.versionHistory': 'Version History',
      'govDocs.newRevision': 'New Revision',
      'govDocs.createRevision': 'Create New Revision',
      'govDocs.currentVersionLabel': 'Current version: v{{version}} → v{{next}}',
      'govDocs.changeDescription': 'Change Description',
      'govDocs.changeDescPlaceholder': 'Describe what was changed in this revision...',
      'govDocs.revisionCreated': 'Revision v{{version}} created',
      'govDocs.revisionError': 'Failed to create revision',
      'govDocs.noRevisions': 'No revisions yet. The document is on its initial version.',
      'govDocs.notifications.newRevision': 'Document Revised',
      'govDocs.notifications.newRevisionMsg': 'A governing document has been revised to version {{version}}',

      // Governing Documents - Attachments
      'govDocs.attachments.title': 'Attachments',
      'govDocs.attachments.upload': 'Upload',
      'govDocs.attachments.uploaded': 'File uploaded',
      'govDocs.attachments.uploadError': 'Failed to upload file',
      'govDocs.attachments.deleted': 'File deleted',
      'govDocs.attachments.deleteError': 'Failed to delete file',
      'govDocs.attachments.tooLarge': 'File "{{name}}" exceeds 20MB limit',
      'govDocs.attachments.empty': 'No attachments yet. Upload PDF, Word, or Excel files.',

      // Governing Documents - Approvals
      'govDocs.approvals.title': 'Approval Workflow',
      'govDocs.approvals.empty': 'No approvers assigned yet.',
      'govDocs.approvals.added': 'Approver added',
      'govDocs.approvals.addError': 'Failed to add approver',
      'govDocs.approvals.addApprover': 'Add Approver',
      'govDocs.approvals.addBtn': 'Add',
      'govDocs.approvals.approverName': 'Name',
      'govDocs.approvals.approverEmail': 'Email',
      'govDocs.approvals.comment': 'Comment (optional)',
      'govDocs.approvals.approve': 'Approve',
      'govDocs.approvals.reject': 'Reject',
      'govDocs.approvals.approvedSuccess': 'Approved',
      'govDocs.approvals.rejectedSuccess': 'Rejected',
      'govDocs.approvals.respondError': 'Failed to respond',
      'govDocs.approvals.submitForReview': 'Submit for Review',
      'govDocs.approvals.submitted': 'Document submitted for review',
      'govDocs.approvals.submitError': 'Failed to submit',
      'govDocs.approvals.allApproved': 'All approvers approved — document status set to Approved',
      'govDocs.approvals.status.pending': 'Pending',
      'govDocs.approvals.status.approved': 'Approved',
      'govDocs.approvals.status.rejected': 'Rejected',

      // Governing Documents - Read Confirmations
      'govDocs.readConfirm.title': 'Read Confirmations',
      'govDocs.readConfirm.count': '{{count}} confirmation(s) for v{{version}}',
      'govDocs.readConfirm.markAsRead': 'Mark as Read',
      'govDocs.readConfirm.confirmed': 'Reading confirmed',
      'govDocs.readConfirm.error': 'Failed to confirm',
      'govDocs.readConfirm.alreadyConfirmed': 'You have confirmed reading this version',

      // Governing Documents - Contract Links
      'govDocs.contracts.title': 'Linked Contracts',
      'govDocs.contracts.link': 'Link',
      'govDocs.contracts.linked': 'Contract linked',
      'govDocs.contracts.linkError': 'Failed to link contract',
      'govDocs.contracts.unlinked': 'Contract unlinked',
      'govDocs.contracts.unlinkError': 'Failed to unlink contract',
      'govDocs.contracts.searchPlaceholder': 'Search contracts by vendor...',
      'govDocs.contracts.empty': 'No linked contracts.',
    }
  },
  es: {
    common: {
      // Header & Quick Settings
      'header.quickSettings': 'Configuración Rápida',
      'header.theme': 'Tema',
      'header.translationMode': 'Modo de Traducción',
      'header.exitTranslationMode': 'Salir del Modo de Traducción',
      'header.notifications': 'Notificaciones',
      'header.erpNotifications': 'Notificaciones ERP',
      'header.testNotifications': 'Notificaciones de Prueba',
      'header.adminPanel': 'Panel de Administración',
      'header.testerArea': 'Área de Pruebas',
      'header.userMenu': 'Menú de Usuario',
      'changelog.title': 'Registro de cambios',
      'changelog.subtitle': 'Mira las novedades y mejoras',
      'changelog.loading': 'Cargando registro de cambios...',
      'changelog.empty': 'Aún no hay registros de cambios.',
      'changelog.newRelease': '{{count}} cambios en esta versión',
      'changelog.viewAll': 'Ver todos los registros de cambios',
      'notifications.markAllRead': 'Marcar todo como leído',
      'notifications.clearRead': 'Limpiar leídas',
      'notifications.loading': 'Cargando notificaciones...',
      'notifications.empty': 'Sin notificaciones',
      'theme.light': 'Claro',
      'theme.dark': 'Oscuro',
      'theme.system': 'Auto',
      'onboarding.gettingStarted': 'Empezar',
      'onboarding.tooltip': 'Haz un recorrido guiado por la app',
      'user.inviteUser': 'Invitar Usuario',
      
      // Navigation - Custom Plan
      'nav.yourFeatures': 'Tus Funciones',
      'nav.account': 'Cuenta',
      'nav.dashboard': 'Panel',
      'nav.contracts': 'Contratos',
      'nav.allContracts': 'Todos los Contratos',
      'nav.allContractsDesc': 'Ver y gestionar contratos',
      'nav.newContract': 'Nuevo Contrato',
      'nav.newContractDesc': 'Crear un nuevo contrato',
      'nav.categories': 'Categorías',
      'nav.categoriesDesc': 'Organizar contratos',
      'nav.services': 'Servicios',
      'nav.servicesDesc': 'Gestionar servicios de contratos',
      'nav.salesAnalytics': 'Análisis de Ventas',
      'nav.costOptimization': 'Optimización de Costos',
      'nav.erpIntegration': 'Integración ERP',
      'nav.documentExtraction': 'Extracción de Documentos',
      'nav.customFields': 'Campos Personalizados',
      'nav.calendarView': 'Calendario',
      'nav.apiPortal': 'Portal API',
      'nav.settings': 'Configuración',
      'nav.help': 'Ayuda',
      
      // Legacy Navigation keys
      contracts: 'Contratos',
      categories: 'Categorías',
      contacts: 'Contactos',
      contractTypes: 'Tipos de Contrato',
      currencies: 'Monedas',
      
      // Actions
      add: 'Añadir',
      edit: 'Editar',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      save: 'Guardar',
      create: 'Crear',
      update: 'Actualizar',
      continue: 'Continuar',
      assign: 'Asignar',
      updating: 'Actualizando...',
      createAndAssign: 'Crear y Asignar',
      
      // States
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      saving: 'Guardando...',
      
      // Contract related
      supplier: 'Proveedor',
      expiryDate: 'Fecha de Vencimiento',
      signedDate: 'Fecha de Firma',
      category: 'Categoría',
      type: 'Tipo',
      importance: 'Importancia',
      expectedCost: 'Costo Esperado',
      expectedIncome: 'Ingreso Esperado',
      value: 'Valor',
      currency: 'Moneda',
      actions: 'Acciones',
      status: 'Estado',
      select: 'Seleccionar',
      selectCategory: 'Seleccionar Categoría',
      selectContractType: 'Seleccionar Tipo de Contrato',
      errorLoadingContract: 'Error al Cargar Contrato',
      contractNotFound: 'No se pudo encontrar el contrato que buscas.',
      backToContracts: 'Volver a Contratos',
      contractType: 'Tipo de Contrato',
      paymentFrequency: 'Frecuencia de Pago',
      oneTime: 'Una vez',
      erpSource: 'ERP',
      erpClient: 'Cliente ERP',
      importedFrom: 'Importado desde',
      addAnother: 'Agregar Otro',
      
      // Contract table UI elements
      searchContracts: 'Buscar contratos...',
      resetFilters: 'Restablecer Filtros',
      settings: 'Configuración',
      updateAllRates: 'Actualizar Todas las Tasas',
      newContract: 'Nuevo Contrato',
      allContracts: 'Todos los Contratos',
      showingXtoYofZ: 'Mostrando {{start}} a {{end}} de {{total}}',
      totalCost: 'Costo total: ',
      totalCostInCurrency: 'Costo total en {{currency}}: ',
      totalIncome: 'Ingreso total: ',
      totalIncomeInCurrency: 'Ingreso total en {{currency}}: ',
      result: 'Resultado: ',
      resultInCurrency: 'Resultado en {{currency}}: ',
      
      // Admin section
      adminDashboard: 'Panel de Administración',
      translations: 'Traducciones',
      manageTranslations: 'Administrar Traducciones',
      
      // User Management
      users: 'Usuarios',
      manageUsers: 'Administrar Usuarios',
      createUser: 'Crear Usuario',
      editUser: 'Editar Usuario',
      deleteUser: 'Eliminar Usuario',
      userCreated: 'Usuario Creado',
      userUpdated: 'Usuario Actualizado',
      userDeleted: 'Usuario Eliminado',
      roles: 'Roles',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      name: 'Nombre',
      
      // Bug Reports
      bugReports: 'Informes de Errores',
      manageBugReports: 'Administrar Informes de Errores',
      newBugReport: 'Nuevo Informe de Error',
      bugReportDetails: 'Detalles del Informe de Error',
      statusChangeSuccess: 'Cambio de Estado Exitoso',
      
      // Email Settings
      emailSettings: 'Configuración de Correo Electrónico',
      configureEmailSettings: 'Configurar la Configuración de Correo Electrónico',
      smtpHost: 'Host SMTP',
      smtpPort: 'Puerto SMTP',
      smtpUser: 'Usuario SMTP',
      smtpPassword: 'Contraseña SMTP',
      senderEmail: 'Correo Electrónico del Remitente',
      testEmail: 'Correo Electrónico de Prueba',
      sendTestEmail: 'Enviar Correo Electrónico de Prueba',
      testEmailSent: 'Correo Electrónico de Prueba Enviado',
      
      // System Settings
      systemSettings: 'Configuración del Sistema',
      generalSettings: 'Configuración General',
      defaultLanguage: 'Idioma Predeterminado',
      
      // Features Settings
      featuresSettings: 'Configuración de Características',
      enableFeature: 'Habilitar Característica',
      disableFeature: 'Deshabilitar Característica',
      
      // Company Register Settings
      companyRegisterSettings: 'Configuración del Registro de la Empresa',
      companyName: 'Nombre de la Empresa',
      companyAddress: 'Dirección de la Empresa',
      companyLogo: 'Logotipo de la Empresa',
      
      // Widget Designer
      widgetDesigner: 'Diseñador de Widgets',
      designYourWidgets: 'Diseña Tus Widgets',
      addWidget: 'Agregar Widget',
      editWidget: 'Editar Widget',
      deleteWidget: 'Eliminar Widget',
      widgetName: 'Nombre del Widget',
      widgetType: 'Tipo de Widget',
      widgetData: 'Datos del Widget',
      
      // Seed Translations
      seedTranslations: 'Sembrar Traducciones',
      seedTranslationsFromDefaults: 'Sembrar Traducciones de los Valores Predeterminados',
      seedingTranslations: 'Sembrando Traducciones',
      translationsSeeded: 'Traducciones Sembradas',
      
      // Translations Manager
      manageApplicationTranslations: 'Administrar Traducciones de la Aplicación',
      addNewLanguage: 'Agregar Nuevo Idioma',
      languageCode: 'Código de Idioma',
      addLanguage: 'Agregar Idioma',
      languageCodeHelp: 'Ingrese un código de idioma de 2 letras (por ejemplo, en, es, fr)',
      localeExists: 'El idioma {{locale}} ya existe',
      localeAdded: 'Idioma {{locale}} agregado',
      addNewTranslationKey: 'Agregar Nueva Clave de Traducción',
      translationKeyPlaceholder: 'Ingrese la clave de traducción',
      valueForLocale: 'Valor para {{locale}}',
      addTranslationKey: 'Agregar Clave de Traducción',
      translationKeyHelp: 'Ingrese una clave única para la traducción',
      translationUpdated: 'Traducción para "{{key}}" en "{{locale}}" actualizada con éxito',
      invalidKey: 'Clave inválida',
      invalidLocaleCode: 'Código de idioma inválido',
      selectLanguage: 'Seleccionar Idioma',
      searchTranslationKeys: 'Buscar Claves de Traducción',
      translationKey: 'Clave de Traducción',
      translationValue: 'Valor',
      noResults: 'Sin Resultados',
      syncingTranslations: 'Sincronizando Traducciones',
      translationsSynced: 'Traducciones Sincronizadas',
      errorSyncingTranslations: 'Error al Sincronizar Traducciones',
      
      // Financial Forecast Widget
      forecast: {
        title: 'Pronóstico Financiero',
        expenses: 'Gastos',
        income: 'Ingresos',
        totalExpenses: 'Gastos Totales',
        totalIncome: 'Ingresos Totales',
        noData: 'No hay datos de pronóstico disponibles para el período seleccionado',
        currencyNote: 'Valores en su moneda predeterminada',
        currencyTooltip: 'Los montos de los contratos se convierten a su moneda predeterminada para mostrar',
        periods: {
          quarter: 'Próximo Trimestre',
          sixMonths: 'Próximos 6 Meses',
          year: 'Próximo Año',
          twoYears: 'Próximos 2 Años'
        }
      },
      
      // Contracts table UI elements
      manageYourContracts: 'Administre todos sus contratos en un solo lugar',
      areYouSure: '¿Está absolutamente seguro?',
      deleteContractsWarning: 'Esta acción no se puede deshacer. Esto eliminará permanentemente los contratos seleccionados de nuestros servidores.',
      assignToGroup: 'Asignar a Grupo',
      removeFromGroup: 'Quitar del Grupo',
      tableSettings: 'Configuración de Tabla',
      configureContractsDisplay: 'Configure cómo se muestran los contratos',
      showGroupedContracts: 'Mostrar Contratos Agrupados',
      displayContractsInGroups: 'Mostrar contratos en sus grupos asignados',
      groupContractsBy: 'Agrupar contratos por',
      groupContractsByDescription: 'Elige cómo se agrupan los contratos en la vista general',
      groupByNone: 'Sin agrupación',
      groupByCustom: 'Grupos personalizados',
      groupByVendor: 'Proveedor',
      groupByType: 'Tipo',
      groupByCategory: 'Categoría',
      groupingPreferenceSaved: 'Preferencia de agrupación guardada',
      columns: 'Columnas',
      customizeColumns: 'Personalizar columnas',
      selectOrCreateGroup: 'Seleccione un grupo existente o cree uno nuevo para asignar los contratos seleccionados.',
      existingGroup: 'Grupo Existente',
      createNewGroup: 'Crear Nuevo Grupo',
      selectAGroup: 'Seleccione un grupo',
      noExistingGroups: 'No se encontraron grupos existentes. Cree un nuevo grupo en su lugar.',
      groupName: 'Nombre del Grupo',
      description: 'Descripción',
      optional: 'opcional',
      enterGroupName: 'Ingrese el nombre del grupo',
      enterGroupDescription: 'Ingrese la descripción del grupo',
      
      // Exchange rates
      noCurrenciesAvailable: 'No hay monedas disponibles',
      exchangeRatesUpdated: 'Todas las tasas de cambio actualizadas con éxito',
      failedToUpdateRates: 'Error al actualizar las tasas de cambio',
      currencyDisclaimer: 'Las conversiones de divisas son estimaciones y pueden no reflejar los tipos de cambio exactos en el momento del pago del contrato.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Panel',
        loading: 'Cargando panel...',
        notAvailable: 'Panel No Disponible',
        upgradeMessage: 'La visualización avanzada del panel no está incluida en su plan de suscripción actual.',
        viewPlans: 'Ver Planes Disponibles',
        upgradeDetails: 'Actualice su plan para obtener acceso a todas las funciones del panel, incluidos los conocimientos financieros, las líneas de tiempo de los contratos, los análisis de distribución y más.',
        
        controls: {
          editLayout: 'Editar Diseño',
          editing: 'Editando',
          addWidget: 'Agregar Widget',
          resetLayout: 'Restablecer Diseño',
          saveLayout: 'Guardar Diseño',
          saving: 'Guardando...',
          saved: '¡Guardado!',
          freePositioning: 'Posicionamiento Libre',
          gridLayout: 'Diseño en Cuadrícula'
        },
        
        widgets: {
          noData: 'Aún no hay datos de contratos',
          populate: 'Su panel se completará con información una vez que agregue contratos al sistema.',
          addFirst: 'Agregue su primer contrato',
          
          totalContracts: 'Contratos Totales',
          acrossCategories: 'En todas las categorías',
          activeContracts: 'Contratos Activos',
          currentlyActive: 'Actualmente activos',
          expiringSoon: 'Vencen Pronto',
          nextDays: 'En los próximos 30 días',
          totalValue: 'Valor Total',
          inUserCurrency: 'En la moneda del usuario',
          calculating: 'Calculando...',
          
          contractsByType: 'Contratos por Tipo',
          contractsTimeline: 'Línea de Tiempo de Contratos',
          hoverInfo: 'Pase el cursor sobre los puntos de datos para ver información detallada',
          contractCount: '{{value}} contratos',
          
          recentContracts: 'Contratos Recientes',
          supplier: 'Proveedor',
          status: 'Estado',
          created: 'Creado',
          actions: 'Acciones',
          noRecentContracts: 'No se encontraron contratos recientes',
          
          upcomingExpirations: 'Próximos Vencimientos',
          expires: 'Vence',
          daysLeft: 'Días Restantes',
          noDaysLeft: '{{count}} días',
          noUpcomingExpirations: 'No hay vencimientos próximos',
          
          contractCostsByType: 'Costos de Contratos por Tipo',
          financialResult: 'Resultado Financiero',
          multiCurrency: 'Conversión de múltiples divisas',
          convertedFrom: 'Convertido de múltiples divisas'
        }
      },
      
      // Contract view page translations
      back: 'Volver',
      contractDetails: 'Detalles del Contrato',
      basicInformation: 'Información Básica',
      supplierDetails: 'Detalles del Proveedor',
      organizationNumber: 'Número de Organización',
      renewalDate: 'Fecha de Renovación',
      renewalTerms: 'Términos de Renovación',
      autoRenews: 'Renovación Automática',
      everyInterval: 'Cada {{interval}} {{unit}}',
      viewTimeline: 'Ver Línea de Tiempo',
      viewCostTimeline: 'Ver Línea de Tiempo de Costos',
      viewIncomeTimeline: 'Ver Línea de Tiempo de Ingresos',
      manageContacts: 'Gestionar Contactos',
      noContacts: 'No hay contactos asociados a este contrato',
      peopleAssociated: 'Personas asociadas a este contrato',
      contactPersons: 'Personas de Contacto',

      // Email related translations
      sendContract: 'Enviar Contrato',
      recipient: 'Destinatario',
      subject: 'Asunto',
      message: 'Mensaje',
      emailAddress: 'Dirección de correo',
      includeAdditionalAttachments: 'Incluir archivos adicionales',
      send: 'Enviar',
      sending: 'Enviando...',
      generatingPdf: 'Generando PDF...',
      emailSent: 'Correo enviado exitosamente',
      errorSendingEmail: 'Error al enviar el correo',
      fillAllFields: 'Por favor complete todos los campos requeridos',

      // Service Types
      serviceTypes: {
        product: 'Producto',
        service: 'Servicio',
        subscription: 'Suscripción',
        license: 'Licencia',
        other: 'Otro'
      },

      // Contract Services translations
      contractServices: 'Servicios del Contrato',
      servicesAssociated: 'Servicios asociados a este contrato',
      noServices: 'No hay servicios asociados a este contrato',
      serviceName: 'Nombre del Servicio',
      serviceType: 'Tipo de Servicio',
      quantity: 'Cantidad',
      unitCost: 'Costo Unitario',
      
      // Empty contracts state translations
      "contracts.emptyState.title": "Comience con la Gestión de Contratos",
      "contracts.emptyState.description": "Cree su primer contrato para comenzar a organizar y gestionar sus acuerdos comerciales de manera efectiva.",
      "contracts.emptyState.addFirstContract": "Agregar Su Primer Contrato",
      "contracts.emptyState.extractContract": "Extraer de Documento",
      "contracts.emptyState.setupGuide": "Guía de Configuración",
      "contracts.emptyState.step1.title": "Ingrese los Detalles Básicos",
      "contracts.emptyState.step1.description": "Comience ingresando el nombre del proveedor y la información básica del contrato.",
      "contracts.emptyState.step2.title": "Establecer Términos",
      "contracts.emptyState.step2.description": "Defina los términos del contrato, incluida la fecha de vencimiento y los costos esperados.",
      "contracts.emptyState.step3.title": "Agregar Documentos",
      "contracts.emptyState.step3.description": "Suba cualquier documento relevante del contrato.",

      // Contract import from Excel
      "contracts.import.title": "Importar Contratos desde Excel",
      "contracts.import.pageTitle": "Importar Contratos",
      "contracts.import.pageDescription": "Importe contratos, proveedores y contactos desde un archivo Excel.",
      "contracts.import.description": "Suba un archivo Excel para crear contratos, proveedores y contactos en masa. Descargue la plantilla, complete los datos y súbalo aquí.",
      "contracts.import.shortDescription": "Cree contratos, proveedores y contactos en masa subiendo un archivo Excel. Descargue la plantilla, complete sus datos y súbalo.",
      "contracts.import.requiredColumns": "Columnas obligatorias:",
      "contracts.import.optionalColumns": "Columnas opcionales:",
      "contracts.import.downloadTemplate": "Descargar Plantilla",
      "contracts.import.dropHere": "Suelte su archivo aquí...",
      "contracts.import.dragOrClick": "Arrastre y suelte un archivo Excel, o haga clic para buscar",
      "contracts.import.acceptedFormats": ".xlsx o .csv",
      "contracts.import.validRows": "{{count}} fila(s) válida(s) lista(s) para importar",
      "contracts.import.errorRows": "{{count}} fila(s) con errores (se omitirán)",
      "contracts.import.rowError": "Fila {{row}}",
      "contracts.import.importButton": "Importar {{count}} contrato(s)",
      "contracts.import.cancel": "Cancelar",
      "contracts.import.importing": "Importando... {{count}} de {{total}}",
      "contracts.import.done": "¡Se importaron {{count}} contrato(s) exitosamente!",
      "contracts.import.success": "¡Se importaron {{count}} contrato(s) exitosamente!",
      "contracts.import.error.missingSupplier": "Falta supplier_name",
      "contracts.import.error.invalidCost": "expected_cost inválido",
      "contracts.import.error.invalidSignedDate": "signed_date inválida",
      "contracts.import.error.invalidExpiryDate": "expiry_date inválida",
      "contracts.import.error.invalidImportance": "La importancia debe ser 1-5",
      "contracts.import.error.invalidFreqUnit": "payment_frequency_unit inválido",
      "contracts.import.error.invalidReminder": "reminder_period inválido",
      "contracts.import.error.parseFailed": "No se pudo analizar el archivo",
      "contracts.import.error.notLoggedIn": "Debe iniciar sesión para importar contratos",
      "contracts.import.limitWarning": "Su plan permite {{remaining}} contrato(s) más. Solo se importarán {{importable}} de {{total}} contratos.",
      "contracts.import.limitUpgradeHint": "Actualice su suscripción para importar todos los contratos.",
      "contracts.import.upgradeLink": "Actualizar ahora",
      "contracts.import.limitReached": "Ha alcanzado el número máximo de contratos ({{used}}/{{limit}}) para su plan.",
      "contracts.import.upgradeToImport": "para importar contratos.",
      
      // Contract extraction
      toggleJson: "Alternar JSON",
      extractedDataJson: "Datos Extraídos (JSON)",
      rawExtractionResults: "Resultados de extracción sin procesar de OpenAI",
      
      // Detect Expenses
      detectExpenses: "Detectar Gastos",
      detectExpensesTooltip: "Analiza gastos recurrentes de tu integración activa de Tripletex para crear contratos automáticamente",
      
      // Expense Detection Page
      analysisSettings: "Configuración de Análisis",
      selectDateRange: "Seleccione el rango de fechas para el análisis de gastos",
      from: "Desde",
      to: "Hasta",
      analyzeExpenses: "Analizar Gastos",
      analyzing: "Analizando",
      detectedPatterns: "Patrones Detectados",
      potentialContracts: "contratos potenciales",
      selectHighConfidence: "Seleccionar Alta Confianza",
      createContracts: "Crear Contratos",
      high: "Alto",
      medium: "Medio",
      low: "Bajo",
      weekly: "Semanal",
      fortnightly: "Quincenal",
      monthly: "Mensual",
      biMonthly: "Bimestral",
      quarterly: "Trimestral",
      semiAnnually: "Semestral",
      annually: "Anual",
      transactions: "transacciones",
      analyzed: "Analizadas",
      transactionsFound: "transacciones, encontradas",
      recurringPatterns: "patrones recurrentes",
      analysisComplete: "Análisis Completado",
      analysisFailed: "Análisis Fallido",
      failedToCreateContracts: "Error al Crear Contratos",
      noExpensesSelected: "Sin Gastos Seleccionados",
      pleaseSelectAtLeastOne: "Seleccione al menos un patrón de gasto para crear contratos",
      cannotReject: "No se Puede Rechazar",
      noSupplierInfo: "Información de proveedor faltante para este patrón",
      patternRejected: "Patrón Rechazado",
      patternWontBeSuggested: "Este patrón no se sugerirá nuevamente",
      rejectionFailed: "Rechazo Fallido",
      noActiveIntegration: "Sin Integración Activa",
      setupFinagoFirst: "Configure su integración de Finago Office primero",
      goToIntegrations: "Ir a Integraciones",
      organization: "Organización",
      detectRecurringExpenses: "Detectar Gastos Recurrentes",
      analyzeFinagoPostings: "Analizar registros de Finago para encontrar gastos recurrentes",
      connectedTo: "Conectado a",
      dateRange: "Rango de Fechas",
      startAnalysis: "Iniciar Análisis",
      detectedRecurringExpenses: "Gastos Recurrentes Detectados",
      reviewAndSelectExpenses: "Revise y seleccione gastos para crear contratos",
      selectAllHighConfidence: "Seleccionar Todos Alta Confianza",
      account: "Cuenta",
      averageAmount: "Monto Promedio",
      frequency: "Frecuencia",
      occurrences: "Ocurrencias",
      times: "veces",
      variance: "Variación",
      varianceTooltip: "La variación muestra cuánto difieren los montos de pago entre ocurrencias. Una variación baja indica pagos consistentes.",
      paymentType: "Tipo de Pago",
      contractDetailsOptional: "Detalles del Contrato (Opcional)",
      leaveEmptyToUseSuggested: "Dejar vacío para usar el sugerido",
      selectCategoryOptional: "Seleccionar categoría (opcional)",
      selectContractTypeOptional: "Seleccionar tipo de contrato (opcional)",
      signingDate: "Fecha de Firma",
      default: "Predeterminado",
      period: "Período",
      sampleDescriptions: "Descripciones de Muestra",
      detectedBy: "Detectado por",
      noPatterns: "Sin Patrones Detectados",
      clickAnalyze: "Haga clic en 'Iniciar Análisis' para detectar patrones de gastos recurrentes de sus transacciones.",
      rejectSuggestion: "Rechazar esta sugerencia",
      accountFilteringRules: "Reglas de Filtrado de Cuentas",
      accountFilteringDescription: "Controle qué números de cuenta deben excluirse o priorizarse en la detección de gastos",
      accountNumber: "Número de Cuenta",
      ruleType: "Tipo de Regla",
      exclude: "Excluir",
      prioritize: "Priorizar",
      descriptionOptional: "Descripción (opcional)",
      descriptionPlaceholder: "ej., Gastos de seguro",
      prioritizedAccounts: "Cuentas Priorizadas",
      excludedAccounts: "Cuentas Excluidas",
      loadingAccountRules: "Cargando reglas de cuenta...",
      accountRuleAdded: "Regla de cuenta agregada",
      accountRuleRemoved: "Regla de cuenta eliminada",
      failedToAddRule: "Error al agregar regla",
      failedToRemoveRule: "Error al eliminar regla",
      pleaseEnterAccountNumber: "Por favor ingrese un número de cuenta",
      
      // Setup guide - Welcome
      "setupGuide.welcome.title": "Bienvenido a Subtrackr",
      "setupGuide.welcome.subtitle": "Esta guía de configuración le ayudará a configurar su cuenta con todos los ajustes esenciales.",
      "setupGuide.welcome.whatWeCover": "Lo que cubriremos:",
      "setupGuide.welcome.coverageDescription": "Configure categorías, tipos de contratos, monedas, tasas de cambio, registros de empresas y configuración de colores de importancia para personalizar su experiencia de gestión de contratos.",
      "setupGuide.welcome.description": "Puede completar esta configuración ahora, o puede acceder a ella más tarde desde la página de Configuración.",
      "setupGuide.welcome.quickStart": "Inicio Rápido",
      "setupGuide.welcome.quickStartDesc": "¿Quiere comenzar de inmediato? Use valores predeterminados para configurar automáticamente categorías, tipos de contratos y monedas.",
      "setupGuide.welcome.useDefaults": "Usar Valores Predeterminados",
      "setupGuide.welcome.settingUp": "Configurando...",
      
      // Setup guide - Categories
      "categories.resetExisting": "Eliminar categorías existentes antes de agregar las predeterminadas",
      "categories.resetting": "Restableciendo...",
      "categories.adding": "Agregando...",
      
      // Setup guide - Contract Types
      "contractTypes.resetExisting": "Eliminar tipos de contrato existentes antes de agregar los predeterminados",
      "contractTypes.resetting": "Restableciendo...",
      
      // Common
      comingSoon: "Próximamente",
      close: "Cerrar",
      reset: "Restablecer",
      resetAll: "Restablecer Todo",
      saveColors: "Guardar Colores",
      backgroundColor: "Color de Fondo",
      textColor: "Color de Texto",
      colorSettingsSaved: "Configuración de colores guardada correctamente",
      failedToSaveSettings: "Error al guardar la configuración",
      
      // Importance levels
      importanceLevels: {
        veryLow: "Muy Bajo",
        low: "Bajo",
        medium: "Medio",
        high: "Alto",
        critical: "Crítico"
      },
    }
  },
  no: {
    common: {
      // Header & Quick Settings
      'header.quickSettings': 'Hurtiginnstillinger',
      'header.theme': 'Tema',
      'header.translationMode': 'Oversettelsesmodus',
      'header.exitTranslationMode': 'Avslutt oversettelsesmodus',
      'header.notifications': 'Varsler',
      'header.erpNotifications': 'ERP-varsler',
      'header.testNotifications': 'Testvarsler',
      'header.adminPanel': 'Administrasjonspanel',
      'header.testerArea': 'Testerområde',
      'header.userMenu': 'Brukermeny',
      'theme.light': 'Lys',
      'theme.dark': 'Mørk',
      'theme.system': 'Auto',
      'onboarding.gettingStarted': 'Kom i gang',
      'onboarding.tooltip': 'Ta en guidet tur gjennom appen',
      'user.inviteUser': 'Inviter bruker',
      'changelog.title': 'Endringslogg',
      'changelog.subtitle': 'Se hva som er nytt og forbedret',
      'changelog.loading': 'Laster endringslogg...',
      'changelog.empty': 'Ingen endringslogger tilgjengelig ennå.',
      'changelog.newRelease': '{{count}} endringer i denne utgivelsen',
      'changelog.viewAll': 'Se alle endringslogger',
      'notifications.markAllRead': 'Merk alle som lest',
      'notifications.clearRead': 'Fjern leste',
      'notifications.loading': 'Laster varsler...',
      'notifications.empty': 'Ingen varsler',
      
      // Navigation - Custom Plan
      'nav.yourFeatures': 'Dine funksjoner',
      'nav.account': 'Konto',
      'nav.dashboard': 'Dashboard',
      'nav.contracts': 'Kontrakter',
      'nav.allContracts': 'Alle kontrakter',
      'nav.allContractsDesc': 'Bla gjennom og administrer kontrakter',
      'nav.newContract': 'Ny kontrakt',
      'nav.newContractDesc': 'Opprett en ny kontrakt',
      'nav.categories': 'Kategorier',
      'nav.categoriesDesc': 'Organiser kontrakter',
      'nav.services': 'Tjenester',
      'nav.servicesDesc': 'Administrer kontraktstjenester',
      'nav.salesAnalytics': 'Salgsanalyse',
      'nav.costOptimization': 'Kostnadsoptimalisering',
      'nav.erpIntegration': 'ERP-integrasjon',
      'nav.documentExtraction': 'Dokumentutvinning',
      'nav.customFields': 'Egendefinerte felt',
      'nav.tags': 'Tagger',
      'tags.pageTitle': 'Kontrakttagger',
      'tags.pageDescription': 'Gjenbrukbare etiketter du kan knytte til kontrakter for å organisere og filtrere dem.',
      'tags.newTag': 'Ny tagg',
      'tags.editTag': 'Rediger tagg',
      'tags.allTags': 'Alle tagger',
      'tags.empty': 'Ingen tagger ennå. Opprett din første tagg for å organisere kontrakter.',
      'contract.owner': 'Eier',
      'contract.ownerPlaceholder': 'Velg eier',
      'contract.ownerDescription': 'Tildel en ansvarlig kollega fra dette arbeidsområdet.',
      'contract.department': 'Avdeling',
      'contract.departmentPlaceholder': 'Velg avdeling',
      'contract.departmentDescription': 'Organiser kontrakten under en avdeling.',
      'contract.noDepartments': 'Ingen avdelinger ennå — opprett dem under Avdelinger',
      'contract.noMembers': 'Ingen medlemmer i arbeidsområdet tilgjengelig',
      'contract.unassigned': 'Ikke tildelt',
      'owner': 'Eier',
      'tags.name': 'Navn',
      'tags.color': 'Farge',
      'tags.deleteTitle': 'Slette denne taggen?',
      'tags.deleteDescription': 'Den fjernes fra alle kontrakter den er knyttet til.',
      'contracts.fields.name': 'Kontraktnavn',
      'contracts.fields.description': 'Beskrivelse',
      'contracts.fields.tags': 'Tagger',
      'duplicateContract': 'Dupliser kontrakt',
      'duplicatingFromNotice': 'Dupliserer fra "{{name}}". Velg en ny leverandør nedenfor — alle andre detaljer er fylt ut på forhånd og kan justeres.',
      'nav.calendarView': 'Kalender',
      'nav.apiPortal': 'API-portal',
      'nav.settings': 'Innstillinger',
      'nav.help': 'Hjelp',
      'nav.subscriptionRequired': 'Abonnement påkrevd',
      'nav.choosePlan': 'Velg en plan',
      'nav.getStarted': 'Kom i gang',
      'nav.documentation': 'Dokumentasjon',
      'nav.documentationDesc': 'Lær hvordan du bruker plattformen',
      'nav.suppliers': 'Leverandører',
      'nav.suppliersDesc': 'Administrer leverandører og deres kontaktpersoner',

      // Suppliers
      'suppliers.title': 'Leverandører',
      'suppliers.description': 'Administrer leverandørene dine og deres kontaktpersoner.',
      'suppliers.addSupplier': 'Legg til leverandør',
      'suppliers.searchPlaceholder': 'Søk etter leverandører...',
      'suppliers.showInactive': 'Vis inaktive',
      'suppliers.noSuppliers': 'Ingen leverandører ennå',
      'suppliers.noSuppliersDescription': 'Legg til din første leverandør for å komme i gang.',
      'suppliers.name': 'Navn',
      'suppliers.orgNumber': 'Org.nr.',
      'suppliers.email': 'E-post',
      'suppliers.phone': 'Telefon',
      'suppliers.status': 'Status',
      'suppliers.active': 'Aktiv',
      'suppliers.inactive': 'Inaktiv',
      'suppliers.activate': 'Aktiver',
      'suppliers.deactivate': 'Deaktiver',
      'suppliers.activated': 'Leverandør aktivert',
      'suppliers.deactivated': 'Leverandør deaktivert',
      'suppliers.deleted': 'Leverandør slettet',
      'suppliers.deleteTitle': 'Slett leverandør',
      'suppliers.deleteDescription': 'Er du sikker på at du vil slette denne leverandøren? Denne handlingen kan ikke angres.',
      'suppliers.createTitle': 'Legg til ny leverandør',
      'suppliers.createDescription': 'Fyll inn detaljene for å opprette en ny leverandør.',
      'suppliers.created': 'Leverandør opprettet',
      'suppliers.updated': 'Leverandør oppdatert',
      'suppliers.save': 'Lagre endringer',
      'suppliers.create': 'Opprett leverandør',
      'suppliers.details': 'Detaljer',
      'suppliers.contactPersons': 'Kontaktpersoner',
      'suppliers.linkedContracts': 'Tilknyttede kontrakter',
      'suppliers.notFound': 'Leverandør ikke funnet',
      'suppliers.backToList': 'Tilbake til leverandører',
      'suppliers.addContact': 'Legg til kontakt',
      'suppliers.noContacts': 'Ingen kontaktpersoner for denne leverandøren.',
      'suppliers.contactCreated': 'Kontaktperson opprettet',
      'suppliers.contactUpdated': 'Kontaktperson oppdatert',
      'suppliers.contactDeleted': 'Kontaktperson slettet',
      'suppliers.editContact': 'Rediger kontakt',
      'suppliers.deleteContact': 'Slett kontakt',
      'suppliers.deleteContactConfirm': 'Er du sikker på at du vil slette denne kontaktpersonen?',
      'suppliers.noContracts': 'Ingen kontrakter knyttet til denne leverandøren.',
      'suppliers.contractName': 'Kontrakt',
      'suppliers.cost': 'Kostnad',
      'suppliers.signedDate': 'Signeringsdato',
      'suppliers.expiryDate': 'Utløpsdato',
      'suppliers.namePlaceholder': 'Skriv inn leverandørnavn',
      'suppliers.orgNumberPlaceholder': 'Skriv inn organisasjonsnummer',
      'suppliers.emailPlaceholder': 'Skriv inn e-postadresse',
      'suppliers.phonePlaceholder': 'Skriv inn telefonnummer',
      'suppliers.addressPlaceholder': 'Skriv inn adresse',
      'suppliers.cityPlaceholder': 'Skriv inn by',
      'suppliers.postalCodePlaceholder': 'Skriv inn postnummer',
      'suppliers.countryPlaceholder': 'Skriv inn land',
      'suppliers.notesPlaceholder': 'Legg til notater om denne leverandøren...',
      'suppliers.address': 'Adresse',
      'suppliers.city': 'By',
      'suppliers.postalCode': 'Postnummer',
      'suppliers.country': 'Land',
      'suppliers.website': 'Nettside',
      'suppliers.notes': 'Notater',
      
      // Subscription access messages
      'subscription.accessRestricted': 'Fullfør abonnementet ditt for å få tilgang til alle funksjoner.',
      'subscription.paymentRequired': 'Betaling kreves for å få tilgang til denne funksjonen.',
      'subscription.upgradeRequired': 'Oppgrader planen din for å få tilgang til denne funksjonen.',
      
      // Legacy Navigation keys
      contracts: 'Kontrakter',
      categories: 'Kategorier',
      contacts: 'Kontakter',
      contractTypes: 'Kontraktstyper',
      currencies: 'Valutaer',
      
      // Actions
      add: 'Legg til',
      edit: 'Rediger',
      delete: 'Slett',
      cancel: 'Avbryt',
      save: 'Lagre',
      create: 'Opprett',
      update: 'Oppdater',
      continue: 'Fortsett',
      assign: 'Tildel',
      updating: 'Oppdaterer...',
      createAndAssign: 'Opprett og Tildel',
      
      // States
      loading: 'Laster...',
      error: 'Feil',
      success: 'Vellykket',
      saving: 'Lagrer...',
      saveSettings: 'Lagre innstillinger',
      
      // 404 Page
      pageNotFound: 'Siden ble ikke funnet',
      pageNotFoundDesc: 'Beklager, siden du leter etter finnes ikke eller har blitt flyttet.',
      backToHome: 'Tilbake til forsiden',
      
      // Contract related
      supplier: 'Leverandør',
      expiryDate: 'Utløpsdato',
      signedDate: 'Signeringsdato',
      'contractDates.startDate': 'Startdato',
      'contractDates.signedDateDesc': 'Datoen kontrakten ble signert',
      'contractDates.startDateDesc': 'Når kontraktsperioden starter (bruker signeringsdato hvis ikke satt)',
      'contractDates.sameAsSigned': 'Samme som signeringsdato',
      category: 'Kategori',
      type: 'Type',
      importance: 'Viktighet',
      expectedCost: 'Forventet kostnad',
      expectedIncome: 'Forventet inntekt',
      value: 'Verdi',
      currency: 'Valuta',
      actions: 'Handlinger',
      status: 'Status',
      select: 'Velg',
      selectCategory: 'Velg Kategori',
      selectContractType: 'Velg Kontraktstype',
      errorLoadingContract: 'Feil ved lasting av kontrakt',
      contractNotFound: 'Kontrakten du leter etter ble ikke funnet.',
      backToContracts: 'Tilbake til Kontrakter',
      contractType: 'Kontraktstype',
      paymentFrequency: 'Betalingsfrekvens',
      oneTime: 'Én gang',
      erpSource: 'ERP',
      erpClient: 'ERP-klient',
      importedFrom: 'Importert fra',
      addAnother: 'Legg til en til',
      
      // Contract table UI elements
      searchContracts: 'Søk i kontrakter...',
      resetFilters: 'Tilbakestill Filtre',
      settings: 'Innstillinger',
      updateAllRates: 'Oppdater Alle Kurser',
      newContract: 'Ny Kontrakt',
      allContracts: 'Alle Kontrakter',
      showingXtoYofZ: 'Viser {{start}} til {{end}} av {{total}}',
      totalCost: 'Total kostnad: ',
      totalCostInCurrency: 'Total kostnad i {{currency}}: ',
      totalIncome: 'Total inntekt: ',
      totalIncomeInCurrency: 'Total inntekt i {{currency}}: ',      
      result: 'Resultat: ',
      resultInCurrency: 'Resultat i {{currency}}: ',      
      
      // Admin section
      adminDashboard: 'Admin Dashboard',
      translations: 'Oversettelser',
      manageTranslations: 'Administrer Oversettelser',
      
      // User Management
      users: 'Brukere',
      manageUsers: 'Administrer Brukere',
      createUser: 'Opprett Bruker',
      editUser: 'Rediger Bruker',
      deleteUser: 'Slett Bruker',
      userCreated: 'Bruker Opprettet',
      userUpdated: 'Bruker Oppdatert',
      userDeleted: 'Bruker Slettet',
      roles: 'Roller',
      email: 'Epost',
      password: 'Passord',
      confirmPassword: 'Bekreft Passord',
      name: 'Navn',
      
      // Bug Reports
      bugReports: 'Feilrapporter',
      manageBugReports: 'Administrer Feilrapporter',
      newBugReport: 'Ny Feilrapport',
      bugReportDetails: 'Feilrapport Detaljer',
      statusChangeSuccess: 'Status Endring Suksess',
      
      // Email Settings
      emailSettings: 'Epostinnstillinger',
      configureEmailSettings: 'Konfigurer Epostinnstillinger',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUser: 'SMTP Bruker',
      smtpPassword: 'SMTP Passord',
      senderEmail: 'Avsender Epost',
      testEmail: 'Test Epost',
      sendTestEmail: 'Send Test Epost',
      testEmailSent: 'Test Epost Sendt',
      
      // System Settings
      systemSettings: 'Systeminnstillinger',
      generalSettings: 'Generelle Innstillinger',
      defaultLanguage: 'Standard Språk',
      
      // User Settings Page
      settingsPage: {
        general: 'Generelt',
        subscription: 'Abonnement',
        appearance: 'Utseende',
        appearanceDescription: 'Tilpass hvordan kontrakter vises i hele applikasjonen.',
        integrations: 'Integrasjoner',
        advisors: 'Rådgivertilgang',
        integrationsDescription: 'Konfigurer eksterne tjenester og dataleverandører for kontoen din.',
        managePreferences: 'Administrer kontoinnstillinger og preferanser.',
        importanceColors: {
          title: 'Kontraktsviktighetsfarger',
          description: 'Tilpass fargene som brukes til å vise kontraktsviktighetsnivåer (Svært lav til Kritisk) i hele applikasjonen.'
        },
        statusColors: {
          title: 'Kontraktsstatusfarger',
          description: 'Tilpass fargene som brukes til å vise kontraktsstatus (Aktiv, Utløper snart, Utløpt, osv.) i kontraktslister og tabeller.'
        },
        exchangeRate: {
          title: 'Valutakonvertering',
          description: 'Konfigurer hvilken tjeneste som skal brukes for valutakurser mellom forskjellige valutaer.'
        },
        companyRegister: {
          title: 'Firmaregister',
          description: 'Konfigurer firmaoppslagstjenester for rask tilgang til firmainformasjon når du legger til kontrakter.',
          intro: 'Firmaregistre hjelper deg med å raskt slå opp firmainformasjon når du legger til kontrakter. Velg hvilket offisielt firmaregister du vil bruke.',
          provider: 'Leverandør',
          selectProvider: 'Velg en leverandør',
          none: 'Ingen - Ingen firmaoppslag',
          requiresApiKey: 'Denne leverandøren krever en API-nøkkel',
          noApiKey: 'Ingen API-nøkkel kreves for denne leverandøren',
          apiKey: 'API-nøkkel',
          enterApiKey: 'Skriv inn din API-nøkkel',
          apiKeyHelp: 'Du må registrere deg for en API-nøkkel fra leverandørens nettside.',
          savedSuccess: 'Firmaregisterinnstillinger lagret',
          savedError: 'Kunne ikke lagre firmaregisterinnstillinger'
        }
      },
      
      // Status colors labels
      statusColors: {
        active: 'Aktiv',
        expiringSoon: 'Utløper snart',
        expired: 'Utløpt',
        autoRenewing: 'Auto-fornyes',
        renewed: 'Fornyet'
      },
      
      // Documentation page
      documentation: {
        title: "Dokumentasjon",
        subtitle: "Lær hvordan du bruker alle funksjonene i Subtrackr",
        searchPlaceholder: "Søk i dokumentasjon...",
        viewSubscription: "Se Abonnement"
      },
      
      // Documentation navigation
      docs: {
        contents: "Innhold",
        categories: {
          gettingStarted: "Kom i Gang",
          coreFeatures: "Kjernefunksjoner",
          organization: "Organisering og Oppsett",
          advancedFeatures: "Avanserte Funksjoner",
          aiTools: "AI og Analyse",
          integrations: "Integrasjoner",
          settings: "Innstillinger"
        },
        nav: {
          gettingStarted: "Introduksjon",
          subscriptionPlans: "Abonnementsplaner",
          dashboard: "Dashboard",
          dashboardWidgets: "Dashboard-widgeter",
          contracts: "Kontrakter",
          calendarView: "Kalendervisning",
          notifications: "Varsler og Påminnelser",
          categories: "Kategorier",
          contractTypes: "Kontraktstyper",
          currencies: "Valutaer",
          contacts: "Kontakter",
          groups: "Avdelinger",
          customFields: "Egendefinerte Felt",
          duplicateDetection: "Duplikatoppdagelse",
          notesActivity: "Notater og Aktivitetslogg",
          approvalWorkflows: "Godkjenningsarbeidsflyter",
          contractDocumentBuilder: "Dokumentbygger",
          clauseLibrary: "Klausulbibliotek",
          documentVariables: "Dokumentvariabler",
          governingDocuments: "Styrende dokumenter",
          esignature: "E-signatur (DocuSign)",
          riskAnalysis: "AI Risikoanalyse",
          costOptimization: "AI Kostnadsoptimalisering",
          salesAnalytics: "Salgsanalyse",
          dataHealth: "Datakvalitet",
          erpIntegrations: "ERP-integrasjoner",
          apiPortal: "API-portal",
          documentExtraction: "Dokumentutvinning",
          settingsProfile: "Innstillinger og Profil"
        },
        // Section content translations
        sections: {
          gettingStarted: {
            title: "Kom i Gang",
            description: "Velkommen til Subtrackr! Denne guiden hjelper deg med å komme i gang med kontraktsstyring.",
            whatIs: "Hva er Subtrackr?",
            whatIsDesc: "Subtrackr er et omfattende kontraktsstyringssystem som hjelper deg med å spore, administrere og analysere dine forretningskontrakter. Det tilbyr verktøy for kontraktslivssyklusstyring, kostnadssporing, påminnelser og integrasjoner med ERP-systemer som Tripletex.",
            firstSteps: "Første Steg",
            firstStepsDesc: "Etter innlogging ser du Dashboardet som gir en oversikt over kontraktene dine og viktige målinger.",
            navigation: "Navigasjon",
            navigationDesc: "Hovednavigasjonen er plassert øverst på siden. Du kan få tilgang til alle funksjoner herfra."
          },
          subscriptionPlans: {
            title: "Abonnementsplaner",
            description: "Subtrackr tilbyr ulike abonnementsplaner tilpasset dine forretningsbehov. Lær om funksjoner, priser og hvordan du oppgraderer.",
            overview: "Oversikt",
            overviewDesc: "Subtrackr har fire abonnementsnivåer: Gratis, Plus, Pro og Business. Hvert nivå tilbyr flere funksjoner og høyere bruksgrenser.",
            freePlan: "Gratis Plan",
            freePlanDesc: "Den gratis planen er perfekt for enkeltpersoner eller små bedrifter som nettopp har begynt med kontraktsstyring.",
            plusPlan: "Plus Plan",
            plusPlanDesc: "Plus-planen er designet for voksende bedrifter som trenger flere kontrakter og tilgang til avanserte funksjoner.",
            proPlan: "Pro Plan",
            proPlanDesc: "Pro-planen er ideell for etablerte bedrifter som trenger omfattende kontraktsstyring.",
            businessPlan: "Business Plan",
            businessPlanDesc: "Business-planen er vårt mest omfattende tilbud for større organisasjoner."
          },
          salesAnalytics: {
            title: "Salgsanalyse",
            description: "Analyser salgsresultatene dine etter produkt, kunde og tidsperiode ved hjelp av data fra ERP-integrasjoner eller CSV-import.",
            whatIs: "Hva er Salgsanalyse?",
            whatIsDesc: "Salgsanalyse gir omfattende innsikt i inntektsstrømmene dine. Den samler ordre- og fakturadata fra tilkoblede ERP-systemer eller manuell CSV-import.",
            accessing: "Tilgang til Salgsanalyse",
            accessingDesc: "Naviger til Salgsanalyse fra Verktøy-menyen i hovednavigasjonen.",
            dataSources: "Datakilder",
            dataSourcesDesc: "Salgsanalyse kan hente data fra flere kilder inkludert Tripletex, Finago og CSV-import.",
            overview: "Oversiktsdashboard",
            overviewDesc: "Oversiktsfanen viser nøkkelindikatorer og trender.",
            products: "Produktanalyse",
            productsDesc: "Produktfanen viser inntekter fordelt på produkt eller tjeneste.",
            customers: "Kundeanalyse",
            customersDesc: "Kundefanen hjelper deg med å forstå kundebasen din.",
            orders: "Ordredetaljer",
            ordersDesc: "Ordrefanen gir en detaljert liste over alle transaksjoner.",
            csvImport: "CSV-import",
            csvImportDesc: "Importer salgsdata manuelt hvis du ikke har ERP-integrasjon.",
            syncing: "Synkronisering av ERP-data",
            syncingDesc: "Hold salgsdataene dine oppdatert med ERP-synkronisering."
          },
          dataHealth: {
            title: "Datakvalitet",
            description: "Overvåk og forbedre kvaliteten på kontraktsdataene dine for å sikre nøyaktig rapportering og pålitelige automatiserte funksjoner.",
            whatIs: "Hva er Datakvalitet?",
            whatIsDesc: "Datakvalitet analyserer kontraktsdatabasen din for å identifisere manglende informasjon, datakvalitetsproblemer og forbedringsmuligheter.",
            accessing: "Tilgang til Datakvalitet",
            accessingDesc: "Naviger til Datakvalitet fra Verktøy-menyen i hovednavigasjonen.",
            healthScore: "Forstå Helseskåren",
            healthScoreDesc: "Datakvalitetskåren gir en rask vurdering av den totale datakvaliteten din.",
            categories: "Problemkategorier",
            categoriesDesc: "Datakvalitet organiserer problemer i logiske kategorier for enklere håndtering.",
            fixing: "Fikse Problemer",
            fixingDesc: "Hvert problem inkluderer veiledning om hvordan det løses.",
            recommendations: "Anbefalinger",
            recommendationsDesc: "Datakvalitet gir proaktive anbefalinger for å forbedre kontraktsstyringen din.",
            widget: "Dashboard-widget",
            widgetDesc: "Legg til Datakvalitet-widgeten på dashboardet ditt for rask overvåking.",
            bestPractices: "Beste Praksis",
            bestPracticesDesc: "Tips for å opprettholde høy datakvalitet."
          },
          approvalWorkflows: {
            title: "Godkjenningsarbeidsflyter",
            description: "Konfigurer godkjenningskjeder med flere interessenter for kontrakter som krever signering fra flere personer.",
            whatIs: "Hva er Godkjenningsarbeidsflyter?",
            whatIsDesc: "Godkjenningsarbeidsflyter lar deg definere formelle godkjenningskjeder for kontrakter.",
            creating: "Opprette en Arbeidsflyt",
            creatingDesc: "Få tilgang til godkjenningsarbeidsflyter fra Verktøy → Godkjenningsarbeidsflyter.",
            steps: "Legge til Godkjenningstrinn",
            stepsDesc: "Hver arbeidsflyt består av ett eller flere sekvensielle godkjenningstrinn.",
            initiating: "Starte en Godkjenning",
            initiatingDesc: "Start godkjenningsprosessen fra kontraktens detaljside.",
            approving: "Godkjenne eller Avvise",
            approvingDesc: "Godkjennere kan handle på ventende forespørsler via e-postlenke eller i systemet.",
            tracking: "Spore Godkjenningsstatus",
            trackingDesc: "Overvåk fremdriften for godkjenningsforespørsler i sanntid.",
            managing: "Administrere Arbeidsflyter",
            managingDesc: "Rediger eller slett arbeidsflyter fra Godkjenningsarbeidsflyter-siden."
          },
          costOptimization: {
            title: "AI Kostnadsoptimalisering",
            description: "Analyser forbruksmønstre på tvers av kontraktene dine for å identifisere besparelsesmuligheter ved hjelp av AI.",
            whatIs: "Hva er Kostnadsoptimalisering?",
            whatIsDesc: "AI Kostnadsoptimaliseringsmotoren analyserer kontraktsporteføljen din for å identifisere besparelsesmuligheter.",
            running: "Kjøre Analyse",
            runningDesc: "Få tilgang til kostnadsoptimalisering fra Verktøy → Kostnadsoptimalisering.",
            suggestions: "Forstå Forslag",
            suggestionsDesc: "AI-en genererer ulike typer optimaliseringsforslag.",
            details: "Forslagsdetaljer",
            detailsDesc: "Hvert forslag inkluderer detaljert informasjon for å hjelpe deg med å handle.",
            managing: "Administrere Forslag",
            managingDesc: "Handle på forslag for å spore optimaliseringsinnsatsen din.",
            stats: "Dashboard-statistikk",
            statsDesc: "Kostnadsoptimaliseringsdashboardet viser nøkkelmålinger.",
            bestPractices: "Beste Praksis",
            bestPracticesDesc: "Tips for å få mest mulig ut av kostnadsoptimalisering."
          },
          riskAnalysis: {
            title: "AI Risikoanalyse",
            description: "Analyser kontraktsdokumenter ved hjelp av AI for å identifisere potensielle juridiske og økonomiske risikoer.",
            whatIs: "Hva er Risikoanalyse?",
            whatIsDesc: "AI Kontraktsrisikoanalyse bruker avansert AI for å evaluere kontraktsdokumentene dine og identifisere potensielle risikoer.",
            running: "Kjøre Risikoanalyse",
            runningDesc: "Analyser et kontraktsdokument fra kontraktens detaljside.",
            scores: "Forstå Risikoskårer",
            scoresDesc: "AI-en tildeler en risikoskåre fra 0-100 og kategoriserer det totale risikonivået.",
            findings: "Risikofunn",
            findingsDesc: "Analysen identifiserer spesifikke risikoområder i kontrakten din.",
            recommendations: "Anbefalinger",
            recommendationsDesc: "For hvert risikofunn gir AI-en spesifikke anbefalinger."
          }
        },
        // Common documentation UI elements
        stepsLabel: "Trinn",
        tipsLabel: "Tips og Notater",
        requiresErp: "Krever ERP-integrasjon"
      },
      
      // Features Settings
      featuresSettings: 'Funksjonsinnstillinger',
      enableFeature: 'Aktiver Funksjon',
      disableFeature: 'Deaktiver Funksjon',
      
      // Company Register Settings
      companyRegisterSettings: 'Firma Register Innstillinger',
      companyName: 'Firmanavn',
      companyAddress: 'Firmaadresse',
      companyLogo: 'Firmalogo',
      
       // Widget Designer
      widgetDesigner: 'Widget Designer',
      designYourWidgets: 'Design Dine Widgets',
      addWidget: 'Legg til Widget',
      editWidget: 'Rediger Widget',
      deleteWidget: 'Slett Widget',
      widgetName: 'Widget Navn',
      widgetType: 'Widget Type',
      widgetData: 'Widget Data',
      
      // Seed Translations
      seedTranslations: 'Seed Oversettelser',
      seedTranslationsFromDefaults: 'Seed Oversettelser Fra Standarder',
      seedingTranslations: 'Seeding Oversettelser',
      translationsSeeded: 'Oversettelser Seeded',
      
      // Translations Manager
      manageApplicationTranslations: 'Administrer Applikasjon Oversettelser',
      addNewLanguage: 'Legg Til Nytt Språk',
      languageCode: 'Språkkode',
      addLanguage: 'Legg Til Språk',
      languageCodeHelp: 'Skriv inn en 2-bokstavs språkkode (f.eks. en, es, fr)',
      localeExists: 'Locale {{locale}} eksisterer allerede',
      localeAdded: 'Locale {{locale}} lagt til',
      addNewTranslationKey: 'Legg Til Ny Oversettelsesnøkkel',
      translationKeyPlaceholder: 'Skriv inn oversettelsesnøkkel',
      valueForLocale: 'Verdi for {{locale}}',
      addTranslationKey: 'Legg Til Oversettelsesnøkkel',
      translationKeyHelp: 'Skriv inn en unik nøkkel for oversettelsen',
      translationUpdated: 'Oversettelse for "{{key}}" i "{{locale}}" oppdatert',
      invalidKey: 'Ugyldig nøkkel',
      invalidLocaleCode: 'Ugyldig språkkode',
      selectLanguage: 'Velg Språk',
      searchTranslationKeys: 'Søk Oversettelsesnøkler',
      translationKey: 'Oversettelsesnøkkel',
      translationValue: 'Verdi',
      noResults: 'Ingen Resultater',
      syncingTranslations: 'Synkroniserer Oversettelser',
      translationsSynced: 'Oversettelser Synkronisert',
      errorSyncingTranslations: 'Feil ved Synkronisering av Oversettelser',
      
      // Financial Forecast Widget
      forecast: {
        title: 'Finansiell Prognose',
        expenses: 'Utgifter',
        income: 'Inntekter',
        totalExpenses: 'Totale Utgifter',
        totalIncome: 'Totale Inntekter',
        noData: 'Ingen prognosedata tilgjengelig for den valgte perioden',
        currencyNote: 'Verdier i din standardvaluta',
        currencyTooltip: 'Kontraktsbeløp konverteres til din standardvaluta for visning',
        periods: {
          quarter: 'Neste Kvartal',
          sixMonths: 'Neste 6 Måneder',
          year: 'Neste År',
          twoYears: 'Neste 2 År'
        }
      },
      
      // Contracts table UI elements
      manageYourContracts: 'Administrer alle kontraktene dine på ett sted',
      areYouSure: 'Er du helt sikker?',
      deleteContractsWarning: 'Denne handlingen kan ikke angres. Dette vil permanent slette de valgte kontraktene fra våre servere.',
      assignToGroup: 'Tildel til Gruppe',
      removeFromGroup: 'Fjern fra Gruppe',
      tableSettings: 'Tabellinnstillinger',
      configureContractsDisplay: 'Konfigurer hvordan kontraktene vises',
      showGroupedContracts: 'Vis Grupperte Kontrakter',
      displayContractsInGroups: 'Vis kontrakter i deres tildelte grupper',
      groupContractsBy: 'Grupper kontrakter etter',
      groupContractsByDescription: 'Velg hvordan kontrakter grupperes i oversikten',
      groupByNone: 'Ingen gruppering',
      groupByCustom: 'Egendefinerte grupper',
      groupByVendor: 'Leverandør',
      groupByType: 'Type',
      groupByCategory: 'Kategori',
      groupingPreferenceSaved: 'Grupperingsinnstilling lagret',
      columns: 'Kolonner',
      customizeColumns: 'Tilpass kolonner',
      selectOrCreateGroup: 'Velg en eksisterende gruppe eller opprett en ny for å tildele de valgte kontraktene.',
      existingGroup: 'Eksisterende Gruppe',
      createNewGroup: 'Opprett Ny Gruppe',
      selectAGroup: 'Velg en gruppe',
      noExistingGroups: 'Ingen eksisterende grupper funnet. Opprett en ny gruppe i stedet.',
      groupName: 'Gruppenavn',
      description: 'Beskrivelse',
      optional: 'valgfri',
      enterGroupName: 'Skriv inn gruppenavn',
      enterGroupDescription: 'Skriv inn gruppebeskrivelse',
      
      // Exchange rates
      noCurrenciesAvailable: 'Ingen valutaer tilgjengelig',
      exchangeRatesUpdated: 'Alle valutakurser oppdatert',
      failedToUpdateRates: 'Kunne ikke oppdatere valutakurser',
      currencyDisclaimer: 'Valutakonverteringer er estimater og gjenspeiler kanskje ikke nøyaktige kurser på tidspunktet for kontraktsbetaling.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Dashboard',
        loading: 'Laster dashboard...',
        notAvailable: 'Dashboard Ikke Tilgjengelig',
        upgradeMessage: 'Den avanserte dashboardvisualiseringen er ikke inkludert i ditt nåværende abonnement.',
        viewPlans: 'Se Tilgjengelige Planer',
        upgradeDetails: 'Oppgrader planen din for å få tilgang til alle dashbordfunksjoner, inkludert økonomisk innsikt, kontrakttidslinjer, distribusjonsanalyse og mer.',
        
        controls: {
          editLayout: 'Rediger Oppsett',
          editing: 'Redigerer',
          addWidget: 'Legg til Widget',
          resetLayout: 'Tilbakestill Oppsett',
          saveLayout: 'Lagre Oppsett',
          saving: 'Lagrer...',
          saved: 'Lagret!',
          freePositioning: 'Fri Posisjonering',
          gridLayout: 'Rutenettlayout'
        },

        filters: {
          title: 'Filtre',
          refineData: 'Filtrer dashboard-data',
          clearAll: 'Tøm alle',
          vendors: 'Leverandører',
          contractTypes: 'Kontraktstyper',
          currencies: 'Valutaer',
          importance: 'Viktighet',
        },
        
        widgets: {
          noData: 'Ingen kontraktsdata ennå',
          populate: 'Dashbordet ditt vil fylles med innsikt når du legger til kontrakter i systemet.',
          addFirst: 'Legg til din første kontrakt',
          
          totalContracts: 'Totale Kontrakter',
          acrossCategories: 'På tvers av alle kategorier',
          activeContracts: 'Aktive Kontrakter',
          currentlyActive: 'Nåværende aktive',
          expiringSoon: 'Utløper Snart',
          nextDays: 'I løpet av de neste 30 dagene',
          totalValue: 'Total Verdi',
          inUserCurrency: 'I brukerens valuta',
          calculating: 'Kalkulerer...',
          
          contractsByType: 'Kontrakter etter Type',
          contractsTimeline: 'Kontraktstidslinje',
          hoverInfo: 'Hold musepekeren over datapunkter for å se detaljert informasjon',
          contractCount: '{{value}} kontrakter',
          
          recentContracts: 'Nylige Kontrakter',
          supplier: 'Leverandør',
          status: 'Status',
          created: 'Opprettet',
          actions: 'Handlinger',
          noRecentContracts: 'Ingen nylige kontrakter funnet',
          
          upcomingExpirations: 'Kommende Utløp',
          expires: 'Utløper',
          daysLeft: 'Dager Igjen',
          noDaysLeft: '{{count}} dager',
          noUpcomingExpirations: 'Ingen kommende utløp',
          
          contractCostsByType: 'Kontraktskostnader etter Type',
          financialResult: 'Finansielt Resultat',
          multiCurrency: 'Flervaluta-konvertering',
          convertedFrom: 'Konvertert fra flere valutaer'
        }
      },
      
      // Contract view page translations
      back: 'Tilbake',
      contractDetails: 'Kontraktsdetaljer',
      basicInformation: 'Grunnleggende Informasjon',
      supplierDetails: 'Leverandørdetaljer',
      organizationNumber: 'Organisasjonsnummer',
      renewalDate: 'Fornyelses Dato',
      renewalTerms: 'Fornyelsesvilkår',
      autoRenews: 'Automatisk Fornying',
      everyInterval: 'Hver {{interval}} {{unit}}',
      viewTimeline: 'Vis Tidslinje',
      'timeline.autoRenewed': 'Automatisk Fornyet',
      'timeline.previousExpiry': 'Forrige utløp',
      'timeline.newExpiry': 'Nytt utløp',
      'timeline.renewedFor': 'Fornyet for',
      viewCostTimeline: 'Vis Kostnadstidslinje',
      viewIncomeTimeline: 'Vis Inntektstidslinje',
      manageContacts: 'Administrer Kontakter',
      noContacts: 'Ingen kontakter tilknyttet denne kontrakten',
      peopleAssociated: 'Personer tilknyttet denne kontrakten',
      contactPersons: 'Kontaktpersoner',

      // Email related translations
      sendContract: 'Send Kontrakt',
      recipient: 'Mottaker',
      subject: 'Emne',
      message: 'Melding',
      emailAddress: 'E-postadresse',
      includeAdditionalAttachments: 'Inkluder tilleggsfiler',
      send: 'Send',
      sending: 'Sender...',
      generatingPdf: 'Genererer PDF...',
      emailSent: 'E-post sendt',
      errorSendingEmail: 'Feil ved sending av e-post',
      fillAllFields: 'Vennligst fyll ut alle påkrevde felt',

      // Service Types
      serviceTypes: {
        product: 'Produkt',
        service: 'Tjeneste',
        subscription: 'Abonnement',
        license: 'Lisens',
        other: 'Annet'
      },

      // Contract Services translations
      contractServices: 'Kontraktstjenester',
      servicesAssociated: 'Tjenester tilknyttet denne kontrakten',
      noServices: 'Ingen tjenester tilknyttet denne kontrakten',
      serviceName: 'Tjenestenavn',
      serviceType: 'Tjenestetype',
      quantity: 'Antall',
      unitCost: 'Enhetskostnad',
      originalCost: 'Originalkostnad',
      contractCost: 'Kontraktskostnad',
      totalInContractCurrency: 'Total (i kontraktsvaluta)',
      exchangeRateApplied: 'Valutakurs brukt',
      // Empty contracts state translations
      "contracts.emptyState.title": "Kom i gang med Kontraktsstyring",
      "contracts.emptyState.description": "Opprett din første kontrakt for å begynne å organisere og administrere dine forretningsavtaler effektivt.",
      "contracts.emptyState.addFirstContract": "Legg til din første kontrakt",
      "contracts.emptyState.extractContract": "Hent ut fra dokument",
      "contracts.emptyState.setupGuide": "Oppsettguide",
      "contracts.emptyState.step1.title": "Skriv inn grunnleggende detaljer",
      "contracts.emptyState.step1.description": "Start med å skrive inn leverandørnavn og grunnleggende kontraktsinformasjon.",
      "contracts.emptyState.step2.title": "Sett vilkår",
      "contracts.emptyState.step2.description": "Definer kontraktsvilkår inkludert utløpsdato og forventede kostnader.",
      "contracts.emptyState.step3.title": "Legg til dokumenter",
      "contracts.emptyState.step3.description": "Last opp relevante kontraktsdokumenter og filer.",

      // Contract import from Excel
      "contracts.import.title": "Importer kontrakter fra Excel",
      "contracts.import.pageTitle": "Importer kontrakter",
      "contracts.import.pageDescription": "Importer kontrakter, leverandører og kontaktpersoner fra en Excel-fil.",
      "contracts.import.description": "Last opp en Excel-fil for å opprette kontrakter, leverandører og kontaktpersoner i bulk. Last ned malen, fyll inn dataene dine, og last den opp her.",
      "contracts.import.shortDescription": "Opprett kontrakter, leverandører og kontaktpersoner i bulk ved å laste opp en Excel-fil. Last ned malen, fyll inn dataene dine, og last opp.",
      "contracts.import.requiredColumns": "Påkrevde kolonner:",
      "contracts.import.optionalColumns": "Valgfrie kolonner:",
      "contracts.import.downloadTemplate": "Last ned mal",
      "contracts.import.dropHere": "Slipp filen din her...",
      "contracts.import.dragOrClick": "Dra og slipp en Excel-fil her, eller klikk for å bla",
      "contracts.import.acceptedFormats": ".xlsx eller .csv",
      "contracts.import.validRows": "{{count}} gyldige rad(er) klare til import",
      "contracts.import.errorRows": "{{count}} rad(er) med feil (hoppes over)",
      "contracts.import.rowError": "Rad {{row}}",
      "contracts.import.importButton": "Importer {{count}} kontrakt(er)",
      "contracts.import.cancel": "Avbryt",
      "contracts.import.importing": "Importerer... {{count}} av {{total}}",
      "contracts.import.done": "Importerte {{count}} kontrakt(er) vellykket!",
      "contracts.import.success": "Importerte {{count}} kontrakt(er) vellykket!",
      "contracts.import.error.missingSupplier": "Mangler supplier_name",
      "contracts.import.error.invalidCost": "Ugyldig expected_cost",
      "contracts.import.error.invalidSignedDate": "Ugyldig signed_date",
      "contracts.import.error.invalidExpiryDate": "Ugyldig expiry_date",
      "contracts.import.error.invalidImportance": "Viktighet må være 1-5",
      "contracts.import.error.invalidFreqUnit": "Ugyldig payment_frequency_unit",
      "contracts.import.error.invalidReminder": "Ugyldig reminder_period",
      "contracts.import.error.parseFailed": "Kunne ikke lese filen",
      "contracts.import.error.notLoggedIn": "Du må være logget inn for å importere kontrakter",
      "contracts.import.limitWarning": "Planen din tillater {{remaining}} kontrakt(er) til. Bare {{importable}} av {{total}} kontrakter vil bli importert.",
      "contracts.import.limitUpgradeHint": "Oppgrader abonnementet ditt for å importere alle kontrakter.",
      "contracts.import.upgradeLink": "Oppgrader nå",
      "contracts.import.limitReached": "Du har nådd maksimalt antall kontrakter ({{used}}/{{limit}}) for planen din.",
      "contracts.import.upgradeToImport": "for å importere kontrakter.",
      
      // Contract extraction
      toggleJson: "Veksle JSON",
      extractedDataJson: "Ekstraherte Data (JSON)",
      rawExtractionResults: "Rå ekstraksjonsresultater fra OpenAI",
      
      // Detect Expenses & Sales
      detect: "Oppdag",
      detectExpenses: "Oppdage Utgifter",
      detectExpensesTooltip: "Analyser gjentakende utgifter fra din aktive Tripletex-integrasjon for å automatisk opprette kontrakter",
      detectRecurringSales: "Finn Salg",
      detectRecurringSalesTooltip: "Analyser gjentakende salgsmønstre for å oppdage potensielle inntektskontrakter",
      detectBoth: "Kjør begge",
      recurringCustomer: "Gjentakende kunde",
      expectedRevenue: "Forventet inntekt",
      salesPattern: "Salgsmønster",
      salesDetection: "Salgsdeteksjon",
      expenseDetection: "Utgiftsdeteksjon",
      willCreateIncomingContract: "Dette oppretter en inntektskontrakt",
      salesDetectionComplete: "Salgsdeteksjon fullført. {{count}} gjentakende mønstre funnet.",
      salesDetectionFailed: "Salgsdeteksjon feilet: {{message}}",
      notARecurringSale: "Ikke et gjentakende salg",
      showAll: "Vis alle",
      "revenue.revenueTrend": "Inntektstrend",
      "revenue.totalRevenue": "Total inntekt",
      "revenue.collected": "Innbetalt",
      "revenue.outstanding": "Utestående",
      "revenue.pipeline": "I pipeline",
      "revenue.actualRevenue": "Faktisk inntekt",
      "revenue.expectedIncome": "Forventet inntekt",
      "revenue.invoiceCount": "{{count}} fakturaer",
      "revenue.salesOrderCount": "{{count}} ordrer",
      "revenue.paid": "Betalt",
      "revenue.confirmed": "Bekreftet",
      "revenue.cancelled": "Kansellert",
      "revenue.draft": "Utkast",
      "revenue.overdue": "Forfalt",
      "revenue.partial": "Delvis",
      "revenue.pending": "Ventende",
      "revenue.invoice": "Faktura",
      "revenue.order": "Ordre",
      "revenue.due": "Forfaller",
      "revenue.showInvoices": "Vis alle fakturaer",
      "revenue.hideInvoices": "Skjul fakturaer",
      "revenue.showOrders": "Vis alle ordrer",
      "revenue.hideOrders": "Skjul ordrer",
      "revenue.amount": "Inntekt",
      
      // Expense Detection Page
      analysisSettings: "Analyseinnstillinger",
      selectDateRange: "Velg datoområde for utgiftsanalyse",
      from: "Fra",
      to: "Til",
      analyzeExpenses: "Analyser Utgifter",
      analyzing: "Analyserer",
      detectedPatterns: "Oppdagede Mønstre",
      potentialContracts: "potensielle kontrakter",
      selectHighConfidence: "Velg Høy Konfidanse",
      createContracts: "Opprett Kontrakter",
      high: "Høy",
      medium: "Middels",
      low: "Lav",
      weekly: "Ukentlig",
      fortnightly: "Annenhver uke",
      monthly: "Månedlig",
      biMonthly: "Annenhver måned",
      quarterly: "Kvartalsvis",
      semiAnnually: "Halvårlig",
      annually: "Årlig",
      transactions: "transaksjoner",
      analyzed: "Analyserte",
      transactionsFound: "transaksjoner, fant",
      recurringPatterns: "gjentakende mønstre",
      analysisComplete: "Analyse Fullført",
      analysisFailed: "Analyse Feilet",
      failedToCreateContracts: "Kunne ikke opprette kontrakter",
      noExpensesSelected: "Ingen Utgifter Valgt",
      pleaseSelectAtLeastOne: "Velg minst ett utgiftsmønster for å opprette kontrakter",
      cannotReject: "Kan Ikke Avvise",
      noSupplierInfo: "Manglende leverandørinformasjon for dette mønsteret",
      patternRejected: "Mønster Avvist",
      patternWontBeSuggested: "Dette mønsteret vil ikke bli foreslått igjen",
      rejectionFailed: "Avvisning Feilet",
      noActiveIntegration: "Ingen Aktiv Integrasjon",
      setupFinagoFirst: "Sett opp Finago Office-integrasjonen din først",
      goToIntegrations: "Gå til Integrasjoner",
      organization: "Organisasjon",
      detectRecurringExpenses: "Oppdag Gjentakende Utgifter",
      analyzeFinagoPostings: "Analyser Finago-posteringer for å finne gjentakende utgifter",
      connectedTo: "Koblet til",
      dateRange: "Datoområde",
      startAnalysis: "Start Analyse",
      detectedRecurringExpenses: "Oppdagede Gjentakende Utgifter",
      reviewAndSelectExpenses: "Gjennomgå og velg utgifter for å opprette kontrakter",
      selectAllHighConfidence: "Velg Alle Høy Konfidanse",
      account: "Konto",
      averageAmount: "Gjennomsnittlig Beløp",
      frequency: "Frekvens",
      occurrences: "Forekomster",
      times: "ganger",
      variance: "Variasjon",
      varianceTooltip: "Variasjon viser hvor mye betalingsbeløpene varierer mellom forekomster. Lav variasjon indikerer konsistente betalinger.",
      paymentType: "Betalingstype",
      contractDetailsOptional: "Kontraktdetaljer (Valgfritt)",
      leaveEmptyToUseSuggested: "La stå tom for å bruke foreslått",
      selectCategoryOptional: "Velg kategori (valgfritt)",
      selectContractTypeOptional: "Velg kontraktstype (valgfritt)",
      signingDate: "Signeringsdato",
      default: "Standard",
      period: "Periode",
      sampleDescriptions: "Eksempelbeskrivelser",
      detectedBy: "Oppdaget av",
      noPatterns: "Ingen Mønstre Oppdaget",
      clickAnalyze: "Klikk 'Start Analyse' for å oppdage gjentakende utgiftsmønstre fra transaksjonene dine.",
      rejectSuggestion: "Avvis dette forslaget",
      accountFilteringRules: "Kontofilteringsregler",
      accountFilteringDescription: "Kontroller hvilke kontonumre som skal ekskluderes eller prioriteres i utgiftsdeteksjon",
      accountNumber: "Kontonummer",
      ruleType: "Regeltype",
      exclude: "Ekskluder",
      prioritize: "Prioriter",
      descriptionOptional: "Beskrivelse (valgfritt)",
      descriptionPlaceholder: "f.eks. Forsikringsutgifter",
      prioritizedAccounts: "Prioriterte Kontoer",
      excludedAccounts: "Ekskluderte Kontoer",
      loadingAccountRules: "Laster kontoregler...",
      accountRuleAdded: "Kontoregel lagt til",
      accountRuleRemoved: "Kontoregel fjernet",
      failedToAddRule: "Kunne ikke legge til regel",
      failedToRemoveRule: "Kunne ikke fjerne regel",
      pleaseEnterAccountNumber: "Vennligst skriv inn et kontonummer",
      
      // Setup guide - Welcome
      "setupGuide.welcome.title": "Velkommen til Subtrackr",
      "setupGuide.welcome.readyToGo": "Kontoen din er klar! Vi har satt opp standardkategorier, kontraktstyper og valutaer for deg.",
      "setupGuide.welcome.customizeTitle": "Vil du tilpasse? Her finner du alt:",
      "setupGuide.welcome.settingsCategories": "Kategorier og kontraktstyper",
      "setupGuide.welcome.settingsCategoriesDesc": "Tilpass i Innstillinger → Kategorier / Kontraktstyper",
      "setupGuide.welcome.settingsExchangeRates": "Valutakurser",
      "setupGuide.welcome.settingsExchangeRatesDesc": "Administrer i Innstillinger → Valutakurser",
      "setupGuide.welcome.settingsCompanyRegister": "Firmaregister",
      "setupGuide.welcome.settingsCompanyRegisterDesc": "Konfigurer i Innstillinger → Firmaregister",
      "setupGuide.welcome.settingsColors": "Viktighets- og statusfarger",
      "setupGuide.welcome.settingsColorsDesc": "Tilpass i Innstillinger → Farger",
      "setupGuide.welcome.nextStepHint": "La oss sette din foretrukne standardvaluta.",
      "setupGuide.welcome.subtitle": "Denne oppsettguiden vil hjelpe deg med å konfigurere kontoen din.",
      "setupGuide.welcome.description": "Du kan fullføre dette oppsettet nå, eller du kan få tilgang til det senere fra Innstillinger-siden.",
      
      // Setup guide - Steps
      "setupGuide.steps.welcome": "Velkommen",
      "setupGuide.steps.defaultCurrency": "Standardvaluta",
      "setupGuide.steps.completed": "Fullført",
      
      // Setup guide - Default Currency
      "setupGuide.defaultCurrency.title": "Velg din standardvaluta",
      "setupGuide.defaultCurrency.description": "Denne vil brukes som standard når du oppretter nye kontrakter. Du kan endre den når som helst i Innstillinger.",
      "setupGuide.defaultCurrency.error": "Kunne ikke sette standardvaluta",
      "setupGuide.defaultCurrency.saved": "Standardvaluta oppdatert!",
      
      // Setup guide - Completion
      "setupGuide.completion.title": "Oppsett fullført!",
      "setupGuide.completion.description": "Alt er klart! Kontoen din er konfigurert og klar til bruk.",
      "setupGuide.completion.whatsNext": "Hva nå?",
      "setupGuide.completion.nextStep1": "Legg til din første kontrakt",
      "setupGuide.completion.nextStep2": "Inviter teammedlemmer til å samarbeide",
      "setupGuide.completion.nextStep3": "Sett opp varsler for kontraktsfornyelser",
      "setupGuide.completion.nextStep4": "Utforsk rapporterings- og analysefunksjonene",
      "setupGuide.completion.accessLater": "Du kan få tilgang til denne oppsettguiden igjen når som helst fra Innstillinger-siden.",
      
      // Setup guide - Actions
      "setupGuide.completedSuccess": "Oppsett fullført!",
      "setupGuide.completedError": "Feil ved markering av oppsett som fullført",
      "setupGuide.error": "Det oppstod en feil under fullføring av oppsett",
      "setupGuide.skippedSuccess": "Oppsett hoppet over. Du kan få tilgang til det når som helst fra Innstillinger.",
      "setupGuide.completing": "Fullfører...",
      "setupGuide.processing": "Behandler...",
      "setupGuide.complete": "Fullfør oppsett",
      
      // Setup guide - Categories
      "categories.resetExisting": "Fjern eksisterende kategorier før du legger til standarder",
      "categories.resetting": "Tilbakestiller...",
      "categories.adding": "Legger til...",
      
      // Setup guide - Contract Types
      "contractTypes.resetExisting": "Fjern eksisterende kontraktstyper før du legger til standarder",
      "contractTypes.resetting": "Tilbakestiller...",
      
      // Common
      comingSoon: "Kommer snart",
      close: "Lukk",
      
      reset: "Tilbakestill",
      resetAll: "Tilbakestill alle",
      saveColors: "Lagre farger",
      backgroundColor: "Bakgrunnsfarge",
      textColor: "Tekstfarge",
      colorSettingsSaved: "Fargeinnstillinger lagret",
      failedToSaveSettings: "Kunne ikke lagre innstillinger",
      
      // Importance levels
      importanceLevels: {
        veryLow: "Svært lav",
        low: "Lav",
        medium: "Middels",
        high: "Høy",
        critical: "Kritisk"
      },

      // Risk Analysis (Norwegian)
      riskAnalysis: {
        title: "Risikoanalyse",
        noAnalysis: "Ingen risikoanalyse er utført for denne kontrakten ennå.",
        analyzeNow: "Analyser Kontrakt",
        analyzing: "Analyserer...",
        analysisComplete: "Kontraktanalyse fullført",
        analysisError: "Kunne ikke analysere kontrakt",
        rateLimitError: "For mange forespørsler. Prøv igjen senere.",
        lastAnalyzed: "Sist analysert",
        findings: "Risikofunn",
        recommendations: "Anbefalinger",
        noIssues: "Ingen vesentlige risikoer oppdaget i denne kontrakten.",
        highRiskContracts: "Høyrisiko Kontrakter",
        highRiskDescription: "Kontrakter som krever umiddelbar oppmerksomhet",
        noHighRisk: "Ingen høyrisiko kontrakter oppdaget",
        analyzeMore: "Analyser kontraktene dine for å identifisere potensielle risikoer",
        expires: "Utløper",
        findingsCount: "funn",
        viewAll: "Vis alle {{count}} høyrisiko kontrakter",
        scoreLabel: "Poengsum",
        riskLevels: {
          low: "Lav Risiko",
          medium: "Middels Risiko",
          high: "Høy Risiko",
          critical: "Kritisk Risiko"
        }
      },

      // Approval Workflows (Norwegian)
      approvalWorkflows: {
        title: "Godkjenningsarbeidsflyter",
        description: "Konfigurer godkjenningskjeder med flere interessenter for kontrakter",
        createWorkflow: "Opprett Arbeidsflyt",
        editWorkflow: "Rediger Arbeidsflyt",
        deleteWorkflow: "Slett Arbeidsflyt",
        workflowName: "Arbeidsflytnavn",
        workflowDescription: "Beskrivelse",
        contractType: "Kontraktstype (Valgfritt)",
        selectContractType: "Bruk på spesifikk kontraktstype...",
        steps: "Godkjenningstrinn",
        approvalSteps: "Godkjenningstrinn",
        addStep: "Legg til Trinn",
        removeStep: "Fjern Trinn",
        approverEmail: "Godkjenners E-post",
        approverName: "Godkjenners Navn",
        stepOrder: "Trinnrekkefølge",
        isMandatory: "Obligatorisk",
        mandatory: "Obligatorisk",
        timeoutDays: "Tidsavbrudd (dager)",
        isDefault: "Standard Arbeidsflyt",
        isActive: "Aktiv",
        default: "Standard",
        inactive: "Inaktiv",
        noWorkflows: "Ingen arbeidsflyter ennå",
        noWorkflowsDesc: "Opprett godkjenningsarbeidsflyter for å administrere kontraktsgodkjenninger med flere interessenter.",
        createFirst: "Opprett Din Første Arbeidsflyt",
        workflowCreated: "Arbeidsflyt opprettet",
        workflowUpdated: "Arbeidsflyt oppdatert",
        workflowDeleted: "Arbeidsflyt slettet",
        confirmDelete: "Er du sikker på at du vil slette denne arbeidsflyten?",
        deleteConfirmTitle: "Slette Arbeidsflyt?",
        deleteConfirmDesc: "Dette vil permanent slette denne arbeidsflyten og alle dens trinn. Denne handlingen kan ikke angres.",
        stepsCount: "{{count}} trinn",
        pendingApproval: "Venter på Godkjenning",
        approved: "Godkjent",
        rejected: "Avvist",
        approve: "Godkjenn",
        reject: "Avvis",
        addComment: "Legg til Kommentar",
        commentsPlaceholder: "Legg til kommentarer (valgfritt)...",
        approvalHistory: "Godkjenningshistorikk",
        currentStep: "Nåværende Trinn",
        step: "Trinn",
        initiatedBy: "Initiert Av",
        initiatedAt: "Startet",
        completedAt: "Fullført",
        noActiveRequest: "Ingen aktiv godkjenningsforespørsel. Start en for å få godkjenning fra interessenter.",
        selectWorkflow: "Velg en arbeidsflyt...",
        startApproval: "Start",
        cancelApproval: "Avbryt Godkjenning",
        noWorkflowsAvailable: "Ingen arbeidsflyter tilgjengelig. Opprett en i Innstillinger.",
        contractApprovals: "Kontraktsgodkjenninger",
        pastRequests: "Tidligere Forespørsler",
        autoInitiated: "Godkjenningsarbeidsflyt \"{{name}}\" er startet",
        pendingApprovalBlocking: "Redigering Blokkert - Venter på Godkjenning",
        pendingApprovalBlockingDesc: "Denne kontrakten venter på godkjenning og kan ikke redigeres før godkjenningsprosessen er fullført. Fullfør eller avbryt godkjenningsarbeidsflyten først.",
        namePlaceholder: "f.eks., Standard Kontraktsgodkjenning",
        descriptionPlaceholder: "Beskriv når denne arbeidsflyten bør brukes...",
        status: {
          pending: "Venter",
          approved: "Godkjent",
          rejected: "Avvist",
          expired: "Utløpt",
          cancelled: "Avbrutt"
        }
      },

      // Timeline View (Norwegian)
      timelineView: "Tidslinjevisning",
      clearFilters: "Fjern filtre",
      convertedAtRate: "Konvertert til kurs",
      currencyConversionDisclaimer: "Valutaomregninger er estimater og gjenspeiler kanskje ikke nøyaktige kurser på tidspunktet for kontraktsbetaling.",
      converting: "konverterer...",
      timeline: {
        title: "Kontraktstidslinje",
        today: "I dag",
        noContracts: "Ingen kontrakter å vise",
        addContracts: "Legg til kontrakter for å se dem på tidslinjen",
        totalContracts: "Totalt Antall Kontrakter",
        active: "Aktive",
        expiringSoon: "Utløper Snart",
        expired: "Utløpt",
        zoomIn: "Zoom inn",
        zoomOut: "Zoom ut",
        reset: "Tilbakestill visning",
        expense: "Utgift",
        revenue: "Inntekt",
        employment: "Ansettelse",
        expiringSoonLabel: "Utløper ≤30d",
        expiredLabel: "Utløpt",
        contractValue: "Kontraktsverdi",
        startDate: "Startdato",
        endDate: "Sluttdato",
        duration: "Varighet",
        days: "dager",
        daysRemaining: "Dager Igjen",
        expiredDays: "{{days}} dager siden",
        viewDetails: "Vis Fullstendige Detaljer",
        instructions: "Klikk og dra for å panorere. Bruk musehjulet eller knappene for å zoome. Klikk på en kontrakt for detaljer."
      },

      // Cost Optimization (Norwegian)
      costOptimization: {
        title: "Kostnadsoptimalisering",
        description: "AI-drevne innsikter for å redusere kontraktskostnader",
        runAnalysis: "Kjør Analyse",
        analyzing: "Analyserer...",
        lastAnalysis: "Siste analyse",
        potentialSavings: "Potensielle Besparelser",
        suggestions: "Forslag",
        noSuggestions: "Ingen optimaliseringsforslag ennå",
        runFirst: "Kjør en analyse for å oppdage besparelsesmuligheter",
        suggestionTypes: {
          consolidation: "Konsolidering",
          renegotiation: "Reforhandling",
          elimination: "Eliminering",
          timing: "Timingoptimalisering",
          alternative: "Alternativ Leverandør"
        },
        status: {
          pending: "Venter på Gjennomgang",
          reviewed: "Gjennomgått",
          implemented: "Implementert",
          dismissed: "Avvist"
        },
        markReviewed: "Merk som Gjennomgått",
        markImplemented: "Merk som Implementert",
        dismiss: "Avvis",
        viewDetails: "Vis Detaljer",
        affectedContracts: "Berørte Kontrakter",
        confidence: "Konfidens",
        recommendations: "Anbefalinger",
        analysisComplete: "Analyse fullført: {{count}} forslag funnet",
        freshAnalysisComplete: "Ny analyse fullført: {{count}} forslag funnet. Tidligere historikk slettet.",
        analysisError: "Kunne ikke analysere kostnader",
        statusUpdated: "Forslagsstatus oppdatert",
        totalPotentialSavings: "Totale Potensielle Besparelser",
        pendingReview: "Venter på Gjennomgang",
        implemented: "Implementert",
        dismissed: "Avvist",
        freshAnalysis: "Ny Full Analyse",
        freshAnalysisTooltip: "Sletter alle tidligere forslag og analyserer alle kontrakter på nytt"
      },

      // Sales Analytics (Norwegian)
      salesAnalytics: {
        title: "Salgsanalyse",
        description: "Analyser salg per produkt, kunde og periode",
        byProduct: "Per produkt",
        byCustomer: "Per kunde",
        orders: "Ordrer",
        ordersShort: "Ordrer",
        product: "Produkt",
        customer: "Kunde",
        totalRevenue: "Total omsetning",
        orderCount: "Antall ordrer",
        confirmedValue: "Bekreftet ordre",
        awaitingDelivery: "Venter på levering",
        paidValue: "Betalt",
        customers: "Kunder",
        avgOrderValue: "Snitt per ordre",
        sources: "kilder",
        noData: "Ingen data",
        importOrSync: "Importer data eller synkroniser fra ERP",
        dataSources: "Datakilder",
        manualImport: "Manuell import",
        selectPeriod: "Velg periode",
        thisMonth: "Denne måneden",
        lastMonth: "Forrige måned",
        thisQuarter: "Dette kvartalet",
        thisYear: "I år",
        last12Months: "Siste 12 måneder",
        pickDate: "Velg dato",
        topProducts: "Topp 10 produkter",
        revenueByProduct: "Omsetning per produkt i valgt periode",
        allProducts: "Alle produkter",
        productCount: "{{count}} produkter",
        productName: "Produkt",
        quantity: "Antall",
        revenue: "Omsetning",
        share: "Andel",
        noProductData: "Ingen produktdata",
        noProductDataDescription: "Det er ingen salgsdata for valgt periode. Synkroniser fra ERP eller importer data manuelt.",
        topCustomers: "Topp 10 kunder",
        revenueByCustomer: "Omsetning per kunde i valgt periode",
        allCustomers: "Alle kunder",
        customerCount: "{{count}} kunder",
        customerName: "Kunde",
        email: "E-post",
        lastOrder: "Siste ordre",
        noCustomerData: "Ingen kundedata",
        noCustomerDataDescription: "Det er ingen salgsdata for valgt periode. Synkroniser fra ERP eller importer data manuelt.",
        orderList: "Ordreliste",
        refresh: "Oppdater",
        orderNumber: "Ordrenr",
        orderDate: "Dato",
        status: "Status",
        amount: "Beløp",
        orderLines: "Ordrelinjer",
        unitPrice: "Enhetspris",
        lineTotal: "Sum",
        noOrders: "Ingen ordrer",
        noOrdersDescription: "Det er ingen ordrer for valgt periode. Synkroniser fra ERP eller importer data manuelt.",
        statusDraft: "Utkast",
        statusConfirmed: "Bekreftet",
        statusInvoiced: "Fakturert",
        statusPaid: "Betalt",
        statusCancelled: "Kansellert",
        // Sync button
        collectSalesAnalytics: "Hent salgsanalyse",
        sync: "Synkroniser",
        syncing: "Synkroniserer...",
        synced: "Synkronisert",
        syncFailed: "Feilet",
        syncComplete: "Synkronisering fullført",
        syncCompleteDesc: "{{products}} produkter, {{customers}} kunder, {{orders}} ordrer synkronisert.",
        syncError: "Synkroniseringsfeil",
        syncErrorDesc: "Kunne ikke synkronisere salgsdata. Prøv igjen senere.",
        noIntegration: "Ingen ERP-integrasjon",
        noIntegrationDesc: "Du må koble til Tripletex eller Finago for å synkronisere salgsdata.",
        noIntegrationTooltip: "Koble til Tripletex eller Finago for å synkronisere",
        syncNewData: "Synkroniser nye data",
        resetAndReimport: "Tilbakestill og re-importer alt",
        resetConfirmTitle: "Tilbakestill salgsdata?",
        resetConfirmDescription: "Dette vil slette alle eksisterende salgsdata (ordrer, produkter, kunder) og importere alt på nytt fra ERP-systemet. Dette kan ta litt tid.",
        resetAndReimportConfirm: "Ja, tilbakestill og re-importer",
        resetComplete: "Tilbakestilling fullført",
        resetAndSyncComplete: "Data slettet og importert på nytt.",
        // Import
        import: "Importer",
        importSalesData: "Importer salgsdata",
        importDescription: "Last opp en CSV-fil med salgsdata. Filen bør inneholde kolonner for kunde, produkt, dato, antall og pris.",
        needTemplate: "Trenger du en mal?",
        downloadTemplate: "Last ned mal",
        dropHere: "Slipp filen her...",
        dragDrop: "Dra og slipp CSV-fil her",
        orClickToSelect: "eller klikk for å velge fil",
        rowsDetected: "rader funnet",
        importing: "Importerer...",
        startImport: "Start import",
        importSuccess: "Import fullført",
        importPartial: "Import fullført med noen feil",
        importCompleted: "Import fullført",
        importWithErrors: "Import fullført med feil",
        ordersCreated: "ordrer",
        linesCreated: "linjer",
        customersCreated: "kunder",
        productsCreated: "produkter",
        moreErrors: "flere feil",
        // Export
        export: "Eksporter",
        exportOrders: "Eksporter ordrer",
        exportProducts: "Eksporter produktsalg",
        exportCustomers: "Eksporter kundesalg",
        exportSuccess: "Eksport fullført",
        exportError: "Eksport feilet",
        currency: "Valuta",
        totalQuantity: "Totalt antall",
        // Filters
        filters: "Filtre",
        advancedFilters: "Avanserte filtre",
        clearAll: "Fjern alle",
        allStatuses: "Alle statuser",
        allSources: "Alle kilder",
        amountRange: "Beløpsintervall",
        min: "Min",
        max: "Maks",
        dataSource: "Datakilde",
        csvImport: "CSV Import",
        manual: "Manuell",
        searchPlaceholder: "Søk i ordrer...",
        // Saved Reports
        savedReports: "Lagrede rapporter",
        saveCurrentAsNew: "Lagre gjeldende som ny rapport",
        yourReports: "Dine rapporter",
        noSavedReports: "Ingen lagrede rapporter ennå",
        saveReport: "Lagre rapport",
        saveReportDesc: "Lagre gjeldende filter- og datoinnstillinger som en rapport du raskt kan laste inn senere.",
        reportName: "Rapportnavn",
        reportNamePlaceholder: "F.eks. Månedlig produktsalg",
        reportDescription: "Beskrivelse (valgfritt)",
        reportDescPlaceholder: "Hva viser denne rapporten?",
        editReport: "Rediger rapport",
        deleteReport: "Slette rapport?",
        deleteReportDesc: "Denne handlingen kan ikke angres. Den lagrede rapporten vil bli permanent slettet.",
        reportSaved: "Rapport lagret",
        reportSaveError: "Kunne ikke lagre rapport",
        reportUpdated: "Rapport oppdatert",
        reportUpdateError: "Kunne ikke oppdatere rapport",
        reportDeleted: "Rapport slettet",
        reportDeleteError: "Kunne ikke slette rapport",
        reportLoaded: "Rapport lastet",
        updateWithCurrent: "Oppdater med gjeldende innstillinger",
        customPeriod: "Egendefinert periode",
        // PDF Export
        downloadPdf: "Last ned PDF",
        pdfPreview: "PDF-forhåndsvisning",
        pdfPreviewDesc: "Forhåndsvis rapporten før nedlasting",
        pdfSelectSections: "Velg hvilke seksjoner som skal inkluderes i rapporten",
        noSectionsSelected: "Velg minst én seksjon å inkludere i rapporten",
        loadingReportData: "Laster rapportdata...",
        totalItems: "Totalt: {{count}} elementer",
        generatedOn: "Generert",
        period: "Periode",
        summary: "Sammendrag",
        pdfDownloaded: "PDF lastet ned",
        pdfError: "Kunne ikke generere PDF",
        generating: "Genererer...",
        showingTop: "Viser topp {{count}} av {{total}}",
        // Contract linking
        contract: "Kontrakt",
        hasContract: "Har kontrakt",
        contractsLinked: "{{count}} kontrakter tilknyttet",
        viewContract: "Vis kontrakt",
        linkedContracts: "Tilknyttede kontrakter",
        expectedRevenue: "Forventet inntekt",
        expiringContract: "Utløper {{date}}"
      },

      // Expense Sync (Norwegian)
      expenseSync: {
        syncExpenses: "Synk kostnader",
        syncing: "Synkroniserer...",
        synced: "Synkronisert",
        syncFailed: "Feilet",
        syncComplete: "Kostnadssynk fullført",
        syncCompleteDesc: "{{synced}} kostnader synkronisert, {{matched}} kontrakter koblet, {{unlinked}} ukoblede kostnader lagret.",
        syncError: "Synkroniseringsfeil",
        syncErrorDesc: "Kunne ikke synkronisere kostnadsdata. Prøv igjen senere.",
      },

      salesContractSuggestions: {
        title: "Kontraktsmatcher",
        description: "Oppdage automatisk matcher mellom salgskunder og inngående kontrakter",
        detect: "Oppdage matcher",
        rescan: "Søk på nytt",
        pending: "ventende",
        noSuggestions: "Ingen kontraktsmatcher funnet ennå. Klikk 'Oppdage matcher' for å skanne etter matcher mellom salgskunder og dine inngående kontrakter.",
        detected: "{{count}} kontraktsmatcher oppdaget",
        noNewMatches: "Ingen nye kontraktsmatcher funnet",
        detectionError: "Kunne ikke oppdage kontraktsmatcher",
        accepted: "Forslag akseptert",
        dismissed: "Forslag avvist",
        dismissTitle: "Avvis denne matchen?",
        dismissDescription: "Denne matchen vises ikke igjen. Du kan skanne på nytt for å finne nye matcher.",
        confirmDismiss: "Avvis",
        orgMatch: "Orgnr-match",
        nameMatch: "Navnematch",
        manualMatch: "Manuell",
        linked: "Tilknyttet",
        avgSales: "Snitt salg",
        contractValue: "Kontrakt",
        confidence: "sikkerhet",
        viewContract: "Vis kontrakt",
        pendingImports: "Produkter som kan importeres som tjenester",
        dismissSelected: "Avvis valgte",
        importSelected: "Importer valgte",
        productName: "Produkt",
        qty: "Antall",
        unitPrice: "Enhetspris",
        total: "Sum",
        importedServices: "Allerede importert som tjenester",
        importedLabel: "Importert",
        status: "Status",
        noLines: "Ingen ordrelinjer tilgjengelig for import",
        imported: "{{count}} tjenester importert",
        importError: "Kunne ikke importere tjenester",
        manualLinkCreated: "Kunde tilknyttet kontrakt",
        salesServiceSuggestions: "Salg-tjenesteforslag",
        contractSuggestionDesc: "Produkter fra salgsordrer som kan importeres som tjenester for denne kontrakten",
        dismiss: "Avvis",
        importAsServices: "Importer som tjenester",
        allImported: "Alle foreslåtte produkter er importert som tjenester",
      },

      // Contract Document Builder (Norwegian)
      contractDocuments: {
        templatesTitle: "Dokumentmaler",
        templatesDescription: "Opprett gjenbrukbare maler for kontraktsdokumentene dine",
        newTemplate: "Ny mal",
        editTemplate: "Rediger mal",
        newTemplateDesc: "Opprett en gjenbrukbar dokumentmal med dynamiske variabler",
        editTemplateDesc: "Endre dokumentmalen din",
        noTemplates: "Ingen maler ennå",
        noTemplatesDesc: "Opprett din første dokumentmal for å begynne å generere profesjonelle kontraktsdokumenter.",
        createFirst: "Opprett din første mal",
        templateName: "Malnavn",
        templateNamePlaceholder: "f.eks. Standard tjenesteavtale",
        templateDescription: "Beskrivelse",
        descriptionPlaceholder: "Beskriv hva denne malen brukes til...",
        templateContent: "Malinnhold",
        templateContentHint: "Bruk knappen \"Sett inn variabel\" for å legge til dynamiske plassholdere som fylles med kontraktsdata.",
        contractType: "Kontraktstype",
        selectContractType: "Velg kontraktstype",
        anyType: "Alle typer",
        direction: "Retning",
        selectDirection: "Velg retning",
        anyDirection: "Alle retninger",
        setAsDefault: "Sett som standard for denne typen",
        templateCreated: "Mal opprettet",
        templateCreatedDesc: "Malen din er klar til bruk.",
        templateUpdated: "Mal oppdatert",
        templateUpdatedDesc: "Malen din er lagret.",
        templateDeleted: "Mal slettet",
        templateDeletedDesc: "Malen har blitt fjernet.",
        deleteTemplateTitle: "Slette mal?",
        deleteTemplateDesc: "Denne handlingen kan ikke angres. Dokumenter opprettet fra denne malen vil ikke bli påvirket.",
        deleteError: "Kunne ikke slette mal.",
        saveError: "Kunne ikke lagre mal.",
        nameRequired: "Malnavn er påkrevd.",
        editorPlaceholder: "Begynn å skrive kontraktsdokumentet ditt...",
        insertVariable: "Sett inn variabel",
        "direction.incoming": "Innkommende",
        "direction.outgoing": "Utgående",
        "direction.employment": "Ansettelse",
        "direction.other": "Annet",
        variables: {
          supplierName: "Leverandørnavn",
          orgNumber: "Organisasjonsnummer",
          contractType: "Kontraktstype",
          category: "Kategori",
          expectedCost: "Forventet kostnad",
          paymentFrequency: "Betalingsfrekvens",
          paymentType: "Betalingstype",
          signedDate: "Signeringsdato",
          expiryDate: "Utløpsdato",
          todayDate: "Dagens dato",
          contactPersons: "Kontaktpersoner",
          companyName: "Firmanavn",
          servicesTable: "Tjenestetabell",
          categoryContract: "Kontraktsinfo",
          categoryFinancial: "Økonomi",
          categoryDates: "Datoer",
          categoryPeople: "Personer",
          categoryDynamic: "Dynamisk innhold",
        },
        // Phase 2: Document editor
        documentsTitle: "Dokumenter",
        documentsDescription: "Kontraktsdokumenter og utkast",
        createDocument: "Opprett dokument",
        noDocuments: "Ingen dokumenter ennå",
        noDocumentsDesc: "Opprett et dokument fra en mal eller start fra bunnen av.",
        document: "Dokument",
        documentCreateError: "Kunne ikke opprette dokument.",
        documentDeleteError: "Kunne ikke slette dokument.",
        pdfError: "Kunne ikke generere PDF.",
        documentDeleted: "Dokument slettet",
        documentDeletedDesc: "Dokumentet har blitt fjernet.",
        deleteDocumentTitle: "Slette dokument?",
        deleteDocumentDesc: "Denne handlingen kan ikke angres. Dokumentet vil bli permanent slettet.",
        selectTemplate: "Velg mal",
        selectTemplateDesc: "Velg en mal for å opprette et forhåndsutfylt dokument, eller start med et blankt dokument.",
        choosePlaceholder: "Velg en mal...",
        default: "standard",
        blankDocument: "Blankt dokument",
        useTemplate: "Bruk mal",
        downloadPdf: "Last ned PDF",
        finalize: "Fullfør",
        saved: "Dokument lagret",
        savedDesc: "Endringene dine er lagret.",
        finalized: "Dokument fullført",
        finalizedDesc: "Dokumentet er markert som fullført.",
        unsaved: "Ulagrede endringer",
        untitledDocument: "Dokument uten tittel",
        documentNotFound: "Dokument ikke funnet",
        goBack: "Gå tilbake",
        lastUpdated: "Oppdatert",
        status: {
          draft: "Utkast",
          finalized: "Fullført",
          sent_for_signing: "Sendt til signering",
          signed: "Signert",
        },
        // Phase 3: Clause Library
        clauseLibrary: "Klausulbibliotek",
        clauseLibraryDesc: "Bla gjennom og sett inn gjenbrukbare klausuler i dokumentet ditt.",
        clauseLibraryPageDesc: "Administrer gjenbrukbare klausuler for kontraktsdokumentene dine.",
        insertClause: "Sett inn",
        newClause: "Ny klausul",
        editClause: "Rediger klausul",
        clauseFormDesc: "Opprett en gjenbrukbar klausul for kontraktsdokumentene dine.",
        clauseName: "Klausulnavn",
        clauseNamePlaceholder: "f.eks. Konfidensialitetsklausul",
        clauseCategoryLabel: "Kategori",
        clauseContent: "Klausulinnhold",
        clauseContentPlaceholder: "Skriv klausulinnholdet her...",
        clauseNameRequired: "Klausulnavn er påkrevd.",
        clauseCreated: "Klausul opprettet",
        clauseCreatedDesc: "Klausulen er lagt til i biblioteket ditt.",
        clauseUpdated: "Klausul oppdatert",
        clauseUpdatedDesc: "Klausulen er lagret.",
        clauseDeleted: "Klausul slettet",
        clauseDeletedDesc: "Klausulen har blitt fjernet.",
        clauseSaveError: "Kunne ikke lagre klausul.",
        clauseDeleteError: "Kunne ikke slette klausul.",
        deleteClauseTitle: "Slette klausul?",
        deleteClauseDesc: "Denne handlingen kan ikke angres. Klausulen vil bli permanent fjernet fra biblioteket ditt.",
        noClausesYet: "Ingen klausuler i biblioteket ditt ennå.",
        noClausesDesc: "Administrer klausuler fra Klausulbibliotek-siden i innstillinger.",
        noClausesPageDesc: "Opprett gjenbrukbare klausuler som du kan sette inn i ethvert kontraktsdokument.",
        createFirstClause: "Opprett din første klausul",
        clauseCategory: {
          general: "Generelt",
          legal: "Juridisk",
          financial: "Økonomi",
          termination: "Oppsigelse",
          confidentiality: "Konfidensialitet",
          liability: "Ansvar",
          other: "Annet",
        },
        // Phase 3: Signing integration
        signingPrepError: "Kunne ikke forberede dokument for signering.",
        preparingSigning: "Forbereder...",
        sendForSigningBankID: "Send til signering (BankID)",
        sendForSigningDocuSign: "Send til signering (DocuSign)",
        sentForSigning: "Sendt til signering",
        sentForSigningDesc: "Dokumentet er sendt til e-signatur.",
        // Document Import
        importDocument: {
          title: "Importer dokument",
          buttonLabel: "Importer",
          description: "Last opp en PDF, DOC, DOCX, eller bildefil for å konvertere den til redigerbart innhold.",
          dropzone: "Klikk for å velge en fil",
          converting: "Konverterer...",
          convert: "Importer til editor",
          success: "Dokument importert",
          successDesc: "Dokumentinnholdet er lagt til i editoren.",
          conversionError: "Kunne ikke konvertere dokument. Prøv igjen.",
          fileTooLarge: "Filen er for stor. Maksimal størrelse er 10MB.",
          unsupportedFormat: "Filformatet støttes ikke. Bruk PDF, DOC, DOCX, eller bildefiler.",
          hint: "DOCX-filer konverteres lokalt for best kvalitet. PDF- og bildefiler bruker AI for å trekke ut og strukturere innholdet.",
          rateLimited: "For mange forespørsler. Vent litt og prøv igjen.",
          creditsExhausted: "AI-kreditter er brukt opp. Legg til flere kreditter for å fortsette.",
        },
        // Version history
        versionHistory: "Versjonshistorikk",
        createNewVersion: "Ny versjon",
        newVersionCreated: "Ny versjon opprettet",
        newVersionCreatedDesc: "En ny utkastversjon er opprettet.",
        newVersionError: "Kunne ikke opprette ny versjon.",
        editedBy: "Redigert av",
        downloadSignedDoc: "Last ned signert dokument",
        lockedMessage: "Denne versjonen er låst fordi den er sendt til signering eller signert. Opprett en ny versjon for å gjøre endringer.",
        // Insert Image
        insertImage: {
          title: "Sett inn bilde",
          description: "Last opp et bilde og velg hvor det skal plasseres i dokumentet.",
          selectFile: "Velg bildefil",
          dropzone: "Klikk for å velge et bilde",
          placement: "Plassering",
          atCursor: "Ved markørposisjon",
          headerSection: "Topptekst",
          footerSection: "Bunntekst",
          left: "Venstre",
          center: "Senter",
          right: "Høyre",
          insert: "Sett inn",
        },
      },

      customPlan: {
        subtitle: "Velg nøyaktig funksjonene du trenger og betal kun for det du bruker.",
        yourPlan: "Din tilpassede plan",
        selectFeatures: "Velg funksjoner for å bygge planen din",
        includedFree: "Inkludert gratis",
        paidFeatures: "Betalte funksjoner",
        monthlyTotal: "Månedlig total",
        annualTotal: "Årlig total",
        saving: "Sparer {{amount}} sammenlignet med månedlig",
        perMonth: "{{amount}}/måned",
        proceedToCheckout: "Gå til betaling",
        processing: "Behandler...",
        checkoutError: "Kunne ikke starte betaling. Prøv igjen.",
        loadError: "Kunne ikke laste funksjoner. Oppdater siden.",
        updatePlan: "Oppdater plan",
        updateSuccess: "Planen din har blitt oppdatert!",
        updateError: "Kunne ikke oppdatere plan. Prøv igjen.",
        currentPlan: "Nåværende plan",
        modifyPlan: "Endre plan",
        core: "Kjerne",
        free: "Gratis",
        requires: "Krever",
        requiredBy: "Påkrevd av: {{features}}",
        requiresFirst: "Velg først: {{features}}",
        save: "Spar 17%",
        categories: {
          core: {
            name: "Kjernefunksjoner",
            description: "Grunnleggende kontraktshåndtering"
          },
          analytics: {
            name: "Analyse og innsikt",
            description: "Forstå kontrakter og kostnader"
          },
          integrations: {
            name: "Integrasjoner",
            description: "Koble til eksisterende systemer"
          },
          advanced: {
            name: "Avanserte funksjoner",
            description: "Kraftige funksjoner for krevende brukere"
          },
          api: {
            name: "API-tilgang",
            description: "Programmatisk tilgang til dataene dine"
          }
        },
        features: {
          contract_management: {
            name: "Kontraktshåndtering",
            description: "Grunnleggende kontraktshåndtering med alle standardfunksjoner"
          },
          dashboard: {
            name: "Dashboard",
            description: "Visuell oversikt over alle kontrakter og nøkkeltall"
          },
          reminders: {
            name: "Påminnelser",
            description: "E-postvarsler før kontraktsfornyelser"
          },
          advanced_dashboard: {
            name: "Avansert Dashboard",
            description: "Utvidede analyser og grafer for bedre innsikt"
          },
          sales_analytics: {
            name: "Salgsanalyse",
            description: "Komplett salgsanalyse med ordre og kundedata"
          },
          cost_optimization: {
            name: "Kostnadsoptimalisering",
            description: "AI-drevne forslag for å redusere kostnader"
          },
          erp_integration: {
            name: "ERP-integrasjon",
            description: "Koble til Tripletex, Finago og andre ERP-systemer"
          },
          document_extraction: {
            name: "Dokumentutvinning",
            description: "AI-drevet utvinning av data fra PDF-kontrakter"
          },
          custom_fields: {
            name: "Egendefinerte felt",
            description: "Legg til tilpassede felt på kontrakter"
          },
          calendar_view: {
            name: "Kalendervisning",
            description: "Se alle kontraktsfrister i kalenderformat"
          },
          contract_notes: {
            name: "Kontraktsnotater",
            description: "Legg til notater og aktivitetslogg på kontrakter"
          },
          duplicate_detection: {
            name: "Duplikatdeteksjon",
            description: "Automatisk varsling om mulige duplikater"
          },
          api_read: {
            name: "API Lesetilgang",
            description: "Programmatisk tilgang til å lese data"
          },
          api_write: {
            name: "API Skrivetilgang",
            description: "Programmatisk tilgang til å opprette og endre data"
          }
        }
      },
      dataHealth: {
        title: "Datahelse",
        pageTitle: "Datahelse",
        pageDescription: "Overvåk og forbedre kvaliteten på kontraktsdataene dine",
        refresh: "Oppdater",
        issues: "Problemer",
        recommendations: "Anbefalinger",
        categories: "Kategorier",
        lastUpdated: "Sist oppdatert",
        tabOverview: "Oversikt",
        tabIssues: "Problemer",
        tabRecommendations: "Anbefalinger",
        issuesTitle: "Datakvalitetsproblemer",
        issuesDescription: "Se gjennom og fiks disse problemene for å forbedre datakvalitetspoengsummen din",
        noIssuesTitle: "Ingen problemer funnet!",
        noIssuesDescription: "Datakvaliteten din er utmerket",
        noRecommendationsTitle: "Flott jobb!",
        noRecommendationsDescription: "Ingen flere anbefalinger for øyeblikket",
        issuesFound: "problemer funnet",
        noIssues: "Ingen problemer funnet",
        viewDetails: "Se detaljer",
        scoreExcellent: "Utmerket",
        scoreGood: "Bra",
        scoreNeedsWork: "Trenger forbedring",
        scorePoor: "Svak",
        errorLoading: "Feil ved lasting av datahelse",
        errorDescription: "Kunne ikke beregne datahelsepoengsummen din",
        issue: "problem",
        issuesPlural: "problemer",
        // Category names
        categorySupplierData: "Leverandørdata",
        categorySupplierDataDesc: "Organisasjonsnummer og leverandørinformasjon",
        categoryDocumentArchive: "Dokumentarkiv",
        categoryDocumentArchiveDesc: "Kontraktsdokumenter og vedlegg",
        categoryCategorization: "Kategorisering",
        categoryCategorizationDesc: "Kategorier og kontraktstyper",
        categoryErpConnection: "ERP-kobling",
        categoryErpConnectionDesc: "Kobling mot ERP-system for automatisk oppfølging",
        categoryContacts: "Kontaktpersoner",
        categoryContactsDesc: "Kontaktpersoner knyttet til kontrakter",
        // Issue descriptions
        issueMissingOrgNumber: "{contractName} mangler organisasjonsnummer",
        actionMissingOrgNumber: "Legg til organisasjonsnummer for bedre sporbarhet og matching",
        issueMissingCategory: "{contractName} mangler kategori",
        actionMissingCategory: "Kategoriser kontrakten for bedre rapportering",
        issueMissingAttachment: "{contractName} har ingen vedlegg",
        actionMissingAttachment: "Last opp kontraktsdokumentet for dokumentasjon",
        issueMissingErpConnection: "{contractName} er ikke koblet til ERP",
        actionMissingErpConnection: "Koble kontrakten til ERP for automatisk kostnadsoppfølging",
        issueMissingContractType: "{contractName} mangler kontraktstype",
        actionMissingContractType: "Velg kontraktstype for bedre kategorisering",
        // Issue type labels
        issueType: {
          missing_org_number: "Mangler org.nr",
          missing_category: "Mangler kategori",
          missing_attachment: "Mangler vedlegg",
          missing_erp_connection: "Mangler ERP",
          missing_contract_type: "Mangler type"
        },
        // Recommendations
        recOrgNumbersTitle: "Legg til organisasjonsnummer",
        recOrgNumbersDesc: "Mer enn halvparten av kontraktene mangler organisasjonsnummer. Dette er viktig for leverandørmatching og rapportering.",
        recAttachmentsTitle: "Last opp kontraktsdokumenter",
        recAttachmentsDesc: "De fleste kontraktene mangler vedlagte dokumenter. Last opp PDF-er for bedre dokumentasjon og AI-utvinning.",
        recErpTitle: "Koble kontrakter til ERP",
        recErpDesc: "Koble flere kontrakter til ERP for automatisk kostnadsoppfølging og budsjett-varsling.",
        recViewContracts: "Se kontrakter",
        recGoToIntegrations: "Gå til integrasjoner",
        // Impact labels
        impact: {
          high: "Høy effekt",
          medium: "Middels effekt",
          low: "Lav effekt"
        },
        // Contract-level data health
        contractScore: "Datahelse",
        contractScoreTooltip: "Datakompletthetsscore for denne kontrakten",
        allChecksPassed: "Alle datahelse-sjekker bestått",
        checkOrgNumber: "Mangler organisasjonsnummer",
        checkCategory: "Mangler kategori",
        checkAttachment: "Mangler vedlegg",
        checkContractType: "Mangler kontraktstype",
        checkErpConnection: "Mangler ERP-kobling"
      },
      // Portfolio Assessment
      portfolioAssessment: {
        title: "Porteføljevurdering",
        description: "Helhetlig oversikt over kontraktporteføljens tilstand",
        maturityScore: "Kontraktmodenhet",
        outOf: "av 100",
        scoreExcellent: "Utmerket",
        scoreGood: "Bra",
        scoreFair: "Akseptabelt",
        scorePoor: "Trenger forbedring",
        dataQuality: "Datakvalitet",
        riskCoverage: "Risikodekning",
        riskScore: "Risikoscore",
        costAdoption: "Kostnadsoptimalisering",
        erpIntegration: "ERP-integrasjon",
        executiveSummary: "Sammendrag",
        activeContracts: "Aktive kontrakter",
        totalContractsSub: "{{count}} totalt",
        annualSpend: "Årlig kostnad",
        expenseContracts: "Utgiftskontrakter",
        annualRevenue: "Årlig inntekt",
        incomeContracts: "Inntektskontrakter",
        categoryCoverage: "Kategoridekning",
        contractsCategorized: "Kontrakter kategorisert",
        riskExposure: "Risikoeksponering",
        analyzed: "Analysert",
        avgRiskScore: "Snitt risikoscore",
        highCritical: "Høy/Kritisk",
        savingsPotential: "Sparepotensial",
        potentialSavings: "Mulige besparelser",
        realized: "Realisert",
        implemented: "implementert",
        pending: "ventende",
        keyFindings: "Hovedfunn",
        expirationTimeline: "Utløpstidslinje",
        days: "dager",
        noExpirations: "Ingen kontrakter utløper i denne perioden",
        noData: "Ingen kontraktsdata tilgjengelig",
        generateReport: "Generer PDF-rapport",
        shareReport: "Del rapport",
        findingHighRiskTitle: "Høy/kritisk risiko-kontrakter oppdaget",
        findingHighRiskDesc: "Kontrakter med høy eller kritisk risiko krever oppmerksomhet.",
        findingSavingsTitle: "Mulige besparelser identifisert",
        findingSavingsDesc: "Kostnadsoptimalisering har identifisert besparelser på tvers av kontraktene dine.",
        findingDataQualityTitle: "Datakvaliteten trenger forbedring",
        findingDataQualityDesc: "Forbedring av datakvalitet vil øke porteføljemodenhet.",
        findingExpiringSoonTitle: "Kontrakter utløper innen 30 dager",
        findingExpiringSoonDesc: "Disse kontraktene krever umiddelbar oppmerksomhet for fornyelse eller reforhandling.",
        findingErpCoverageTitle: "Lav ERP-integrasjonsdekning",
        findingErpCoverageDesc: "Koble flere kontrakter til ERP-data for bedre kostnadssporing.",
        shareTitle: "Del vurderingsrapport",
        shareDescription: "Opprett en tidsbegrenset lenke som hvem som helst kan bruke for å se denne rapporten uten å logge inn.",
        shareLinkExpiry: "Lenken utløper etter",
        shareExpiry24h: "24 timer",
        shareExpiry72h: "3 dager",
        shareExpiry7d: "7 dager",
        shareExpiry30d: "30 dager",
        shareGenerate: "Generer delingslenke",
        shareLinkLabel: "Delingslenke",
        shareLinkCopied: "Lenke kopiert til utklippstavle",
        shareLinkCreated: "Delingslenke opprettet",
        shareError: "Kunne ikke generere delingslenke",
        shareAuthError: "Autentisering kreves",
        shareExpiresAt: "Utløper",
        // Benchmark & Trend
        industryBenchmark: "Bransjebenchmark",
        yourScore: "Din score",
        industryAvg: "Bransjegjennomsnitt",
        scoreTrend: "Score-utvikling",
        sinceStart: "siden start",
        trendNoData: "Score-historikk vises her etter neste vurdering. Scores registreres daglig.",
        // AI Summary
        aiSummary: "AI-sammendrag",
        aiGenerate: "Generer sammendrag",
        aiRegenerate: "Generer på nytt",
        aiSummaryHint: "Klikk \"Generer sammendrag\" for å lage en AI-drevet oppsummering av porteføljevurderingen.",
        aiGenerating: "Analyserer porteføljedata...",
        aiSummaryError: "Kunne ikke generere sammendrag. Vennligst prøv igjen.",
        // Scenario Simulator
        scenarioTitle: "Scenariosimulator",
        scenarioDesc: "Juster inntekter og kostnader for å utforske ulike scenarier",
        scenarioReset: "Tilbakestill",
        scenarioRevenue: "Inntektsjustering",
        scenarioCost: "Kostnadsjustering",
        scenarioCurrent: "Nåværende overskudd",
        scenarioSimulated: "Simulert overskudd",
        scenarioChange: "Endring",
        scenarioGoalTitle: "AI-målanalyse",
        scenarioGoalDesc: "Sett et overskuddsmål og la AI analysere porteføljen din for å foreslå hvordan du kan oppnå det.",
        scenarioGoalLabel: "Mål for årlig overskudd (NOK)",
        scenarioYears: "År",
        scenarioAnalyze: "Analyser",
        scenarioEnterGoal: "Vennligst oppgi et gyldig overskuddsmål",
        scenarioError: "Kunne ikke generere analyse. Vennligst prøv igjen.",
        aiRateLimit: "For mange forespørsler. Vennligst prøv igjen senere.",
        aiAnalysisGenerated: "AI-analyse generert — {{count}} strategiske områder identifisert",
        aiPaymentRequired: "AI-kreditt brukt opp. Vennligst legg til kreditt.",
        scenarioInclUnlinked: "inkl. {{amount}} uten kontrakt",
      },
      sharedReport: {
        sharedAssessment: "Delt porteføljevurdering",
        generatedOn: "Generert",
        poweredBy: "Drevet av Subtrackr — Kontrakthåndteringsplattform",
        expiredTitle: "Rapportlenken har utløpt",
        expiredDesc: "Denne rapportlenken har utløpt. Be eieren om en ny lenke.",
        revokedTitle: "Rapportlenken er tilbakekalt",
        revokedDesc: "Denne rapportlenken er tilbakekalt av eieren.",
        notFoundTitle: "Rapport ikke funnet",
        notFoundDesc: "Denne rapporten ble ikke funnet. Lenken kan være ugyldig.",
        errorTitle: "Noe gikk galt",
        errorDesc: "En feil oppstod under lasting av rapporten. Vennligst prøv igjen senere.",
      },
      // Advisor Access
      advisorAccess: {
        title: "Rådgivertilgang",
        description: "Inviter eksterne konsulenter eller investorer til å gjennomgå kontraktporteføljen din med lesetilgang.",
        inviteAdvisor: "Inviter rådgiver",
        email: "E-postadresse",
        accessLevel: "Tilgangsnivå",
        readOnly: "Kun lesetilgang",
        analyst: "Analytiker (les + analyser)",
        duration: "Tilgangsvarighet",
        days30: "30 dager",
        days60: "60 dager",
        days90: "90 dager",
        sendInvite: "Send invitasjon",
        inviteSent: "Invitasjon sendt",
        inviteError: "Kunne ikke sende invitasjon",
        currentAdvisors: "Nåværende rådgivere",
        noAdvisors: "Ingen rådgivere har blitt invitert ennå.",
        expiresOn: "Utløper",
        active: "Aktiv",
        pending: "Venter",
        expired: "Utløpt",
        revoked: "Tilbakekalt",
        revokeTitle: "Tilbakekall rådgivertilgang",
        revokeDescription: "Er du sikker på at du vil tilbakekalle tilgangen for {{email}}? De vil umiddelbart miste tilgang til kontraktporteføljen din.",
        revokeConfirm: "Tilbakekall tilgang",
        revokeError: "Kunne ikke tilbakekalle tilgang",
        acceptSuccess: "Invitasjon godtatt!",
        acceptSuccessDesc: "Du har nå rådgivertilgang til å gjennomgå kontraktporteføljen.",
        acceptError: "Invitasjonsfeil",
        goToDashboard: "Gå til rådgiver-dashboard",
      },
      advisorDashboard: {
        title: "Rådgiver-dashboard",
        description: "Lesetilgang til kontraktporteføljen",
        noAccess: "Ingen aktiv rådgivertilgang",
        noAccessDesc: "Du har ingen aktive rådgiverengasjement. Be en kontoeier om å invitere deg.",
      },
      bureauCockpit: {
        nav: "Cockpit",
        title: "Byrå-cockpit for kontrakter",
        subtitle: "Tverrgående kontrakt- og kostnadsoversikt for hele rådgivningsporteføljen.",
        loadingClients: "Laster klientdata…",
        noAccessTitle: "Ingen aktive klientengasjement",
        noAccessDesc: "Byrå-cockpit aggregerer kontraktdata på tvers av alle klient-workspaces du har aktiv rådgivertilgang til. Be en arbeidsområde-eier invitere deg som rådgiver for å komme i gang.",
        clientFallback: "Klient",
        kpi: {
          clients: "Klienter",
          contractsAcross: "{{count}} kontrakter på tvers av porteføljen",
          totalSpend: "Total årlig kostnad",
          aggregated: "Aggregert på tvers av alle klienter",
          savings: "Besparingspotensial",
          savingsDesc: "AI-identifisert på tvers av alle klientporteføljer",
          maturity: "Snitt modenhetsscore",
          maturityScale: "Av 100",
        },
        renewals: {
          title: "Kommende fornyelser på tvers av klienter",
          next30: "Neste 30 dager",
          next60: "Neste 60 dager",
          next90: "Neste 90 dager",
        },
        risk: {
          title: "Klienter med høyrisiko-kontrakter",
          ofTotal: "av {{total}} klienter",
          desc: "Klienter med én eller flere kontrakter merket som høy eller kritisk risiko.",
        },
        table: {
          title: "Klientportefølje",
          search: "Søk i klienter…",
          client: "Klient",
          contracts: "Kontrakter",
          spend: "Årlig kostnad",
          savings: "Besparelse",
          maturity: "Modenhet",
          expiring30: "Utløp 30d",
          empty: "Ingen klienter matcher filteret ditt.",
          open: "Åpne klient-dashboard",
        },
      },
      // Tripletex Token Help Dialog
      tripletexHelp: {
        howToCreateToken: "Hvordan opprette en ansattnøkkel?",
        title: "Hvordan opprette en API-ansattnøkkel i Tripletex",
        description: "Følg disse trinnene for å opprette en ansattnøkkel for å koble Subtrackr til din Tripletex-konto.",
        intro: "For å koble en integrasjon til Tripletex, bruker du en unik API-brukernøkkel. Brukernøkkelen opprettes på en ansatt eller kontakt i selskapet og gis til integrasjonspartneren.",
        accessNote: "Brukernøkkelen kan kun ha samme eller mindre tilgang til systemet som det brukeren du lager nøkkelen på har. I tillegg må du være brukeradmin for å se fanen «API-tilgang».",
        stepsTitle: "Slik lager du en API-brukernøkkel:",
        step1: "Gå til «Lønn > Ansatte» eller «Kunde > Kontakter» i hovedmenyen, og velg den brukeren du ønsker å registrere brukernøkkelen på.",
        step2: "Velg fanen «API-tilgang». Denne fanen finner du også på deg selv.",
        step3: "Registrer en nøkkel ved å klikke på «Ny nøkkel».",
        setupTitle: "Oppsett av brukernøkkel:",
        setup1: "Velg integrasjonen i feltet «Applikasjon». Hvis du finner integrasjonen i rullegardinen, kan du fortsette til steg 4. Hvis du IKKE finner applikasjonen, fortsetter du til steg 2 og 3.",
        setup2: "Huk av for «Tilpasset oppsett» og velg hvilke type tilganger du ønsker å gi integrasjonen.",
        setup3: "Skriv inn applikasjonsnavn i feltet «Applikasjonsnavn». Pass på å skrive det nøyaktig slik som vist under, og ta hensyn til små og store bokstaver i navnet:",
        setup4: "Legg inn hva du ønsker å kalle integrasjonen i oversikten i feltet «Gi nøkkelen et navn».",
        setup5: "Klikk på «Opprett nøkkel» for å få opp den unike brukernøkkelen.",
        accessOptionsTitle: "Tilgangsalternativer:",
        allAccess: "Alle tilganger",
        allAccessDesc: "Dette alternativet gir brukernøkkelen alle tilganger, men vil være begrenset til tilgangene brukeren har. I dette tilfellet må du gi brukeren flere tilganger, eller velge en annen bruker med tilgangene brukernøkkelen har behov for.",
        userAccess: "Gi brukernøkkel denne brukerens tilganger",
        userAccessDesc: "Dette alternativet gir brukernøkkelen alle tilganger som brukeren har på tidspunktet nøkkelen opprettes.",
        customAccess: "Bestem selv",
        customAccessDesc: "Dette alternativet gir ingen tilganger til integrasjonen. Du kan legge til tilgangene til integrasjonen i ettertid.",
        importantNote: "Viktig: Brukernøkkelen vises kun én gang. Du er selv ansvarlig for å ta vare på den.",
        officialDocs: "Se offisiell Tripletex-dokumentasjon",
        copied: "Kopiert!",
        copiedDescription: "Applikasjonsnavn kopiert til utklippstavlen"
      },
      attachments: {
        title: "Vedlegg",
        description: "Dokumenter relatert til denne kontrakten",
        upload: "Last opp",
        uploading: "Laster opp...",
        noAttachments: "Ingen vedlegg lastet opp",
        addAttachments: "Legg til vedlegg",
        view: "Vis",
        download: "Last ned",
        downloading: "Laster ned",
        opening: "Åpner",
        downloadError: "Kunne ikke laste ned filen. Vennligst prøv igjen.",
        openError: "Kunne ikke åpne filen. Vennligst prøv å laste ned i stedet.",
        uploadSuccess: "Filer lastet opp",
        uploadError: "Kunne ikke laste opp filer. Vennligst prøv igjen.",
        uploadFileError: "Feil ved opplasting av fil",
        saveError: "Feil ved lagring av vedlegg",
        authError: "Du må være innlogget for å laste opp filer.",
        delete: "Slett",
        deleting: "Sletter...",
        deleteTitle: "Slett vedlegg",
        deleteConfirm: "Er du sikker på at du vil slette \"{name}\"? Denne handlingen kan ikke angres.",
        deleteSuccess: "Vedlegg slettet",
        deleteError: "Kunne ikke slette vedlegg"
      },
      // Security & Compliance Page
      security: {
        title: "Sikkerhet og samsvar",
        subtitle: "Hvordan vi beskytter dataene dine og oppfyller bedriftskrav",
        protected: "Beskyttet",
        architecture: {
          title: "Plattformarkitektur",
          description: "Subtrackr er en moderne skybasert applikasjon bygget på bransjeledende infrastruktur."
        },
        dataProtection: {
          title: "Databeskyttelse",
          encryption: "Kryptering",
          encryptionText: "All data er kryptert under overføring (TLS 1.3) og i hvile (AES-256). Databasetilkoblinger bruker SSL.",
          tenantIsolation: "Kundeisolasjon",
          tenantIsolationText: "PostgreSQL Row-Level Security (RLS) sikrer streng dataisolasjon mellom kunder på databasenivå. Alle tabeller har RLS-policyer knyttet til den autentiserte brukeren.",
          authentication: "Autentisering",
          authenticationText: "JWT-basert autentisering med automatisk token-fornyelse. Sesjoner utløper etter 1 time med sømløs fornyelse. Passord hashes med bcrypt.",
          backups: "Sikkerhetskopier",
          backupsText: "Automatiske daglige sikkerhetskopier med punkt-i-tid-gjenoppretting. Infrastruktur administrert av Supabase med innebygd redundans."
        },
        appSecurity: {
          title: "Applikasjonssikkerhet",
          xss: "Cross-Site Scripting (XSS)",
          xssText: "React escaper automatisk alt gjengitt innhold via Virtual DOM. Applikasjonen har praktisk talt ingen bruk av dangerouslySetInnerHTML, og der det finnes behandles kun interne CSS-variabler uten brukerinput.",
          sqli: "SQL-injeksjon",
          sqliText: "All databasetilgang bruker Supabase SDK med parametriserte spørringer og PostgreSQL RPC-funksjoner. Ingen rå SQL konstrueres fra brukerinput.",
          ddos: "DDoS-beskyttelse",
          ddosText: "DDoS-beskyttelse på infrastrukturnivå leveres av vår hostingplattform (Supabase på AWS), inkludert automatisk trafikkfiltrering og hastighetsbegrensning."
        },
        sso: {
          title: "SSO og tilgangskontroll",
          description: "Subtrackr støtter bedrifts Single Sign-On (SSO) via SAML 2.0, som muliggjør integrasjon med identitetsleverandører som Duo, Okta, Azure AD og andre. SSO er tilgjengelig som et bedriftstillegg.",
          supported: "Støttede autentiseringsmetoder",
          emailPassword: "E-post og passord-autentisering",
          magicLink: "Magic link (passordløs) autentisering",
          saml: "SAML 2.0 SSO (Bedrift — Duo, Okta, Azure AD)"
        },
        compliance: {
          title: "Samsvar og sertifiseringer",
          soc2: "SOC 2 Type II",
          soc2Text: "Vår infrastrukturleverandør (Supabase) opprettholder SOC 2 Type II-samsvar, som dekker sikkerhet, tilgjengelighet og konfidensialitetskontroller. Subtrackr arver disse kontrollene på infrastrukturnivå.",
          gdpr: "GDPR",
          gdprText: "Subtrackr er designet med GDPR-samsvar i tankene. Brukere kan eksportere og slette sine data. Vi behandler kun data som er nødvendig for å levere tjenesten."
        },
        dataResidency: {
          title: "Dataplassering",
          description: "Kundedata lagres i Supabase-prosjektregionen. Bedriftskunder kan be om regionsspesifikke distribusjoner for å oppfylle krav til dataplassering (f.eks. kun USA eller kun EU).",
          contact: "For spesifikke krav til dataplassering, vennligst kontakt oss på security@subtrackr.com."
        },
        businessContinuity: {
          title: "Forretningskontinuitet og tilgjengelighet",
          description: "Subtrackr er bygget på svært tilgjengelig skyinfrastruktur med automatisert failover og redundans. Plattformen vår bruker Supabase (hostet på AWS) som gir multi-AZ-distribusjoner og automatisk gjenoppretting.",
          uptimeTarget: "Oppetidsmål",
          rpo: "Gjenopprettingspunktmål",
          rto: "Gjenopprettingstidsmål"
        },
        contact: {
          title: "Sikkerhetsspørsmål?",
          description: "For sikkerhetsrelaterte spørsmål, sårbarhetsrapporter eller for å be om vår fullstendige sikkerhetsdokumentasjonspakke, vennligst kontakt sikkerhetsteamet vårt."
        }
      },
      'terms.sla': '8. Tjenestenivåavtale (SLA)',
      'terms.slaText': 'Subtrackr har et mål om 99,9% plattformtilgjengelighet målt på månedlig basis, eksklusive planlagte vedlikeholdsvinduer. Planlagt vedlikehold vil bli kommunisert minst 48 timer i forveien.',
      'terms.slaSupport': 'Responstider for support: Kritiske saker — 4 arbeidstimer. Standard saker — 1 arbeidsdag. Generelle henvendelser — 2 arbeidsdager.',
      'terms.slaEnterprise': 'Bedriftskunder kan forhandle tilpassede SLA-vilkår, inkludert forbedrede oppetidsgarantier og dedikert support, som del av abonnementsavtalen.',

      // Demo Data
      'demo.bannerMessage': 'Du ser på demodata. Klar til å starte på ekte?',
      'demo.goLive': 'Start på ekte',
      'demo.confirmTitle': 'Bytt til live-modus?',
      'demo.confirmDescription': 'Alle demodata (kontrakter, leverandører, kontaktpersoner) vil bli permanent slettet. Kontoinnstillinger, kategorier og valutaer beholdes. Denne handlingen kan ikke angres.',
      'demo.confirmAction': 'Ja, start på ekte',

      // Environment Setup Screen
      'setup.title': 'Forbereder miljøet ditt',
      'setup.subtitle': 'Vi klargjør demodata slik at du kan utforske plattformen med en gang.',
      'setup.stepDefaults': 'Setter opp valutaer og kategorier...',
      'setup.stepSuppliers': 'Oppretter demoleverandører og kontakter...',
      'setup.stepContracts': 'Genererer eksempelkontrakter...',
      'setup.stepDone': 'Alt klart!',

      // Governing Documents
      'govDocs.title': 'Styrende dokumenter',
      'govDocs.subtitle': 'Administrer prosedyrer, instrukser, veiledninger og risikovurderinger',
      'govDocs.newDocument': 'Nytt dokument',
      'govDocs.editDocument': 'Rediger dokument',
      'govDocs.manageTypes': 'Dokumenttyper',
      'govDocs.documentTypes': 'Dokumenttyper',
      'govDocs.noDocuments': 'Ingen dokumenter ennå',
      'govDocs.noDocumentsDesc': 'Opprett ditt første styrende dokument for å starte livssyklushåndtering.',
      'govDocs.createFirst': 'Opprett ditt første dokument',
      'govDocs.searchPlaceholder': 'Søk i dokumenter...',
      'govDocs.allStatuses': 'Alle statuser',
      'govDocs.status.draft': 'Utkast',
      'govDocs.status.inReview': 'Til gjennomgang',
      'govDocs.status.inHearing': 'På høring',
      'govDocs.status.approved': 'Godkjent',
      'govDocs.status.active': 'Aktiv',
      'govDocs.status.revisionNeeded': 'Revisjon nødvendig',
      'govDocs.status.archived': 'Arkivert',
      'govDocs.status.superseded': 'Erstattet',
      'govDocs.overdueRevisions': 'Forfalte revisjoner',
      'govDocs.overdueCount': '{{count}} dokument(er) trenger revisjon',
      'govDocs.upcomingRevisions': 'Kommende revisjoner',
      'govDocs.upcomingCount': '{{count}} dokument(er) forfaller innen 30 dager',
      'govDocs.overdue': 'Forfalt',
      'govDocs.dueSoon': 'Snart forfalt',
      'govDocs.nextRevision': 'Neste revisjon',
      'govDocs.deleted': 'Dokument slettet',
      'govDocs.deleteError': 'Kunne ikke slette dokument',
      'govDocs.confirmDelete': 'Slette dokument?',
      'govDocs.confirmDeleteDesc': 'Denne handlingen kan ikke angres.',
      'govDocs.documentDetails': 'Dokumentdetaljer',
      'govDocs.titleLabel': 'Tittel',
      'govDocs.titlePlaceholder': 'f.eks. Sikkerhetsprosedyre',
      'govDocs.documentNumber': 'Dokumentnummer',
      'govDocs.documentType': 'Dokumenttype',
      'govDocs.selectType': 'Velg type',
      'govDocs.statusLabel': 'Status',
      'govDocs.description': 'Beskrivelse',
      'govDocs.ownershipRevision': 'Eierskap og revisjon',
      'govDocs.tabs.details': 'Detaljer',
      'govDocs.tabs.attachments': 'Vedlegg',
      'govDocs.tabs.workflow': 'Arbeidsflyt',
      'govDocs.tabs.history': 'Historikk',
      'govDocs.tabs.links': 'Koblinger',
      'govDocs.ownerName': 'Dokumenteier',
      'govDocs.ownerEmail': 'Eiers e-post',
      'govDocs.revisionInterval': 'Revisjonsintervall (måneder)',
      'govDocs.titleRequired': 'Tittel er påkrevd',
      'govDocs.created': 'Dokument opprettet',
      'govDocs.updated': 'Dokument oppdatert',
      'govDocs.saveError': 'Kunne ikke lagre dokument',
      'govDocs.notFound': 'Dokument ikke funnet',
      'govDocs.newType': 'Ny type',
      'govDocs.createType': 'Opprett dokumenttype',
      'govDocs.typeName': 'Navn',
      'govDocs.typeNamePlaceholder': 'f.eks. Prosedyre, Instruks, Veiledning',
      'govDocs.typeDescription': 'Beskrivelse',
      'govDocs.lifecycleType': 'Livssyklustype',
      'govDocs.simple': 'Enkel',
      'govDocs.advanced': 'Avansert',
      'govDocs.defaultRevisionInterval': 'Standard revisjonsintervall (måneder)',
      'govDocs.requiresHearing': 'Krever høring',
      'govDocs.requiresApproval': 'Krever godkjenning',
      'govDocs.typeCreated': 'Dokumenttype opprettet',
      'govDocs.typeCreateError': 'Kunne ikke opprette type',
      'govDocs.typeDeleted': 'Dokumenttype slettet',
      'govDocs.typeDeleteError': 'Kunne ikke slette type',
      'govDocs.typeNameRequired': 'Typenavn er påkrevd',
      'govDocs.noTypes': 'Ingen dokumenttyper definert. Opprett en for å kategorisere styrende dokumenter.',
      'govDocs.revisionEvery': 'Revisjon hver {{months}}. måned',
      'govDocs.hearing': 'Høring',
      'govDocs.approval': 'Godkjenning',
      'govDocs.versionHistory': 'Versjonshistorikk',
      'govDocs.newRevision': 'Ny revisjon',
      'govDocs.createRevision': 'Opprett ny revisjon',
      'govDocs.currentVersionLabel': 'Gjeldende versjon: v{{version}} → v{{next}}',
      'govDocs.changeDescription': 'Endringsbeskrivelse',
      'govDocs.changeDescPlaceholder': 'Beskriv hva som ble endret i denne revisjonen...',
      'govDocs.revisionCreated': 'Revisjon v{{version}} opprettet',
      'govDocs.revisionError': 'Kunne ikke opprette revisjon',
      'govDocs.noRevisions': 'Ingen revisjoner ennå. Dokumentet er på sin opprinnelige versjon.',
      'govDocs.notifications.newRevision': 'Dokument revidert',
      'govDocs.notifications.newRevisionMsg': 'Et styrende dokument er revidert til versjon {{version}}',

      // Governing Documents - Attachments
      'govDocs.attachments.title': 'Vedlegg',
      'govDocs.attachments.upload': 'Last opp',
      'govDocs.attachments.uploaded': 'Fil lastet opp',
      'govDocs.attachments.uploadError': 'Kunne ikke laste opp fil',
      'govDocs.attachments.deleted': 'Fil slettet',
      'govDocs.attachments.deleteError': 'Kunne ikke slette fil',
      'govDocs.attachments.tooLarge': 'Filen "{{name}}" overskrider 20MB grensen',
      'govDocs.attachments.empty': 'Ingen vedlegg ennå. Last opp PDF, Word, eller Excel-filer.',

      // Governing Documents - Approvals
      'govDocs.approvals.title': 'Godkjenningsflyt',
      'govDocs.approvals.empty': 'Ingen godkjennere tildelt ennå.',
      'govDocs.approvals.added': 'Godkjenner lagt til',
      'govDocs.approvals.addError': 'Kunne ikke legge til godkjenner',
      'govDocs.approvals.addApprover': 'Legg til godkjenner',
      'govDocs.approvals.addBtn': 'Legg til',
      'govDocs.approvals.approverName': 'Navn',
      'govDocs.approvals.approverEmail': 'E-post',
      'govDocs.approvals.comment': 'Kommentar (valgfritt)',
      'govDocs.approvals.approve': 'Godkjenn',
      'govDocs.approvals.reject': 'Avvis',
      'govDocs.approvals.approvedSuccess': 'Godkjent',
      'govDocs.approvals.rejectedSuccess': 'Avvist',
      'govDocs.approvals.respondError': 'Kunne ikke svare',
      'govDocs.approvals.submitForReview': 'Send til gjennomgang',
      'govDocs.approvals.submitted': 'Dokument sendt til gjennomgang',
      'govDocs.approvals.submitError': 'Kunne ikke sende',
      'govDocs.approvals.allApproved': 'Alle godkjennere har godkjent — dokumentstatus satt til Godkjent',
      'govDocs.approvals.status.pending': 'Venter',
      'govDocs.approvals.status.approved': 'Godkjent',
      'govDocs.approvals.status.rejected': 'Avvist',

      // Governing Documents - Read Confirmations
      'govDocs.readConfirm.title': 'Lesebekreftelser',
      'govDocs.readConfirm.count': '{{count}} bekreftelse(r) for v{{version}}',
      'govDocs.readConfirm.markAsRead': 'Bekreft lest',
      'govDocs.readConfirm.confirmed': 'Lesing bekreftet',
      'govDocs.readConfirm.error': 'Kunne ikke bekrefte',
      'govDocs.readConfirm.alreadyConfirmed': 'Du har bekreftet at du har lest denne versjonen',

      // Governing Documents - Contract Links
      'govDocs.contracts.title': 'Tilknyttede kontrakter',
      'govDocs.contracts.link': 'Tilknytt',
      'govDocs.contracts.linked': 'Kontrakt tilknyttet',
      'govDocs.contracts.linkError': 'Kunne ikke tilknytte kontrakt',
      'govDocs.contracts.unlinked': 'Kontrakt fjernet',
      'govDocs.contracts.unlinkError': 'Kunne ikke fjerne kontrakt',
      'govDocs.contracts.searchPlaceholder': 'Søk kontrakter etter leverandør...',
      'govDocs.contracts.empty': 'Ingen tilknyttede kontrakter.',
    }
  }
}

// Revenue tracking translations - add to common section
// revenue.title: 'Revenue Overview'
// revenue.revenueTrend: 'Revenue Trend'
// revenue.paid: 'Paid'
// revenue.pending: 'Pending'
// revenue.overdue: 'Overdue'
// revenue.partial: 'Partial'
// revenue.totalRevenue: 'Total Revenue'
// revenue.collected: 'Collected'
// revenue.outstanding: 'Outstanding'
// revenue.invoiceCount: '{{count}} invoices'
// revenue.invoices: 'invoices'
// revenue.showInvoices: 'Show All Invoices'
// revenue.hideInvoices: 'Hide Invoices'
// revenue.actualRevenue: 'Actual Revenue'
// revenue.expectedIncome: 'Expected Income'
// revenue.noRevenueData: 'No revenue data for income contracts'
